webpackJsonp([50],{

/***/ "+HI+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+IjS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerQuery_vue__ = __webpack_require__("g6N2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ec1bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerQuery_vue__ = __webpack_require__("F7Xg");
function injectStyle (ssrContext) {
  __webpack_require__("A4R5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerQuery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ec1bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerQuery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+dzg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/licence_show_type_single.9f63757.png";

/***/ }),

/***/ "/2eX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/z1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subComponents_sdkUpload__ = __webpack_require__("uhd8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "set-login-allowed",
    components: {
        upload: __WEBPACK_IMPORTED_MODULE_2__subComponents_sdkUpload__["a" /* default */]
    },
    data: function data() {
        return {
            isSdkVersion5_6: true,
            submitRechargeAllowedDisabled: false,
            version: "",
            platform: "",
            activeUrl: "",
            params: {
                payment: {
                    submit_recharge_allowed: "",
                    filter_channel_with_geo_country: "",
                    charge_button_allowed: "",
                    quick_charge_google_allowed: "",
                    quick_charge_thirdparty_allowed: "",
                    manual_charge_google_allowed: "",
                    manual_charge_thirdparty_allowed: "",
                    charge_thirdparty_page_style: "",
                    game_payment_method_image: "",
                    apf_enabled: false,
                    apf_safe_mode: false,
                    apf_ux_style: 'bottom-drawer',
                    apf_min_history_topup: 0,
                    apf_min_topup_times: 0,
                    apf_external_webview_url: ''
                },
                step: "payment"
            },
            styleDialogVisible: false
        };
    },

    props: ["isDetail", "isCopy", "labelWidth"],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(["$helper", "$lodash"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])("sdkReleasesEdit", ["gameVersion", "packageList", "packageStoreList", "sdkVersion", "data"]), {
        isSave: function isSave() {
            return this.platform === "ANDROID" && this.version < 7.07 || this.platform === "H5" || this.platform === "WINDOWS" ? "完成" : "下一步";
        }
    }),
    watch: {
        "data.payment": function dataPayment() {
            this.params.payment = this.$lodash.cloneDeep(this.data.payment);
            this.params.step = "payment";
            console.log(this.params.payment);
            if (this.params.payment.charge_button_allowed == false) {
                this.submitRechargeAllowedDisabled = true;
            }
            if (this.params.payment.quick_charge_thirdparty_allowed == false) {
                this.submitRechargeAllowedDisabled = true;
            }
        },
        "data.query": function dataQuery(value) {
            var version = "";
            this.sdkVersion.forEach(function (item) {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            });
            var versionStr = version.substr(0, 2);
            console.log(versionStr);
            if (!["6.", "5."].includes(versionStr)) {
                this.isSdkVersion5_6 = false;
            } else {
                this.isSdkVersion5_6 = true;
            }
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
        }
    },
    methods: {
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this.$emit("submit", _this.params, _this.isSave === "完成" ? "save" : "");
                }
            });
        },
        changeChargeButtonAllowed: function changeChargeButtonAllowed(allowed) {
            if (allowed === false) {
                this.params.payment.quick_charge_google_allowed = false;
                this.params.payment.quick_charge_thirdparty_allowed = false;
                this.changeThirdpartyAllowed(false);
            }
        },
        changeThirdpartyAllowed: function changeThirdpartyAllowed(allowed) {
            if (allowed === false) {
                this.params.payment.submit_recharge_allowed = false;
                this.submitRechargeAllowedDisabled = true;
            } else {
                this.submitRechargeAllowedDisabled = false;
            }
        },
        handlerPreview: function handlerPreview(key) {
            this.activeUrl = this.currentUrl(key);
            this.styleDialogVisible = true;
        },
        currentUrl: function currentUrl(key) {
            var urls = {
                pay_page_sample_and_size: __webpack_require__("a5BF"),
                third_pay_page_default_style: __webpack_require__("L8+Q"),
                third_pay_page_google_style: __webpack_require__("FTdV")
            };
            return urls[key];
        },
        justifyVersion: function justifyVersion(version) {
            var versionarr = version.split(".");
            var version_convert = "";
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            } else {
                version_convert = version;
            }
            return version_convert;
        },
        changeChargeThirdpartyPageStyle: function changeChargeThirdpartyPageStyle() {}
    },
    created: function created() {
        this.platform = this.$helper.helper.getParamers("platform");
    }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0ZdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_server_vue__ = __webpack_require__("xtGW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dc62ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_server_vue__ = __webpack_require__("ozhi");
function injectStyle (ssrContext) {
  __webpack_require__("EMK4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57dc62ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_server_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dc62ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_server_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0h8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "0nXr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "13Nv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    iosConfigList: [],
    androidConfigList: [],
    h5ConfigList: [],
    windowsConfigList: [],
    iosSdkVersion: [],
    androidSdkVersion: [],
    h5SdkVersion: [],
    windowsSdkVersion: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_SDK_VERSION: function GET_SDK_VERSION(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {
            platform: args.platform
        }).then(function (res) {
            data = res.data.sdk_versions;
            if (args.platform === 'IOS') {
                commit('_iosSdkVersion', data);
            } else if (args.platform === 'H5') {
                commit('_h5SdkVersion', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsSdkVersion', data);
            } else {
                commit('_androidSdkVersion', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_CONFIG_LIST: function GET_CONFIG_LIST(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/plans', {
            platform: args.platform,
            sdk_version_id: args.sdk_version_id
        }).then(function (res) {
            data = res.data.plans;
            if (args.platform === 'IOS') {
                commit('_iosConfigList', data);
            } else if (args.platform === 'H5') {
                commit('_h5ConfigList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsConfigList', data);
            } else {
                commit('_androidCongfigList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    DELETE_ROW: function DELETE_ROW(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.delete('/games/' + gameCode + '/plans/' + args.plan_id, { platform: args.platform }).then(function (res) {
            data = res.data.deleted;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '删除成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '删除失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist');
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _iosConfigList: function _iosConfigList(state, args) {
        state.iosConfigList = args;
        console.log('_iosConfigList=', state.iosConfigList);
    },
    _androidCongfigList: function _androidCongfigList(state, args) {
        state.androidConfigList = args;
        console.log('_androidCongfigList=', state.androidConfigList);
    },
    _h5ConfigList: function _h5ConfigList(state, args) {
        state.h5ConfigList = args;
        console.log('_h5CongfigList=', state.h5ConfigList);
    },
    _windowsConfigList: function _windowsConfigList(state, args) {
        state.windowsConfigList = args;
        console.log('_windowsCongfigList=', state.windowsConfigList);
    },
    _iosSdkVersion: function _iosSdkVersion(state, args) {
        state.iosSdkVersion = args;
        console.log(state.iosSdkVersion);
    },
    _androidSdkVersion: function _androidSdkVersion(state, args) {
        state.androidSdkVersion = args;
        console.log(state.androidSdkVersion);
    },
    _h5SdkVersion: function _h5SdkVersion(state, args) {
        state.h5SdkVersion = args;
        console.log(state.h5SdkVersion);
    },
    _windowsSdkVersion: function _windowsSdkVersion(state, args) {
        state.windowsSdkVersion = args;
        console.log(state.windowsSdkVersion);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "35re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"详情","visible":_vm.dialogFormVisible,"width":"650px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"close":_vm.handleDialog}},[_c('el-table',{attrs:{"data":_vm.rander,"border":"","show-header":false}},[_c('el-table-column',{attrs:{"prop":"key","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(['通用码', '礼包ID'].includes(row.key))?_c('div',[_vm._v("\n                    "+_vm._s(row.value)+"\n                    "),(row.value)?_c('i',{staticClass:"el-icon-document-copy",on:{"click":function($event){return _vm.doCopy(row.value)}}}):_vm._e()]):_c('div',[_vm._v(_vm._s(row.value))])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3DF/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3E/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdk-dimension-container"},[_c('el-form',{ref:"form",attrs:{"model":_vm.params,"rules":_vm.paramsRules,"label-width":_vm.labelWidth}},[_c('el-form-item',{attrs:{"label":"游戏版本：","prop":"game_version_id"}},[_c('el-select',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","placeholder":"游戏版本","disabled":_vm.selDisable},model:{value:(_vm.params.game_version_id),callback:function ($$v) {_vm.$set(_vm.params, "game_version_id", $$v)},expression:"params.game_version_id"}},_vm._l((_vm.gameVersion),function(item){return _c('el-option',{key:item.game_version_id,attrs:{"label":item.version,"value":item.game_version_id}})}),1),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"small","icon":"el-icon-plus","disabled":_vm.selDisable},on:{"click":function($event){_vm.gameVersionDialogFormVisible = true}}},[_vm._v("新增\n                ")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"包名：","prop":"package_id"}},[_c('el-select',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","placeholder":"包名","disabled":_vm.selDisable},on:{"change":_vm.handlerPackage},model:{value:(_vm.params.package_id),callback:function ($$v) {_vm.$set(_vm.params, "package_id", $$v)},expression:"params.package_id"}},_vm._l((_vm.packageList),function(item){return _c('el-option',{key:item.package_name,attrs:{"label":item.package_name,"value":item.package_id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发行渠道：","prop":"store_id"}},[_c('el-select',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","placeholder":"发行渠道","disabled":_vm.selDisable},model:{value:(_vm.params.store_id),callback:function ($$v) {_vm.$set(_vm.params, "store_id", $$v)},expression:"params.store_id"}},_vm._l((_vm.packageStoreList),function(item){return _c('el-option',{key:item.store_id,attrs:{"label":item.store_name,"value":item.store_id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"SDK版本：","prop":"sdk_version_id"}},[_c('el-select',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","placeholder":"SDK版本","disabled":_vm.selDisable},model:{value:(_vm.params.sdk_version_id),callback:function ($$v) {_vm.$set(_vm.params, "sdk_version_id", $$v)},expression:"params.sdk_version_id"}},_vm._l((_vm.sdkVersion),function(item){return _c('el-option',{key:item.sdk_version_id,attrs:{"label":item.version,"value":item.sdk_version_id}})}),1),_vm._v(" "),(this.operate_type !== '' && !this.releasePlan.length)?_c('span',{staticClass:"allow-auto-process"},[_vm._v("\n                    经系统判断，当前版本未配置"),_c('a',{attrs:{"href":_vm.configUrl(),"target":"_blank"}},[_vm._v("SDK配置文件")]),_vm._v("！\n                ")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',[(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small","disabled":!this.releasePlan.length},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"el-dialog__body_self",attrs:{"title":"新增版本","visible":_vm.gameVersionDialogFormVisible,"width":"600px"},on:{"update:visible":function($event){_vm.gameVersionDialogFormVisible=$event}}},[_c('el-form',{attrs:{"model":_vm.gameVersionForm,"labelWidth":"80px"}},[_c('el-form-item',{attrs:{"label":"游戏版本"}},[_c('el-input',{attrs:{"size":"small","autocomplete":"off"},model:{value:(_vm.gameVersionForm.game_version),callback:function ($$v) {_vm.$set(_vm.gameVersionForm, "game_version", $$v)},expression:"gameVersionForm.game_version"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.gameVersionDialogFormVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){_vm.gameVersionDialogFormVisible = false;
                        _vm.gameVersionNew();}}},[_vm._v("\n                    确 定\n                ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Mkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);




var handle = {
    inArrayRole: function inArrayRole(key, rootState) {
        var role = rootState.$roles;
        var len = role.length;
        var status = false;
        for (var i = 0; i < len; i++) {
            if (role[i] === key) {
                status = true;
            }
        }
        return status;
    }
};

var mutations = {
    /**当前页面**/
    CHANGE_PAGE: function CHANGE_PAGE(state, page) {
        state.$page = page;
    },


    /**启用loading**/
    LOADING: function LOADING(state, args) {
        state.$loading = args;
    },


    /**
     * 无权限访问页面处理
     * @constructor
     */
    NO_ACCESS_PAGE: function NO_ACCESS_PAGE(state, _ref) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState,
            args = _ref.args,
            status = _ref.status,
            selectPlaceholder = _ref.selectPlaceholder;

        state.$isaccess = status;
        // state.$activeGameCode = '';
        //state.$activeGameInfo = [];
        state.$selectDisabledStatus = !state.$gameList.length;
        state.$selectPlaceholder = selectPlaceholder !== undefined ? selectPlaceholder : state.$selectDisabledStatus ? "用户无游戏权限" : state.$selectPlaceholder;
    },


    /**内容区域LOADING**/
    PRIVATE_LOADING: function PRIVATE_LOADING(state, args) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).resize(function () {
            var breadcrumb = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#page-main-breadcrumb");
            var content = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#page-main-content");
            var loading = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#loading-private");
            var window_height = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).height() - __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".el-header").outerHeight();
            var height = breadcrumb.height() + content.outerHeight();
            if (height < window_height) {
                height = window_height;
            }
            loading.height(height);
        });

        if (args) {
            var timeout = function timeout() {
                setTimeout(function () {
                    var breadcrumb = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#page-main-breadcrumb");
                    var content = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#page-main-content");
                    var loading = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#loading-private");
                    var window_height = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).height() - __WEBPACK_IMPORTED_MODULE_1_jquery___default()(".el-header").outerHeight();
                    //console.log(window_height);
                    if (breadcrumb.length === 0) {
                        timeout();
                    } else {
                        //console.log(breadcrumb.height() + content.outerHeight());
                        var height = breadcrumb.height() + content.outerHeight();
                        //console.log(window_height, height);
                        if (height < window_height) {
                            height = window_height;
                        }
                        loading.height(height);
                        state.$loadingPrivate = args;
                    }
                }, 50);
            };
            timeout();
        } else {
            state.$loadingPrivate = args;
        }
    },


    /***
     * 设置内容区域高度
     * @constructor
     */
    SET_CONTENT_HEIGHT: function SET_CONTENT_HEIGHT(state, height) {
        state.$iframeHeight = height;
    },
    _updateJumpProjectType: function _updateJumpProjectType(state, args) {
        state.$jumpProjectTypeRoute1 = args.projectTypeRoute1;
        state.$jumpProjectTypeRoute2 = args.projectTypeRoute2;
        //console.log(state.$jumpProjectTypeRoute1, state.$jumpProjectTypeRoute2)
    },
    _updateLoading: function _updateLoading(state, args) {
        state.$loading = args;
    },
    _updateAccessStatus: function _updateAccessStatus(state, status) {
        state.$isaccess = status;
    },
    _updateActiveGameInfo: function _updateActiveGameInfo(state, args) {
        state.$activeGameInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, args.gameinfo);
        if (args.type) {
            args.rootState.$helper.localStorage.remove("odp_gameList");
        }
    },
    updateAppInfo: function updateAppInfo(state, res) {
        state.$gameList = res["gamelist"]["data"]["games"];
        state.$userInfo = res["gamelist"]["data"]["user"];
        state.$gameAdminList = res["gamelist"]["data"]["games_admin"];
    },
    updateUserRoles: function updateUserRoles(state, args) {
        var token = args.rootState.$helper.cookie.get(args.rootState.$config.userLoginAccessTokenKey);
        var user = JSON.parse(args.rootState.$base64.decode(token.split(".")[1]));

        if (Array.isArray(user["params"]["roles"])) {
            user["params"]["roles"] = user["params"]["roles"].map(function (item) {
                return item.replace('ODP5PANELCHINA', 'ODP5');
            });
        }
        state.$roles = user["params"]["roles"];

        /**设置管理**/
        if (handle.inArrayRole("ROLE_APP_ODP5_SYS_ADMIN", args.rootState)) {
            state.$isAdmin = 1;
        }
    },
    updateAppGameCode: function updateAppGameCode(state, code) {
        if (!code) {
            code = state.$helper.helper.getParamers("game_code");
        }
        var codes = state.$gameList.map(function (v) {
            return v.game_code;
        });
        /**用户第一次进浏览器没有选择游戏code，使用用户返回游戏的第一个游戏**/
        if (!code) {
            state.$activeGameCode = codes[0];
        } else if (codes.indexOf(code) === -1) {
            state.$activeGameCode = codes[0];
        } else {
            state.$activeGameCode = code;
        }
        var urlParams = state.$helper.helper.getUrlParams();
        urlParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, urlParams, {
            game_code: state.$activeGameCode
        });

        window.history.pushState(null, null, "?" + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(urlParams));
        if (state.$gameAdminList.indexOf(state.$activeGameCode) >= 0) {
            state.$isGameAdmin = 1;
        } else {
            state.$isGameAdmin = 0;
        }
    },
    updateProjectType: function updateProjectType(state, type) {
        // let type = state.$helper.cookie.get('odp-projectType');
        // if (!type) {
        //     type = state.$jumpProjectTypeRoute1 ? 1 : 2;
        // }
        state.$projectType = parseInt(type);
    },
    _updateMune: function _updateMune(state, mune) {
        state.$routerMaps = mune;
    },
    _updateSaveVueObject: function _updateSaveVueObject(state, $vue) {
        state.$vue = $vue;
    },
    _setTitle: function _setTitle(state, pageName) {
        state.$title = state.$s_title + (" - " + pageName);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "3myU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectUsers_vue__ = __webpack_require__("mdp2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0026d5aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectUsers_vue__ = __webpack_require__("Ng4a");
function injectStyle (ssrContext) {
  __webpack_require__("jYsH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0026d5aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0026d5aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3q9L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/login-phone.fb3f549.png";

/***/ }),

/***/ "3ySD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_error__ = __webpack_require__("PmJb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_message__ = __webpack_require__("Kcpt");



var actions = {
    APP_INIT: function APP_INIT(_ref, callback) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;


        // if(rootState.$helper.helper.getParamers('game_code')){
        //     rootState.$helper.cookie.set('odp-selectedGameCode', rootState.$helper.helper.getParamers('game_code'));
        // }

        /**设置页面Title**/
        if (rootState.$page !== 'index') {
            dispatch('SET_TITLE');
        }

        /**localStorage取游戏列表*/
        var gameList = rootState.$helper.localStorage.get('odp_gameList');
        if (gameList) {
            new rootState.$helper.loginHandle({ state: state, commit: commit, dispatch: dispatch, rootState: rootState }, gameList, callback);
            return;
        }

        /**远端取游戏列表**/
        var options = [{ url: rootState.$config.api.app.get_game_list, method: 'get', key: 'gamelist', data: { isGameCode: false } }];

        rootState.$helper.request.all(options, function (res) {
            console.log('APP_INIT=>', res);
            /**本地存储**/
            rootState.$helper.localStorage.set('odp_gameList', res, 0.5);

            /**调用用户登陆统一处理**/
            new rootState.$helper.loginHandle({ state: state, commit: commit, dispatch: dispatch, rootState: rootState }, res, callback);
        }, function (res) {
            /**无权限返回内容**/
            if (res['response'] && res['response']['data'] && res['response']['data']['mess']) {
                var message = res['response']['data']['mess'];
                if (message === 'No permission to access this url') {
                    /**已在无权限提示页面不再跳转**/
                    if (rootState.$page !== 'noAccess') {
                        rootState.$route('noAccess');
                    } else {
                        var data = {};
                        data['gamelist'] = {};
                        data['gamelist']['data'] = {};
                        data['gamelist']['data']['games'] = [];
                        data['gamelist']['data']['games_admin'] = [];
                        data['gamelist']['data']['user'] = {};
                        data['gamelist']['data']['user']['email'] = '无权限访客';

                        /**设置用户信息和游戏信息**/
                        commit('updateAppInfo', data);

                        /**设置用户权限对象**/
                        commit('updateUserRoles', { res: data, rootState: rootState });

                        /**设置用户无权限对象**/
                        commit('NO_ACCESS_PAGE', { args: data, status: false, state: state, commit: commit, dispatch: dispatch, rootState: rootState });
                        callback();
                    }
                    return;
                }
            }

            /**用户登陆验证**/
            if (res['response'] && res['response']['data'] && res['response']['data']['exception'] && res['response']['data']['exception']['message']) {
                var _message = res['response']['data']['exception']['message'];
                __WEBPACK_IMPORTED_MODULE_0__helper_error__["a" /* default */].noAccessPage(_message, rootState);
            }
        });
    },
    GET_ACTIVE_GAME_INFO: function GET_ACTIVE_GAME_INFO(_ref2, callback) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var url = rootState.$config.api.app.get_game_info;
        rootState.$helper.request.get(url).then(function (res) {
            dispatch('UPDATE_ACTIVE_GAME_INFO', {
                res: res['data']['games'][0],
                type: callback === null ? true : false
            });
            if (typeof callback === 'function') callback(res);
        }).catch(function (res) {
            console.log(res);
        });
    },


    /***
     * 更新游戏信息
     * @constructor
     */
    UPDATE_ACTIVE_GAME_INFO: function UPDATE_ACTIVE_GAME_INFO(_ref3, _ref4) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;
        var res = _ref4.res,
            type = _ref4.type;

        commit('_updateActiveGameInfo', { gameinfo: res, rootState: rootState, type: type });
    },
    ACCESS_STATUS: function ACCESS_STATUS(_ref5, status) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        commit('_updateAccessStatus', status);
    },


    /**
     * 更新$loading状态
     * @constructor
     */
    LOADING: function LOADING(_ref6, args) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;

        commit('_updateLoading', args);
    },


    /**
     * 存储$vue
     * @constructor
     */
    SAVE_VUE_OBJECT: function SAVE_VUE_OBJECT(_ref7, $vue) {
        var state = _ref7.state,
            commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            rootState = _ref7.rootState;

        commit('_updateSaveVueObject', $vue);
    },


    /**
     * 请求错误统一处理
     * @constructor
     */
    ERROR_HANDLE: function ERROR_HANDLE(_ref8, e) {
        var state = _ref8.state,
            commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            rootState = _ref8.rootState;

        __WEBPACK_IMPORTED_MODULE_0__helper_error__["a" /* default */].error(e, { state: state, commit: commit, dispatch: dispatch, rootState: rootState });
    },


    /**
     * 提示
     * @constructor
     * arge.message 提示文案
     * arge.callback 关闭回调用方法
     * args.reload 关闭回调用方法 默认false
     */
    MESSAGE_HANDLE: function MESSAGE_HANDLE(_ref9, arge) {
        var state = _ref9.state,
            commit = _ref9.commit,
            dispatch = _ref9.dispatch,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_1__helper_message__["a" /* default */].message(arge, { state: state, commit: commit, dispatch: dispatch, rootState: rootState });
    },


    /**
     * 提示
     * @constructor
     * args.message 弹窗层提示
     * args.callback 关闭回调用方法
     * args.reload 关闭回调用方法 默认false
     */
    ALERT_HANDLE: function ALERT_HANDLE(_ref10, args) {
        var state = _ref10.state,
            commit = _ref10.commit,
            dispatch = _ref10.dispatch,
            rootState = _ref10.rootState;

        __WEBPACK_IMPORTED_MODULE_1__helper_message__["a" /* default */].alert(args, { state: state, commit: commit, dispatch: dispatch, rootState: rootState });
    },


    /**
     * 设置页面
     * @constructor
     */
    SET_TITLE: function SET_TITLE(_ref11) {
        var state = _ref11.state,
            commit = _ref11.commit,
            dispatch = _ref11.dispatch,
            rootState = _ref11.rootState;

        var arr = state.$page.split('/');
        var title = '';
        if (arr.length > 1) {
            title = rootState.$routerMapsDefined[arr[0]]['children'][arr[1]]['title'];
        } else {
            title = rootState.$routerMapsDefined[arr[0]]['title'];
        }
        commit('_setTitle', title);
    },


    /**
     * 用户退出
     * @constructor
     */
    LOGOUT: function LOGOUT(_ref12, args) {
        var state = _ref12.state,
            commit = _ref12.commit,
            dispatch = _ref12.dispatch,
            rootState = _ref12.rootState;

        alert('LOGOUT');
    }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "47f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'push-scheme',
    props: ['isDetail', 'isCopy', 'activeNumber'],
    data: function data() {
        var validatorHttp = function validatorHttp(rule, value, callback) {
            var reg = /^https:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
            if (!reg.test(value) && value) {
                callback(new Error("请输入https://开头地址U"));
            } else {
                callback();
            }
        };
        return {
            languageCurrentName: 'en',
            currentModelName: 'android',
            pushContainerForm: {
                title: '',
                content: '',
                imgurl: ''
            },
            pushContainerFormRules: {
                title: [{
                    required: true, message: '请输入推送标题', trigger: 'blur'
                }],
                content: [{
                    required: true, message: '请输入推送文案', trigger: 'blur'
                }],
                imgurl: [{
                    validator: validatorHttp
                }]
            },
            isAll: true,
            langs: [],
            validatorHttp: validatorHttp
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('pushPushPlanOperate', ['data'])),
    watch: {
        data: {
            handler: function handler() {
                this.init();
            },

            immediate: true
        },
        activeNumber: function activeNumber(num) {
            if (num === 2) {
                this.init();
            }
        }
    },
    methods: {
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs['form'].validate(function (valid, obj) {
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).length && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj)[0].indexOf('.') > -1) {
                    _this.languageCurrentName = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj)[0].split('.')[0];
                }
                if (valid) {
                    _this.$emit('submit', {
                        contents: _this.pushContainerForm
                    }, 2);
                }
            });
        },
        init: function init() {
            if (typeof this.data.conditions.lang !== 'undefined' && typeof this.data.conditions.lang === 'string') {
                this.langs = this.data.conditions.lang.split(',');
            } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.data.conditions.lang)) {
                this.langs = this.data.conditions.lang;
            }
            this.initLanguageOptionParams();
        },
        initLanguageOptionParams: function initLanguageOptionParams() {
            var _this2 = this;

            this.pushContainerForm = {};
            if (Array.isArray(this.langs) && this.langs.length) {
                this.langs.map(function (item) {
                    if (_this2.data.contents[item]) {
                        _this2.pushContainerForm[item] = _this2.data.contents[item];
                    } else {
                        _this2.$set(_this2.pushContainerForm, item, {
                            title: '',
                            content: '',
                            imgurl: ''
                        });
                    }
                });
                this.languageCurrentName = this.langs[0];
                this.isAll = false;
            } else {
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data.contents).length) {
                    this.pushContainerForm = this.data.contents;
                } else {
                    this.pushContainerForm = {
                        title: '',
                        content: '',
                        imgurl: ''
                    };
                }
                this.isAll = true;
            }
        }
    }
});

/***/ }),

/***/ "4XHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/**
 * Created by shiyonggao on 2019/2/25.
 */



/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    pushTopicGroupList: [],
    planSchedulesList: [],
    topicGroupId: ''
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_PUSH_TOPIC_GROUP_LIST: function GET_PUSH_TOPIC_GROUP_LIST(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;


        var push_games_code_push_topic_group_url = rootState.$config.api.push_games_code_push_topic_group_url;
        push_games_code_push_topic_group_url = push_games_code_push_topic_group_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.get(push_games_code_push_topic_group_url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ limit: 1000 }, args)).then(function (res) {
            commit('_updatePushTopicGroupList', res.data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PLAN_SCHEDULES_LIST: function GET_PLAN_SCHEDULES_LIST(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;


        var push_schedules_list_url = rootState.$config.api.push_schedules_list_url;
        push_schedules_list_url = push_schedules_list_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.get(push_schedules_list_url, args).then(function (res) {
            commit('_updatePlanSchedulesList', res.data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    DELETE_SCHEDULES_BY_ID: function DELETE_SCHEDULES_BY_ID(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;


        var push_delete_edit_schedules_by_id_url = rootState.$config.api.push_delete_edit_schedules_by_id_url;
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{game_code}', args.game_code);
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{schedule_id}', args.schedule_id);

        rootState.$helper.request.delete(push_delete_edit_schedules_by_id_url, args).then(function (res) {
            dispatch('GET_PLAN_SCHEDULES_LIST', { game_code: args.game_code, topic_group_id: args.topic_group_id, status: 5 });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    EDIT_PLAN_SCHEDULES: function EDIT_PLAN_SCHEDULES(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;


        var push_delete_edit_schedules_by_id_url = rootState.$config.api.push_delete_edit_schedules_by_id_url;
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{game_code}', args.game_code);
        push_delete_edit_schedules_by_id_url = push_delete_edit_schedules_by_id_url.replace('{schedule_id}', args.schedule_id);

        rootState.$helper.request.put(push_delete_edit_schedules_by_id_url, args).then(function (res) {
            dispatch('GET_PLAN_SCHEDULES_LIST', { game_code: args.game_code, topic_group_id: args.topic_group_id, status: 5 });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updatePushTopicGroupList: function _updatePushTopicGroupList(state, args) {
        state.pushTopicGroupList = args.topic_groups;
    },
    _updatePlanSchedulesList: function _updatePlanSchedulesList(state, args) {
        state.planSchedulesList = args.schedules;
    },
    _updateTopicGroupId: function _updateTopicGroupId(state, args) {
        state.topicGroupId = args;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "4chI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_noIdentified_vue__ = __webpack_require__("iUc2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df12b75_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_noIdentified_vue__ = __webpack_require__("Eeq5");
function injectStyle (ssrContext) {
  __webpack_require__("OQYA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0df12b75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_noIdentified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df12b75_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_noIdentified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5phe":
/***/ (function(module, exports) {

module.exports = {"web_title":"我的网站"}

/***/ }),

/***/ "5u7H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/account-bind.37c51fc.png";

/***/ }),

/***/ "60zE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64__ = __webpack_require__("xrTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helper_autoload__ = __webpack_require__("BTzX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_router__ = __webpack_require__("p0NN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__("3ySD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutations__ = __webpack_require__("3Mkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getters__ = __webpack_require__("TZaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_autoload__ = __webpack_require__("FEZE");

/**
 * Created by shiyonggao on 2019/1/28.
 */

var MD5 = __webpack_require__("eCz2");











var Config = __webpack_require__("wFsZ");






var locale = "zh-CN";

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
    locale: locale,
    messages: __webpack_require__("6iS0")
});

/**
 * md5算法
 * @param str
 * @param hex
 * @returns {*}
 */
var md5Fn = function md5Fn(str) {
    var hex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hex";

    return new MD5()["update"](str)["digest"](hex);
};

var routeFn = function routeFn(routeName, data) {
    var blank = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var urlParams = __WEBPACK_IMPORTED_MODULE_7__helper_autoload__["a" /* default */].helper.getUrlParams();
    data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, urlParams, data);
    __WEBPACK_IMPORTED_MODULE_7__helper_autoload__["a" /* default */].helper.route(routeName, data, blank);
};

var getNoRoleRoute = function getNoRoleRoute() {
    var temp = {};
    for (var key in __WEBPACK_IMPORTED_MODULE_9__config_router__["a" /* default */]) {
        if (!__WEBPACK_IMPORTED_MODULE_9__config_router__["a" /* default */][key]["role"]) {
            temp[key] = __WEBPACK_IMPORTED_MODULE_9__config_router__["a" /* default */][key];
        }
    }
    return temp;
};
console.log(Config, 64);
var state = {
    $i18n: i18n,
    $md5: md5Fn,
    $base64: __WEBPACK_IMPORTED_MODULE_4_js_base64__["Base64"],
    $page: "index",
    $config: Config,
    $lodash: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a,
    $jquery: __WEBPACK_IMPORTED_MODULE_6_jquery___default.a,
    $helper: __WEBPACK_IMPORTED_MODULE_7__helper_autoload__["a" /* default */],
    $moment: __WEBPACK_IMPORTED_MODULE_8_moment___default.a,
    $loading: true,
    $vue: null,
    $s_title: "ODP5发行平台",
    $title: "ODP5发行平台 欢迎您！",
    $route: routeFn,
    $routerMaps: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, getNoRoleRoute()),
    $routerMapsDefined: __WEBPACK_IMPORTED_MODULE_9__config_router__["a" /* default */],
    $gameList: [],
    $gameAdminList: [],
    $activeGameCode: "lotr",
    $activeGameInfo: {},
    $userInfo: "",
    /** 1，发行配置   2，业务发行 **/
    $projectType: 1,
    $loadingPrivate: false,
    $isaccess: true,
    /** 无权限禁用选择切换功能 **/
    $selectDisabledStatus: false,
    $selectPlaceholder: "请选择",
    $iframeHeight: 400,
    $roles: [],
    $isAdmin: 0,
    $isGameAdmin: 0,
    $jumpProjectTypeRoute1: "",
    $jumpProjectTypeRoute2: "",
    $showProjectTypeRoute2: true,
    $showProjectTypeRoute1: true
};

var actions = __WEBPACK_IMPORTED_MODULE_11__actions__["a" /* default */];
var mutations = __WEBPACK_IMPORTED_MODULE_12__mutations__["a" /* default */];
var getters = __WEBPACK_IMPORTED_MODULE_13__getters__["a" /* default */];
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* default */].Store({
    modules: __WEBPACK_IMPORTED_MODULE_14__modules_autoload__["a" /* default */],
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/* harmony default export */ __webpack_exports__["default"] = (store);

/***/ }),

/***/ "61bN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6BbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sub-header",
    data: function data() {
        return {
            options: [],
            gameCode: "",
            activeProjectType: 1,
            activeIndex: "system/sdkVersion",
            showProjectTypeRoute1: true,
            showProjectTypeRoute2: true
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(["$md5", "$base64", "$page", "$lodash", "$helper", "$route", "$routerMaps", "$gameList", "$activeGameCode", "$activeGameInfo", "$projectType", "$config", "$isaccess", "$selectDisabledStatus", "$selectPlaceholder", "$userInfo", "$isAdmin", "$isGameAdmin", "$gameAdminList", "$showProjectTypeRoute2", "$showProjectTypeRoute1", "$roles"])),
    watch: {},
    created: function created() {
        this.options = this.$gameList;
        this.gameCode = this.$activeGameCode;
        this.activeProjectType = this.$projectType;
        // let projectTypehide = this.$helper.cookie.get('odp-projectType-hide');
        // if(projectTypehide) {
        //     projectTypehide = parseInt(projectTypehide);
        //     if(projectTypehide === 1)  {
        //         this.showProjectTypeRoute1 = false;
        //     }
        //     if(projectTypehide === 2) {
        //         this.showProjectTypeRoute2 = false;
        //     }
        // }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["LOADING", "SAVE_VUE_OBJECT", "LOGOUT"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(["updateAppGameCode", "LOADING"]), {
        subMenuSelected: function subMenuSelected(key, keyPath) {
            this.$route(key.toLocaleLowerCase());
        },


        /**
         * 切换发行配置和业务管理页面
         * @param path
         * @param num
         */
        projectTypeFn: function projectTypeFn(path, num) {
            this.$helper.cookie.set("odp-projectType", num);
            this.$route(path);
        },
        selectFn: function selectFn(gamecode) {
            // this.$helper.cookie.set('odp-selectedGameCode', gamecode);
            this.$helper.cookie.remove("odp-projectType");
            this.updateAppGameCode(gamecode);
            this.LOADING(true);
            this.$route(this.$page);
        },
        visibleChange: function visibleChange(visible) {
            if (visible) {
                this.filterGameList();
            }
        },
        filterGameList: function filterGameList(val) {
            if (val) {
                //val存在
                var pinyin = this.$helper.pinyin.all(val);
                this.options = this.$gameList.filter(function (item) {
                    if (item.name.indexOf(val) !== -1 || item["game_code_jianpin"].indexOf(pinyin.frist) !== -1 || item["game_code_quanpin"].indexOf(pinyin.full) !== -1 || item["game_code"].indexOf(pinyin.full) !== -1) {
                        return true;
                    }
                });
            } else {
                //val为空时，还原数组
                this.options = this.$gameList;
            }
        }
    })
});

/***/ }),

/***/ "6Gs/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sub-game-apiinfo',
    props: ['gameApiInfo', 'ind', 'regionName'],
    components: {},
    data: function data() {
        return {
            serverListUrl: '',
            roleUrl: '',
            registerUrl: '',
            onlineUrl: '',
            baseInfo: {}
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment', '$route']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('gameConfigCommonInfo', [])),

    created: function created() {
        this.serverListUrl = this.gameApiInfo.server_list;
        this.roleUrl = this.gameApiInfo.role_info;
        this.registerUrl = this.gameApiInfo.register_num;
        this.onlineUrl = this.gameApiInfo.online_num;
    },


    watch: {
        serverListUrl: function serverListUrl() {
            this.change();
        },
        roleUrl: function roleUrl() {
            this.change();
        },
        registerUrl: function registerUrl() {
            this.change();
        },
        onlineUrl: function onlineUrl() {
            this.change();
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('gameConfigCommonInfo', ['SET_API_CONFIG']), {
        change: function change() {
            this.baseInfo = {
                key: this.ind,
                region_name: this.regionName,
                server_list: this.serverListUrl,
                role_info: this.roleUrl,
                register_num: this.registerUrl,
                online_num: this.onlineUrl
            };

            this.SET_API_CONFIG(this.baseInfo);
        },
        showTest: function showTest(type) {
            this.$emit('dialog-show', { 'status': true, 'type': type, 'serverListUrl': this.serverListUrl, roleUrl: this.roleUrl,
                'registerUrl': this.registerUrl, 'onlineUrl': this.onlineUrl });
        },
        checkUrl: function checkUrl(type) {
            var sRegex = "^((https|http|ftp|rtsp|mms)?://)" + "(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
            + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
            + "|" // 允许IP和DOMAIN（域名）
            + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
            + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
            + "[a-z]{2,6})" // first level domain- .com or .museum
            + "(:[0-9]{1,4})?" // 端口- :80
            + "((/?)|" // a slash isn't required if there is no file name
            + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";

            var matchUrl = new RegExp(sRegex, 'i');
            var parentSubmit = false;
            if (type == "server") {
                if (this.serverListUrl && !matchUrl.test(this.serverListUrl)) {
                    this.$message({
                        message: '请输入有效的服列表地址！',
                        type: 'error',
                        showClose: true
                    });
                    this.$refs['serverlist'].focus();
                    parentSubmit = true;
                }
            } else if (type == "role") {
                if (this.roleUrl && !matchUrl.test(this.roleUrl)) {
                    this.$message({
                        message: '请输入有效的角色信息地址！',
                        type: 'error',
                        showClose: true
                    });
                    this.$refs['role'].focus();
                    parentSubmit = true;
                }
            } else if (type == "register") {
                if (this.registerUrl && !matchUrl.test(this.registerUrl)) {
                    this.$message({
                        message: '请输入有效的注册人数地址！',
                        type: 'error',
                        showClose: true
                    });
                    this.$refs['register'].focus();
                    parentSubmit = true;
                }
            } else if (type == "online") {
                if (this.onlineUrl && !matchUrl.test(this.onlineUrl)) {
                    this.$message({
                        message: '请输入有效的在线人数地址！',
                        type: 'error',
                        showClose: true
                    });
                    this.$refs['online'].focus();
                    parentSubmit = true;
                }
            }
            this.$emit('child-event', parentSubmit);
        }
    })
});

/***/ }),

/***/ "6OKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-scheme-container"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"按用户细分定位","name":"user"}},[_c('div',{staticClass:"device-flex"},[_c('div',[_vm._v("\n                    选择细分维度： "),_c('span',{staticClass:"title-description"},[_vm._v("（用户细分定位可排重推送）")])]),_vm._v(" "),(_vm.detailData.last_send_number)?_c('div',{staticClass:"device-number"},[_vm._v(_vm._s(_vm.detailData.last_send_number)),_c('span',[_vm._v("个目标设备")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"check-group-buttons"},_vm._l((_vm.groupOptions),function(item){return _c('span',{key:item.label,staticClass:"button",class:{'active': item.checked},on:{"click":function($event){return _vm.handlerDimension(item)}}},[_vm._v(" \n                    "+_vm._s(item.label)+" \n                ")])}),0),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"margin-top-18",attrs:{"model":_vm.pushDeviceFilterForm,"label-width":"230px"}},[_vm._l((_vm.userPositionFormItems),function(item,index){return _c('div',{key:'form-item'+index},[(item.checked)?_c('el-form-item',{staticClass:"border-form-item",attrs:{"label":item.label,"prop":item.key,"rules":{
                                required: item.checked, message: ' ', trigger: ['blur', 'change']
                            }}},[_c('span',{staticClass:"line"}),_vm._v(" "),(['reg_date', 'last_login_date'].includes(item.key))?_c('div',{staticClass:"flex"},[_c('el-input-number',{attrs:{"placeholder":"无限制","size":"small","disabled":_vm.isDetail,"min":0,"controls":false,"precision":0},model:{value:(_vm.pushDeviceFilterForm[item.key][0]),callback:function ($$v) {_vm.$set(_vm.pushDeviceFilterForm[item.key], 0, $$v)},expression:"pushDeviceFilterForm[item.key][0]"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-input-number',{attrs:{"placeholder":"无限制","size":"small","disabled":_vm.isDetail,"min":_vm.pushDeviceFilterForm[item.key][0],"controls":false,"precision":0},model:{value:(_vm.pushDeviceFilterForm[item.key][1]),callback:function ($$v) {_vm.$set(_vm.pushDeviceFilterForm[item.key], 1, $$v)},expression:"pushDeviceFilterForm[item.key][1]"}}),_vm._v(" "),_c('span',[_vm._v("天")])],1):(['future_7days_lose', 'future_7days_pay'].includes(item.key))?_c('div',{staticClass:"flex slider"},[_c('el-slider',{staticClass:"w450",attrs:{"disabled":_vm.isDetail,"range":"","marks":_vm.marks},model:{value:(_vm.pushDeviceFilterForm[item.key]),callback:function ($$v) {_vm.$set(_vm.pushDeviceFilterForm, item.key, $$v)},expression:"pushDeviceFilterForm[item.key]"}})],1):_c('el-select',{staticClass:"w450",attrs:{"disabled":_vm.isDetail,"placeholder":'请选择'+item.label,"filterable":"","size":"small","remote":"","remote-method":function (kwd) { return _vm.filterData(kwd,item); },"multiple":item.key !== 'os'},model:{value:(_vm.pushDeviceFilterForm[item.key]),callback:function ($$v) {_vm.$set(_vm.pushDeviceFilterForm, item.key, $$v)},expression:"pushDeviceFilterForm[item.key]"}},_vm._l((item.options),function(row){return _c('el-option',{key:'label'+row.label+row.value,attrs:{"label":row.label,"value":row.value}})}),1),_vm._v(" "),(!_vm.isDetail && item.label !== 'OS')?_c('el-button',{attrs:{"type":"danger","size":"small","icon":"el-icon-delete","circle":""},on:{"click":function($event){return _vm.handlerDimension(item,index)}}}):_vm._e()],1):_vm._e()],1)})],2)],1)],1),_vm._v(" "),(!_vm.isDetail)?_c('el-button',{staticClass:"next-button margin-top-18",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6OPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-notice-subscribe-container"},[_c('span',{staticClass:"title-description"},[_vm._v("在每次推送前，提前一天钉钉通知到以下人员。")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.pushNoticeSubscribeForm}},[_c('el-form-item',[_c('select-users',{attrs:{"disabled":_vm.isDetail},model:{value:(_vm.pushNoticeSubscribeForm.users),callback:function ($$v) {_vm.$set(_vm.pushNoticeSubscribeForm, "users", $$v)},expression:"pushNoticeSubscribeForm.users"}})],1),_vm._v(" "),(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("完成")]):_c('el-button',{staticClass:"next-button",attrs:{"size":"small"},on:{"click":_vm.cancel}},[_vm._v("取消")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6iS0":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Created by shiyonggao on 2019/1/22.
 */
module.exports = {
  'zh-CN': __webpack_require__("5phe")
};

/***/ }),

/***/ "6m1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-slimvue"},[_c('iframe',{attrs:{"width":"100%","scrolling":"auto","frameborder":"0","height":_vm.$iframeHeight,"src":_vm.url}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6pTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7TQX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushNoticeSubscribe_vue__ = __webpack_require__("O4kk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e1e912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushNoticeSubscribe_vue__ = __webpack_require__("6OPV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushNoticeSubscribe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e1e912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushNoticeSubscribe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7XdD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"website","version":"1.0.0","description":"A Vue.js project","author":"Gaoshiyong <gaoshiyong1272@vip.163.com>","private":true,"scripts":{"clean":"node build/clean.js","dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","watch":"node build/build.js -w","release":"node build/build.js -p","library":"node build/build.js -l","postinstall":"node build/post-install.js && rm -rf ./node_modules/@oasis-games/ces/node_modules/axios","setup-library":"node build/setup-library.js","create-vue":"node build/create-vue.js"},"dependencies":{"@oasis-games/ces":"^0.5.12","argparse":"^1.0.10","axios":"^0.19.0","babel-polyfill":"^6.26.0","blob.js":"^1.0.1","element-ui":"^2.13.0","file-saver":"^2.0.2","jquery":"^3.4.1","js-base64":"^2.5.1","load-script":"^1.0.0","moment":"^2.22.2","node-notifier":"^6.0.0","qs":"^6.9.3","simple-pinyin":"^3.0.2","vue":"^2.5.17","vue-clipboard2":"^0.3.1","vue-i18n":"^8.15.1","vue-json-views":"^1.1.0","vuex":"^3.1.1","xlsx":"^0.15.3"},"devDependencies":{"autoprefixer":"^7.2.6","babel-core":"^6.26.3","babel-eslint":"^7.1.1","babel-loader":"^7.1.5","babel-plugin-component":"^0.10.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.7.0","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^2.4.1","clean-webpack-plugin":"^0.1.19","compression-webpack-plugin":"^1.1.11","connect-history-api-fallback":"^1.5.0","copy-webpack-plugin":"^4.5.2","css-loader":"^0.28.11","cssnano":"^3.10.0","eslint":"^3.19.0","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-promise":"^3.8.0","eslint-plugin-standard":"^2.0.1","eventsource-polyfill":"^0.9.6","express":"^4.16.3","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.7.0","fs-extra":"^6.0.1","fsevents":"^1.2.11","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.18.0","minimist":"^1.2.0","mockjs":"^1.1.0","moment-timezone":"^0.5.32","node-sass":"^4.9.3","opn":"^5.3.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.4.0","recursive-readdir":"^2.2.2","recursive-readdir-sync":"^1.0.6","rimraf":"^2.6.0","sass-loader":"^6.0.7","semver":"^5.5.1","shelljs":"^0.7.6","url-loader":"^1.1.1","vue-loader":"^13.7.2","vue-style-loader":"^3.1.2","vue-template-compiler":"^2.5.17","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.13.1","webpack-dev-middleware":"^1.12.2","webpack-hot-middleware":"^2.22.3","webpack-merge":"^4.1.4"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "8/2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 活动页面管理 store module
 */

var state = {
    tableData: []
};

var actions = {
    GET_ACTIVITY_PAGES: function GET_ACTIVITY_PAGES(_ref) {
        var commit = _ref.commit,
            rootState = _ref.rootState,
            dispatch = _ref.dispatch;

        commit("PRIVATE_LOADING", true, { root: true });
        rootState.$helper.request.get(rootState.$config.api.activity_page.list).then(function (res) {
            commit("_updateTableData", res.data || []);
            commit("PRIVATE_LOADING", false, { root: true });
        }).catch(function (err) {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch("ERROR_HANDLE", err, { root: true });
        });
    },
    ADD_ACTIVITY_PAGE: function ADD_ACTIVITY_PAGE(_ref2, args) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState,
            dispatch = _ref2.dispatch;

        commit("PRIVATE_LOADING", true, { root: true });
        rootState.$helper.request.post(rootState.$config.api.activity_page.add, args).then(function () {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch("GET_ACTIVITY_PAGES");
            dispatch("ALERT_HANDLE", { message: "添加成功！" }, { root: true });
        }).catch(function (err) {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch("ERROR_HANDLE", err, { root: true });
        });
    },
    UPDATE_ACTIVITY_PAGE: function UPDATE_ACTIVITY_PAGE(_ref3, args) {
        var commit = _ref3.commit,
            rootState = _ref3.rootState,
            dispatch = _ref3.dispatch;

        commit("PRIVATE_LOADING", true, { root: true });
        var url = _.replace(rootState.$config.api.activity_page.edit, '{id}', args.id);
        rootState.$helper.request.post(url, args).then(function () {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch("GET_ACTIVITY_PAGES");
            dispatch("ALERT_HANDLE", { message: "更新成功！" }, { root: true });
        }).catch(function (err) {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch("ERROR_HANDLE", err, { root: true });
        });
    }
};

var getters = {};

var mutations = {
    _updateTableData: function _updateTableData(state, data) {
        state.tableData = data;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "85ET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    demoList: [],
    demoStatus: false
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    DEMO_ACTIONS: function DEMO_ACTIONS(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        console.log('DEMO_ACTIONS=>', args, rootState);
        var data = [{ id: 1, data: 'aata1' }, { id: 2, data: 'aata2' }, { id: 3, data: 'aata3' }];
        commit('_updateDemoList', data);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateDemoList: function _updateDemoList(state, args) {
        state.demoList = args;
        console.log(state.demoList);
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "8EeF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    blockList: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_BLOCK_DATA: function GET_BLOCK_DATA(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/riskmanage').then(function (res) {
            data = res.data;
            commit('_blockList', data);
            args.callback(data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_BLOCK_DATA: function PUT_BLOCK_DATA(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.post('/games/' + gameCode + '/riskmanage', {
            block_type: args.block_type,
            block_allowed: args.block_allowed,
            white_country: args.white_country,
            white_ip: args.white_ip,
            black_country: args.black_country,
            black_ip: args.black_ip
        }).then(function (res) {
            dispatch('ALERT_HANDLE', {
                message: '提交成功!',
                callback: function callback() {
                    rootState.$helper.helper.route('riskManagement/ipBlockView', { block_type: args.block_type });
                }
            }, { root: true });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _blockList: function _blockList(state, args) {
        state.blockList = args;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "8IcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['titleColor']
});

/***/ }),

/***/ "8Tb4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/gamekit_switchaccount@2x.23bb410.png";

/***/ }),

/***/ "8kzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    data: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    getPushPlanData: function getPushPlanData(_ref, params) {
        var commit = _ref.commit,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get('/games/' + gameCode + '/pushplans', params, function (res) {
            return true;
        });
    },
    getDeviceData: function getDeviceData(_ref2, params) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get('/games/' + gameCode + '/pushplan/trylist', params, function (res) {
            return true;
        });
    },
    trySend: function trySend(_ref3, params) {
        var commit = _ref3.commit,
            rootState = _ref3.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.put('/games/' + gameCode + '/pushplan/trysend', params, function (res) {
            return true;
        });
    },
    createdLoginBan: function createdLoginBan(_ref4, params) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        return rootState.$helper.request.post('/games/{game_code}/login-blacklist/new', params);
    },
    editLoginBan: function editLoginBan(_ref5, params) {
        var commit = _ref5.commit,
            rootState = _ref5.rootState;

        return rootState.$helper.request.put('/games/{game_code}/login-blacklist/edit', params, function (res) {
            return true;
        });
    },
    deleteLoginBan: function deleteLoginBan(_ref6, params) {
        var commit = _ref6.commit,
            rootState = _ref6.rootState;

        return rootState.$helper.request.delete('/games/{game_code}/login-blacklist/delete', params, function (res) {
            return true;
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    changeData: function changeData(state, data) {
        state.data = data;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "9DvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiinfo_vue__ = __webpack_require__("6Gs/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a28e04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_apiinfo_vue__ = __webpack_require__("EXhs");
function injectStyle (ssrContext) {
  __webpack_require__("vhh8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18a28e04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_apiinfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a28e04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_apiinfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9DxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse',{model:{value:(_vm.params.names),callback:function ($$v) {_vm.$set(_vm.params, "names", $$v)},expression:"params.names"}},_vm._l((_vm.params.identified_user_rules),function(item,i){return _c('el-collapse-item',{key:i,attrs:{"name":i}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex title-change-btn"},[_c('div',[_vm._v("\n                    年龄：\n                    "),_c('span',[_vm._v(_vm._s(item.age_from))]),_vm._v("岁\n                    "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.age_to === 150 ? '26岁及以上' : item.age_to + '岁'))])])])]),_vm._v(" "),_c('div',{staticClass:"border-card mar-t-0"},[(item.limit_type.indexOf(1) > -1)?[_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"节假日登录限制："}}),_vm._v(" "),_vm._l((item.login_rule.holiday.rules),function(timeRange,timeIndex){return _c('el-form-item',{key:'timeRange'+ timeIndex,attrs:{"label":_vm.randerLabel(timeRange.date_type),"label-width":"140px"}},[(timeRange.date_type === 1)?[_vm._v("\n                        当天累计登陆上限\n                        "),_c('span',[_vm._v(_vm._s(timeRange.daily_max_game_time))]),_vm._v("\n                        min\n                    ")]:(timeRange.date_type === 2)?[_c('span',[_vm._v(_vm._s(timeRange.start_time))]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(timeRange.end_time))])]:(timeRange.date_type === 3)?[_c('span',[_vm._v(_vm._s(timeRange.start_time))]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(timeRange.end_time))])]:_vm._e()],2)}),_vm._v(" "),_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"非节假日（周五）登录限制："}}),_vm._v(" "),_vm._l((item.login_rule.work_day_special.rules),function(timeRangeSpecial,timeIndex){return _c('el-form-item',{key:'timeRangeSpecial'+ timeIndex,attrs:{"label":_vm.randerLabel(timeRangeSpecial.date_type),"label-width":"140px"}},[(timeRangeSpecial.date_type === 1)?[_vm._v("\n                        当天累计登陆上限\n                        "),_c('span',[_vm._v(_vm._s(timeRangeSpecial.daily_max_game_time))]),_vm._v("\n                        min\n                    ")]:(timeRangeSpecial.date_type === 2)?[_c('span',[_vm._v(_vm._s(timeRangeSpecial.start_time))]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(timeRangeSpecial.end_time))])]:(timeRangeSpecial.date_type === 3)?[_c('span',[_vm._v(_vm._s(timeRangeSpecial.start_time))]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(timeRangeSpecial.end_time))])]:_vm._e()],2)}),_vm._v(" "),_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"非节假日（非周五）登录限制："}}),_vm._v(" "),_vm._l((item.login_rule.work_day_normal.rules),function(timeRangeNormal,timeIndex){return _c('el-form-item',{key:'timeRangeNormal'+ timeIndex,attrs:{"label":_vm.randerLabel(timeRangeNormal.date_type),"label-width":"140px"}},[(timeRangeNormal.date_type === 1)?[_vm._v("\n                        当天累计登陆上限\n                        "),_c('span',[_vm._v(_vm._s(timeRangeNormal.daily_max_game_time))]),_vm._v("\n                        min\n                    ")]:(timeRangeNormal.date_type === 2)?[_c('span',[_vm._v(_vm._s(timeRangeNormal.start_time))]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(timeRangeNormal.end_time))])]:(timeRangeNormal.date_type === 3)?[_c('span',[_vm._v(_vm._s(timeRangeNormal.start_time))]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(timeRangeNormal.end_time))])]:_vm._e()],2)})]:_vm._e(),_vm._v(" "),(item.limit_type.indexOf(2) > -1)?[_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"消费限制："}}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"单笔单次消费上限金额："}},[_c('span',[_vm._v(_vm._s(item.payment_rule.max_consume_per_order))]),_vm._v(" RMB\n                ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"单月累计消费上限金额："}},[_c('span',[_vm._v(_vm._s(item.payment_rule.max_consume_per_month))]),_vm._v(" RMB\n                ")])]:_vm._e()],2)],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9oi5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-scheme-container"},[_c('div',{staticClass:"push-container"},[_c('div',{staticClass:"container-left"},[_c('span',{staticClass:"title-description"},[_vm._v("选择全部语言则默认一个推送内容，选择多个语言则分语言设置推送内容")]),_vm._v(" "),(!_vm.isAll)?_c('el-form',{ref:"form",attrs:{"model":_vm.pushContainerForm}},[_c('el-tabs',{attrs:{"stretch":true},model:{value:(_vm.languageCurrentName),callback:function ($$v) {_vm.languageCurrentName=$$v},expression:"languageCurrentName"}},_vm._l((_vm.pushContainerForm),function(item,key){return _c('el-tab-pane',{key:key,attrs:{"name":key}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                            "+_vm._s(key.toUpperCase())+"\n                            "),_c('em',{class:item.title && item.content ? 'language-success': 'language-warning'})]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推送标题","prop":key + '.title',"rules":{required: true, message: '请输入推送标题', trigger: 'blur'}}},[_c('sub-inputtrim',{attrs:{"size":"small","disabled":_vm.isDetail},model:{value:(item.title),callback:function ($$v) {_vm.$set(item, "title", $$v)},expression:"item.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推送文案","prop":key + '.content',"rules":{required: true, message: '请输入推送文案', trigger: 'blur'}}},[_c('sub-inputtrim',{attrs:{"type":"textarea","size":"small","disabled":_vm.isDetail},model:{value:(item.content),callback:function ($$v) {_vm.$set(item, "content", $$v)},expression:"item.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片地址","prop":key + '.imgurl',"rules":{validator: _vm.validatorHttp}}},[_c('el-tooltip',{attrs:{"content":"纵向图片宽高比为 3:2；横向图片宽高比为 1:1","placement":"top-start"}},[_c('el-link',{attrs:{"href":"https://upload-img.mars-era.cn/","target":"_blank","type":"primary"}},[_vm._v("上传图片")])],1),_vm._v(" "),_c('sub-inputtrim',{attrs:{"size":"small","disabled":_vm.isDetail},model:{value:(item.imgurl),callback:function ($$v) {_vm.$set(item, "imgurl", $$v)},expression:"item.imgurl"}})],1)],1)}),1)],1):_c('el-form',{ref:"form",attrs:{"model":_vm.pushContainerForm,"rules":_vm.pushContainerFormRules}},[_c('el-form-item',{attrs:{"label":"推送标题","prop":"title"}},[_c('sub-inputtrim',{attrs:{"size":"small","disabled":_vm.isDetail},model:{value:(_vm.pushContainerForm.title),callback:function ($$v) {_vm.$set(_vm.pushContainerForm, "title", $$v)},expression:"pushContainerForm.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"推送文案","prop":"content"}},[_c('sub-inputtrim',{attrs:{"type":"textarea","size":"small","disabled":_vm.isDetail},model:{value:(_vm.pushContainerForm.content),callback:function ($$v) {_vm.$set(_vm.pushContainerForm, "content", $$v)},expression:"pushContainerForm.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片地址","prop":"imgurl"}},[_c('el-tooltip',{attrs:{"content":"纵向图片宽高比为 3:2；横向图片宽高比为 1:1","placement":"top-start"}},[_c('el-link',{attrs:{"href":"https://upload-img.mars-era.cn/","target":"_blank","type":"primary"}},[_vm._v("上传图片")])],1),_vm._v(" "),_c('sub-inputtrim',{attrs:{"size":"small","disabled":_vm.isDetail},model:{value:(_vm.pushContainerForm.imgurl),callback:function ($$v) {_vm.$set(_vm.pushContainerForm, "imgurl", $$v)},expression:"pushContainerForm.imgurl"}})],1)],1),_vm._v(" "),(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1),_vm._v(" "),_c('el-tabs',{staticClass:"container-right",model:{value:(_vm.currentModelName),callback:function ($$v) {_vm.currentModelName=$$v},expression:"currentModelName"}},[_c('el-tab-pane',{attrs:{"label":"Android","name":"android"}},[_c('img',{attrs:{"src":__webpack_require__("DeZu"),"width":"375","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v("默认效果")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("DCAM"),"width":"375","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v("展开效果")])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"iOS","name":"ios"}},[_c('img',{attrs:{"src":__webpack_require__("TepT"),"width":"375","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v("默认效果")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("aCwl"),"width":"375","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v("展开效果")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9tRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerDialog_vue__ = __webpack_require__("nYdf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b106ed9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerDialog_vue__ = __webpack_require__("Ei61");
function injectStyle (ssrContext) {
  __webpack_require__("WX7q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b106ed9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b106ed9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9yFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiyTitle_vue__ = __webpack_require__("8IcM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5724dba3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiyTitle_vue__ = __webpack_require__("hsci");
function injectStyle (ssrContext) {
  __webpack_require__("wazR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5724dba3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiyTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5724dba3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiyTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A4R5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AcnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_BLOCK_DATA: function GET_BLOCK_DATA(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/riskmanage').then(function (res) {
            data = res.data;
            args.callback(data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "AtVe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B1dP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/gift.39b631f.png";

/***/ }),

/***/ "BAnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */
var handler = {
    getUrl: function getUrl(key, platform, rootState) {
        var system = rootState.$config.api.system;
        return system[key].replace(/\{platform\}/g, platform);
    }
};

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    iosVersionList: [],
    iosVersionListLen: 0,
    iosVersionLast: {},

    androidVersionList: [],
    androidVersionListLen: 0,
    androidVersionLast: {},

    h5VersionList: [],
    h5VersionListLen: 0,
    h5VersionLast: {},

    windowsVersionList: [],
    windowsVersionListLen: 0,
    windowsVersionLast: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    ADD_BASE_VERSION: function ADD_BASE_VERSION(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        commit('PRIVATE_LOADING', true, { root: true });
        var url = handler.getUrl('add_version', args.platform, rootState);
        rootState.$helper.request.put(url, args.data).then(function (res) {
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ALERT_HANDLE', { message: '添加版本成功！', reload: true }, { root: true });
        }).catch(function (error) {
            var message = '操作失败！';
            if (error['response'] && error['response']['data'] && error['response']['data']['exception'] && error['response']['data']['exception']['message']) {
                message = error['response']['data']['exception']['message'];
            }
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ALERT_HANDLE', { message: message }, { root: true });
        });
    },
    EDIT_BASE_VERSION: function EDIT_BASE_VERSION(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        commit('PRIVATE_LOADING', true, { root: true });
        var version_id = args.item['sdk_version_id'];
        var url = handler.getUrl('edit_version', args.item.platform, rootState);
        url = url.replace(/\{sdk_version_id\}/g, version_id);
        rootState.$helper.request.put(url, args.data).then(function (res) {
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ALERT_HANDLE', { message: '编辑版本成功！', reload: true }, { root: true });
        }).catch(function (res) {
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },


    /**
     * 删除版本号
     * @constructor
     */
    REMOVE_BASE_VERSION: function REMOVE_BASE_VERSION(_ref3, item) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        commit('PRIVATE_LOADING', true, { root: true });
        var version_id = item['sdk_version_id'];
        var url = handler.getUrl('remove_version', item['platform'], rootState);
        url = url.replace(/\{sdk_version_id\}/g, version_id);
        rootState.$helper.request.delete(url).then(function (res) {
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ALERT_HANDLE', { message: '删除成功！', reload: true }, { root: true });
        }).catch(function (res) {
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },


    /**
     * 获取所有版本号列表
     * @constructor
     */
    GET_BASE_VERSION_LIST: function GET_BASE_VERSION_LIST(_ref4) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        commit('PRIVATE_LOADING', true, { root: true });
        var url = handler.getUrl('get_version_list', 'all', rootState);
        var data = {
            iosVersionList: [],
            androidVersionList: [],
            h5VersionList: [],
            windowsVersionList: [],
            iosVersionListLen: 0,
            androidVersionListLen: 0,
            h5VersionListLen: 0,
            windowsVersionListLen: 0
        };
        rootState.$helper.request.get(url).then(function (res) {
            for (var key in res.data['sdk_versions']) {
                if (res.data['sdk_versions'][key]['platform'] === 'iOS') {
                    data.iosVersionList.push(res.data['sdk_versions'][key]);
                    data.iosVersionListLen += 1;
                }

                if (res.data['sdk_versions'][key]['platform'] === 'Android') {
                    data.androidVersionList.push(res.data['sdk_versions'][key]);
                    data.androidVersionListLen += 1;
                }

                if (res.data['sdk_versions'][key]['platform'] === 'H5') {
                    data.h5VersionList.push(res.data['sdk_versions'][key]);
                    data.h5VersionListLen += 1;
                }
                if (res.data['sdk_versions'][key]['platform'] === 'Windows') {
                    data.windowsVersionList.push(res.data['sdk_versions'][key]);
                    data.windowsVersionListLen += 1;
                }
            }
            commit('_updateVersion', data);
            commit('PRIVATE_LOADING', false, { root: true });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
            commit('PRIVATE_LOADING', false, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateVersion: function _updateVersion(state, data) {
        state.iosVersionList = data.iosVersionList;
        state.iosVersionListLen = data.iosVersionListLen;
        state.iosVersionLast = data.iosVersionList[0];

        state.androidVersionList = data.androidVersionList;
        state.androidVersionListLen = data.androidVersionListLen;
        state.androidVersionLast = data.androidVersionList[0];

        state.h5VersionList = data.h5VersionList;
        state.h5VersionListLen = data.h5VersionListLen;
        state.h5VersionLast = data.h5VersionList[0];

        state.windowsVersionList = data.windowsVersionList;
        state.windowsVersionListLen = data.windowsVersionListLen;
        state.windowsVersionLast = data.windowsVersionList[0];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "BLOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "BTzX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie__ = __webpack_require__("wwIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cpArgExportPrivacyPolicy__ = __webpack_require__("boqd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error__ = __webpack_require__("PmJb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__excel__ = __webpack_require__("HBXY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__("Q8VG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__localStorage__ = __webpack_require__("RFTr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loginHandle__ = __webpack_require__("eE6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__message__ = __webpack_require__("Kcpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pinyin__ = __webpack_require__("CY4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request__ = __webpack_require__("bGtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sessionStorage__ = __webpack_require__("l6JS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__test_test_test__ = __webpack_require__("Cbub");













/* harmony default export */ __webpack_exports__["a"] = ({
    cookie: __WEBPACK_IMPORTED_MODULE_0__cookie__["a" /* default */],
    cpArgExportPrivacyPolicy: __WEBPACK_IMPORTED_MODULE_1__cpArgExportPrivacyPolicy__["a" /* default */],
    error: __WEBPACK_IMPORTED_MODULE_2__error__["a" /* default */],
    excel: __WEBPACK_IMPORTED_MODULE_3__excel__["a" /* default */],
    helper: __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */],
    localStorage: __WEBPACK_IMPORTED_MODULE_5__localStorage__["a" /* default */],
    loginHandle: __WEBPACK_IMPORTED_MODULE_6__loginHandle__["a" /* default */],
    message: __WEBPACK_IMPORTED_MODULE_7__message__["a" /* default */],
    pinyin: __WEBPACK_IMPORTED_MODULE_8__pinyin__["a" /* default */],
    request: __WEBPACK_IMPORTED_MODULE_9__request__["a" /* default */],
    sessionStorage: __WEBPACK_IMPORTED_MODULE_10__sessionStorage__["a" /* default */],
    testTestTest: __WEBPACK_IMPORTED_MODULE_11__test_test_test__["a" /* default */]
});

/***/ }),

/***/ "C5Dp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    getRechargeCodeList: function getRechargeCodeList(_ref, params) {
        var commit = _ref.commit,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get('/games/' + gameCode + '/activity/list', params, function (res) {
            return true;
        });
    },
    createdRechargeCode: function createdRechargeCode(_ref2, params) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState;

        return rootState.$helper.request.filePost('/games/{game_code}/activity/create', params);
    },
    editRechargeCode: function editRechargeCode(_ref3, params) {
        var commit = _ref3.commit,
            rootState = _ref3.rootState;

        return rootState.$helper.request.filePost('/games/{game_code}/activity/edit', params);
    },
    changeStatusAction: function changeStatusAction(_ref4, params) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        return rootState.$helper.request.post('/games/{game_code}/activity/change-status', params);
    },
    addCode: function addCode(_ref5, params) {
        var commit = _ref5.commit,
            rootState = _ref5.rootState;

        return rootState.$helper.request.filePost('/games/{game_code}/activity/add-code', params);
    },
    removeActivity: function removeActivity(_ref6, params) {
        var commit = _ref6.commit,
            rootState = _ref6.rootState;

        return rootState.$helper.request.delete('/games/{game_code}/activity/delete/' + params.id);
    },
    getActivityDetails: function getActivityDetails(_ref7, params) {
        var commit = _ref7.commit,
            rootState = _ref7.rootState;

        return rootState.$helper.request.get('/games/{game_code}/activity/get/' + params.id);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "CCe3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetContentAllowed_vue__ = __webpack_require__("uOBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe271364_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetContentAllowed_vue__ = __webpack_require__("UuKd");
function injectStyle (ssrContext) {
  __webpack_require__("x/+b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe271364"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetContentAllowed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe271364_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetContentAllowed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CNxV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/ios-landscape.5fff5da.png";

/***/ }),

/***/ "CQ4N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/ios-landscape1.224d2b5.png";

/***/ }),

/***/ "CY4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_pinyin__ = __webpack_require__("GH9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_pinyin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simple_pinyin__);


/**
 * Created by shiyonggao on 2019/11/28.
 */


var pinyin = function () {
    function pinyin() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, pinyin);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(pinyin, [{
        key: 'fristChar',

        /***
         * 获取首字母
         * @param str
         * @returns {s}
         */
        value: function fristChar(str) {

            var reg = /[\u4e00-\u9fa5]/;
            /**英文字母返回所有字符**/
            if (!reg.test(str)) {
                return str;
            }

            var arr = __WEBPACK_IMPORTED_MODULE_2_simple_pinyin___default()(str, { pinyinOnly: false });
            var temp = [],
                len = arr.length;
            for (var i = 0; i < len; i++) {
                temp.push(arr[i].slice(0, 1));
            }
            return temp.join('');
        }

        /**
         * 获取全拼拼音
         * @param str
         */

    }, {
        key: 'fullChar',
        value: function fullChar(str) {
            return __WEBPACK_IMPORTED_MODULE_2_simple_pinyin___default()(str, { pinyinOnly: false }).join('');
        }

        /**
         * 获取首字母和全拼
         * @param str
         */

    }, {
        key: 'all',
        value: function all(str) {
            return {
                frist: this.fristChar(str),
                full: this.fullChar(str)
            };
        }
    }]);

    return pinyin;
}();

/* harmony default export */ __webpack_exports__["a"] = (new pinyin());

/***/ }),

/***/ "Cbub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Created by shiyonggao on 2019/11/28.
 */

var test = function () {
  function test() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, test);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(test, [{
    key: 'test',

    /***
     * 去掉两端空格
     * @param s
     * @returns {s}
     */
    value: function test(s) {
      return s.replace(/^\s+|\s+$/gm, '');
    }
  }]);

  return test;
}();

/* harmony default export */ __webpack_exports__["a"] = (new test());

/***/ }),

/***/ "CuWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-system-search"},[_c('el-form',{ref:"form",staticClass:"sub-system-search-from",attrs:{"model":_vm.form,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"活动名称"}},[_c('el-input',{attrs:{"size":"small","placeholder":"SDK版本"},model:{value:(_vm.form.version),callback:function ($$v) {_vm.$set(_vm.form, "version", $$v)},expression:"form.version"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"活动名称"}},[_c('el-input',{attrs:{"size":"small","placeholder":"描述"},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"活动名称"}},[_c('el-button',{attrs:{"size":"mini","type":"success","icon":"el-icon-plus"},on:{"click":_vm.onSubmit}},[_vm._v("添加版本")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DCAM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/container-android2.5b47ba1.png";

/***/ }),

/***/ "DeZu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/container-android1.b4e3b8f.png";

/***/ }),

/***/ "EMK4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EXhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-system-list"},[_c('el-form',{attrs:{"label-width":"135px"}},[_c('el-form-item',{attrs:{"label":"服列表地址:"}},[_c('el-tooltip',{attrs:{"placement":"top-start","content":"由CP研发人员提供，获取服务列表信息"}},[_c('i',{staticClass:"el-icon-question"})]),_vm._v(" "),_c('el-input',{ref:"serverlist",staticClass:"el-input--small",staticStyle:{"width":"70%"},on:{"blur":function($event){return _vm.checkUrl('server')}},model:{value:(_vm.serverListUrl),callback:function ($$v) {_vm.serverListUrl=$$v},expression:"serverListUrl"}}),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh","size":"mini","type":"primary"},on:{"click":function($event){return _vm.showTest('server')}}},[_vm._v("\n                测试\n            ")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"角色信息接口:"}},[_c('el-tooltip',{attrs:{"placement":"top-start","content":"由CP研发人员提供，获取角色信息"}},[_c('i',{staticClass:"el-icon-question"})]),_vm._v(" "),_c('el-input',{ref:"role",staticClass:"el-input--small",staticStyle:{"width":"70%"},on:{"blur":function($event){return _vm.checkUrl('role')}},model:{value:(_vm.roleUrl),callback:function ($$v) {_vm.roleUrl=$$v},expression:"roleUrl"}}),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh","size":"mini","type":"primary"},on:{"click":function($event){return _vm.showTest('role')}}},[_vm._v("\n                测试\n            ")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"注册人数接口:"}},[_c('el-tooltip',{attrs:{"placement":"top-start","content":"由CP研发人员提供，获取注册人数信息"}},[_c('i',{staticClass:"el-icon-question"})]),_vm._v(" "),_c('el-input',{ref:"register",staticClass:"el-input--small",staticStyle:{"width":"70%"},on:{"blur":function($event){return _vm.checkUrl('register')}},model:{value:(_vm.registerUrl),callback:function ($$v) {_vm.registerUrl=$$v},expression:"registerUrl"}}),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh","size":"mini","type":"primary"},on:{"click":function($event){return _vm.showTest('reg')}}},[_vm._v("\n                测试\n            ")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"在线人数接口:"}},[_c('el-tooltip',{attrs:{"placement":"top-start","content":"由CP研发人员提供，获取在线人数信息"}},[_c('i',{staticClass:"el-icon-question"})]),_vm._v(" "),_c('el-input',{ref:"online",staticClass:"el-input--small",staticStyle:{"width":"70%"},on:{"blur":function($event){return _vm.checkUrl('online')}},model:{value:(_vm.onlineUrl),callback:function ($$v) {_vm.onlineUrl=$$v},expression:"onlineUrl"}}),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh","size":"mini","type":"primary"},on:{"click":function($event){return _vm.showTest('online')}}},[_vm._v("\n            测试\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EYzl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eeq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("2.未认证玩家配置")]),_vm._v(" "),_c('div',{staticClass:"border-card"},[_c('h4',[_vm._v("规则说明：")]),_vm._v(" "),_c('div',{staticClass:"now-config"},[(_vm.is_configured)?_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":"no_identified_user_rule.timing_period_days"}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":1,"controls":false,"precision":0,"disabled":"true"},model:{value:(_vm.params.no_identified_user_rule.timing_period_days),callback:function ($$v) {_vm.$set(_vm.params.no_identified_user_rule, "timing_period_days", $$v)},expression:"params.no_identified_user_rule.timing_period_days"}})],1):_c('span',[_vm._v(_vm._s(_vm.params.no_identified_user_rule.timing_period_days))]),_vm._v("\n            天内 累计登陆\n            "),(_vm.is_configured)?_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":"no_identified_user_rule.total_game_minutes"}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"precision":0,"controls":false,"disabled":"true"},model:{value:(_vm.params.no_identified_user_rule.total_game_minutes),callback:function ($$v) {_vm.$set(_vm.params.no_identified_user_rule, "total_game_minutes", $$v)},expression:"params.no_identified_user_rule.total_game_minutes"}})],1):_c('span',[_vm._v(_vm._s(_vm.params.no_identified_user_rule.total_game_minutes))]),_vm._v("\n            min，要求玩家实名认证。\n        ")],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ei61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.selfVisible,"width":"600px"},on:{"update:visible":function($event){_vm.selfVisible=$event}}},[(_vm.formVisible)?_c('el-form',{ref:"form",attrs:{"model":_vm.params,"rules":_vm.rules,"size":"small","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"区服方式","prop":"type"}},[_c('el-radio-group',{on:{"change":_vm.typeChange},model:{value:(_vm.params.type),callback:function ($$v) {_vm.$set(_vm.params, "type", $$v)},expression:"params.type"}},[_c('el-radio',{attrs:{"label":"single"}},[_vm._v("按单服筛选")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"range"}},[_vm._v("选择区服段")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"all"}},[_vm._v("全部")])],1)],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.params.type !== 'range'),expression:"params.type !== 'range'"}],attrs:{"label":"选择区服","prop":"ids"}},[_c('div',{staticClass:"range-select w400"},[_c('el-select',{staticClass:"w400",attrs:{"size":"small","filterable":"","clearable":"","multiple":"","disabled":_vm.params.type === 'all',"placeholder":"请选择"},model:{value:(_vm.params.ids),callback:function ($$v) {_vm.$set(_vm.params, "ids", $$v)},expression:"params.ids"}},_vm._l((_vm.filterServers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":(item.display_server_name || item.server_name) +
                                '（' +
                                item.server_id +
                                '）',"value":item.server_auto_id}})}),1)],1)]),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.params.type === 'range'),expression:"params.type === 'range'"}],attrs:{"label":"选择区服","prop":"range"}},[_c('div',{staticClass:"range-select w400"},[_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","disabled":_vm.params.type === 'all',"placeholder":"请选择"},model:{value:(_vm.params.begin),callback:function ($$v) {_vm.$set(_vm.params, "begin", $$v)},expression:"params.begin"}},_vm._l((_vm.beginServers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":(item.display_server_name || item.server_name) +
                                '（' +
                                item.server_id +
                                '）',"value":item.server_auto_id}})}),1),_vm._v(" "),_c('span',[_vm._v("至")]),_vm._v(" "),_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","disabled":_vm.params.type === 'all',"placeholder":"请选择"},model:{value:(_vm.params.end),callback:function ($$v) {_vm.$set(_vm.params, "end", $$v)},expression:"params.end"}},_vm._l((_vm.endServers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":(item.display_server_name || item.server_name) +
                                '（' +
                                item.server_id +
                                '）',"value":item.server_auto_id}})}),1)],1)]),_vm._v(" "),(_vm.type === 'maintain')?_c('el-form-item',{attrs:{"label":"维护时间","prop":"time"}},[_c('el-date-picker',{attrs:{"type":"datetimerange","align":"right","start-placeholder":"开始日期","end-placeholder":"结束日期","default-time":['12:00:00', '22:00:00']},model:{value:(_vm.params.time),callback:function ($$v) {_vm.$set(_vm.params, "time", $$v)},expression:"params.time"}})],1):(_vm.type === 'open')?_c('el-form-item',{attrs:{"label":"开服时间","prop":"time"}},[_c('el-date-picker',{staticClass:"w400",attrs:{"type":"datetime","align":"right","placeholder":"选择开服时间","default-time":"12:00:00"},model:{value:(_vm.params.time),callback:function ($$v) {_vm.$set(_vm.params, "time", $$v)},expression:"params.time"}})],1):_vm._e(),_vm._v(" "),(_vm.type === 'config')?_c('el-form-item',{attrs:{"label":"数据来源","prop":"data_source"}},[_c('el-radio-group',{on:{"change":_vm.dsChange},model:{value:(_vm.params.data_source),callback:function ($$v) {_vm.$set(_vm.params, "data_source", $$v)},expression:"params.data_source"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v("接口同步")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v("人工编辑")])],1)],1):_vm._e(),_vm._v(" "),(_vm.type === 'config')?_c('el-form-item',{attrs:{"label":"区服类型","prop":"server_type"}},[_c('el-radio-group',{attrs:{"disabled":_vm.params.data_source === 0},model:{value:(_vm.params.server_type),callback:function ($$v) {_vm.$set(_vm.params, "server_type", $$v)},expression:"params.server_type"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("正式")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v("测试")]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v("审核")])],1)],1):_vm._e(),_vm._v(" "),(_vm.type === 'maintain')?_c('el-form-item',{staticClass:"dialog-tips-box",attrs:{"label":"提示"}},[_c('div',[_vm._v("北京时区")])]):(_vm.type === 'open')?_c('div',{staticClass:"dialog-tips-box",staticStyle:{"color":"red","padding-left":"52px","width":"460px"}},[_vm._v("\n            开服时间生效条件："),_c('br'),_vm._v("\n            1. 数据来源为人工编辑时，配置的开服时间会生效"),_c('br'),_vm._v("\n            2.\n            数据来源为接口同步时，但CP同步的数据中没有开服时间，会以配置时间为准\n        ")]):(_vm.type === 'config')?_c('div',{staticClass:"dialog-tips-box",staticStyle:{"color":"red","padding-left":"52px","width":"460px"}},[_vm._v("\n            注：数据来源为接口同步时，会从CP同步区服类型、合服到、开服时间等字段"),_c('br'),_vm._v("\n            数据来源为人工编辑时，区服类型、合服到、开服时间以人工编辑的为准\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.selfVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.submit}},[_vm._v("提 交")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eyoo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "F7Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"server-query"},[_c('el-form',{attrs:{"inline":"","model":_vm.params}},[_c('el-form-item',[_c('div',{staticClass:"range-select"},[_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","placeholder":"服ID"},on:{"change":_vm.change},model:{value:(_vm.params.begin),callback:function ($$v) {_vm.$set(_vm.params, "begin", $$v)},expression:"params.begin"}},_vm._l((_vm.beginServers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":(item.display_server_name || item.server_name) +
                                '（' +
                                item.server_id +
                                '）',"value":item.server_auto_id}})}),1),_vm._v(" "),_c('span',[_vm._v("至")]),_vm._v(" "),_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","placeholder":"服ID"},on:{"change":_vm.change},model:{value:(_vm.params.end),callback:function ($$v) {_vm.$set(_vm.params, "end", $$v)},expression:"params.end"}},_vm._l((_vm.endServers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":(item.display_server_name || item.server_name) +
                                '（' +
                                item.server_id +
                                '）',"value":item.server_auto_id}})}),1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","placeholder":"服展示名称"},on:{"change":_vm.change},model:{value:(_vm.params.name),callback:function ($$v) {_vm.$set(_vm.params, "name", $$v)},expression:"params.name"}},_vm._l((_vm.srcServers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":(item.display_server_name || item.server_name) +
                            '（' +
                            item.server_id +
                            '）',"value":item.server_auto_id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","placeholder":"区服类型"},on:{"change":_vm.change},model:{value:(_vm.params.type),callback:function ($$v) {_vm.$set(_vm.params, "type", $$v)},expression:"params.type"}},[_c('el-option',{attrs:{"label":"正式","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"测试","value":2}}),_vm._v(" "),_c('el-option',{attrs:{"label":"审核","value":3}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"size":"small","filterable":"","clearable":"","placeholder":"区服状态"},on:{"change":_vm.change},model:{value:(_vm.params.status),callback:function ($$v) {_vm.$set(_vm.params, "status", $$v)},expression:"params.status"}},[_c('el-option',{attrs:{"label":"正常","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"维护","value":0}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F8sR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__ = __webpack_require__("aAVc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c77b096_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__ = __webpack_require__("35re");
function injectStyle (ssrContext) {
  __webpack_require__("qkxf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c77b096"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c77b096_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FEZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antiAddiction_configuration__ = __webpack_require__("xoU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cpArgExport__ = __webpack_require__("LKPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__demo__ = __webpack_require__("SDic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gameConfig_PackagePlanManager__ = __webpack_require__("lJ6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gameConfig_activityPageManager__ = __webpack_require__("8/2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gameConfig_baseInfo__ = __webpack_require__("S/4/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gameConfig_commonInfo__ = __webpack_require__("j9ck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gameConfig_server__ = __webpack_require__("VPC1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index__ = __webpack_require__("nYFH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ipBlock__ = __webpack_require__("8EeF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ipBlockView__ = __webpack_require__("AcnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__noAccess__ = __webpack_require__("WfUJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__notfind__ = __webpack_require__("UzzN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__payPackageSetting__ = __webpack_require__("rvp8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__push_PushPlan__ = __webpack_require__("8kzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__push_PushPlanDetail__ = __webpack_require__("4XHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__push_PushPlanManager__ = __webpack_require__("QpaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__push_PushPlanOperate__ = __webpack_require__("qzhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__push_ces__ = __webpack_require__("PXhh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__push_detail__ = __webpack_require__("LM9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__push_operateLoginBanUserList__ = __webpack_require__("YQOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__push_trysend__ = __webpack_require__("vtgs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__query_activityOrderDetail__ = __webpack_require__("Eyoo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__query_activityOrderList__ = __webpack_require__("VUCT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__query_activityOrderResend__ = __webpack_require__("h1Z3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__query_loginList__ = __webpack_require__("xoEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__query_pay__ = __webpack_require__("rpMM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__query_reg__ = __webpack_require__("SDvU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__query_sdkReleaseRecord__ = __webpack_require__("P0b5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__query_terminal__ = __webpack_require__("WW6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__query_user__ = __webpack_require__("85ET");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__recharge_createRechargeCode__ = __webpack_require__("C5Dp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__recharge_pushRechargeCode__ = __webpack_require__("lDZI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__recharge_rechargeCodeList__ = __webpack_require__("Yxl2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__riskManagement_autoBanSetting__ = __webpack_require__("mne3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__riskManagement_detail__ = __webpack_require__("Wtzk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__riskManagement_ipBlock__ = __webpack_require__("I0GJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__riskManagement_ipBlockView__ = __webpack_require__("vfTj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__riskManagement_loginBan__ = __webpack_require__("yCC1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__riskManagement_operateLoginBanUserList__ = __webpack_require__("In2k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__sdk_adjustToken__ = __webpack_require__("y4Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__sdk_configEdit__ = __webpack_require__("Uul0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__sdk_configList__ = __webpack_require__("13Nv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__sdk_dialog__ = __webpack_require__("BLOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__sdk_releasesEdit__ = __webpack_require__("OukJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__sdk_releasesEdit1__ = __webpack_require__("jqB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__sdk_releasesList__ = __webpack_require__("zH1E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__system_sdkVersion__ = __webpack_require__("BAnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__watch_alarmGroup__ = __webpack_require__("tz4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__watch_alarmPolicy__ = __webpack_require__("t0sm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__watch_attendence__ = __webpack_require__("NzMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__watch_daka__ = __webpack_require__("fdrO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__watch_line__ = __webpack_require__("0h8K");






















































/* harmony default export */ __webpack_exports__["a"] = ({
    antiAddictionConfiguration: __WEBPACK_IMPORTED_MODULE_0__antiAddiction_configuration__["a" /* default */],
    cpArgExport: __WEBPACK_IMPORTED_MODULE_1__cpArgExport__["a" /* default */],
    demo: __WEBPACK_IMPORTED_MODULE_2__demo__["a" /* default */],
    gameConfigPackagePlanManager: __WEBPACK_IMPORTED_MODULE_3__gameConfig_PackagePlanManager__["a" /* default */],
    gameConfigActivityPageManager: __WEBPACK_IMPORTED_MODULE_4__gameConfig_activityPageManager__["a" /* default */],
    gameConfigBaseInfo: __WEBPACK_IMPORTED_MODULE_5__gameConfig_baseInfo__["a" /* default */],
    gameConfigCommonInfo: __WEBPACK_IMPORTED_MODULE_6__gameConfig_commonInfo__["a" /* default */],
    gameConfigServer: __WEBPACK_IMPORTED_MODULE_7__gameConfig_server__["a" /* default */],
    index: __WEBPACK_IMPORTED_MODULE_8__index__["a" /* default */],
    ipBlock: __WEBPACK_IMPORTED_MODULE_9__ipBlock__["a" /* default */],
    ipBlockView: __WEBPACK_IMPORTED_MODULE_10__ipBlockView__["a" /* default */],
    noAccess: __WEBPACK_IMPORTED_MODULE_11__noAccess__["a" /* default */],
    notfind: __WEBPACK_IMPORTED_MODULE_12__notfind__["a" /* default */],
    payPackageSetting: __WEBPACK_IMPORTED_MODULE_13__payPackageSetting__["a" /* default */],
    pushPushPlan: __WEBPACK_IMPORTED_MODULE_14__push_PushPlan__["a" /* default */],
    pushPushPlanDetail: __WEBPACK_IMPORTED_MODULE_15__push_PushPlanDetail__["a" /* default */],
    pushPushPlanManager: __WEBPACK_IMPORTED_MODULE_16__push_PushPlanManager__["a" /* default */],
    pushPushPlanOperate: __WEBPACK_IMPORTED_MODULE_17__push_PushPlanOperate__["a" /* default */],
    pushCes: __WEBPACK_IMPORTED_MODULE_18__push_ces__["a" /* default */],
    pushDetail: __WEBPACK_IMPORTED_MODULE_19__push_detail__["a" /* default */],
    pushOperateLoginBanUserList: __WEBPACK_IMPORTED_MODULE_20__push_operateLoginBanUserList__["a" /* default */],
    pushTrysend: __WEBPACK_IMPORTED_MODULE_21__push_trysend__["a" /* default */],
    queryActivityOrderDetail: __WEBPACK_IMPORTED_MODULE_22__query_activityOrderDetail__["a" /* default */],
    queryActivityOrderList: __WEBPACK_IMPORTED_MODULE_23__query_activityOrderList__["a" /* default */],
    queryActivityOrderResend: __WEBPACK_IMPORTED_MODULE_24__query_activityOrderResend__["a" /* default */],
    queryLoginList: __WEBPACK_IMPORTED_MODULE_25__query_loginList__["a" /* default */],
    queryPay: __WEBPACK_IMPORTED_MODULE_26__query_pay__["a" /* default */],
    queryReg: __WEBPACK_IMPORTED_MODULE_27__query_reg__["a" /* default */],
    querySdkReleaseRecord: __WEBPACK_IMPORTED_MODULE_28__query_sdkReleaseRecord__["a" /* default */],
    queryTerminal: __WEBPACK_IMPORTED_MODULE_29__query_terminal__["a" /* default */],
    queryUser: __WEBPACK_IMPORTED_MODULE_30__query_user__["a" /* default */],
    rechargeCreateRechargeCode: __WEBPACK_IMPORTED_MODULE_31__recharge_createRechargeCode__["a" /* default */],
    rechargePushRechargeCode: __WEBPACK_IMPORTED_MODULE_32__recharge_pushRechargeCode__["a" /* default */],
    rechargeRechargeCodeList: __WEBPACK_IMPORTED_MODULE_33__recharge_rechargeCodeList__["a" /* default */],
    riskManagementAutoBanSetting: __WEBPACK_IMPORTED_MODULE_34__riskManagement_autoBanSetting__["a" /* default */],
    riskManagementDetail: __WEBPACK_IMPORTED_MODULE_35__riskManagement_detail__["a" /* default */],
    riskManagementIpBlock: __WEBPACK_IMPORTED_MODULE_36__riskManagement_ipBlock__["a" /* default */],
    riskManagementIpBlockView: __WEBPACK_IMPORTED_MODULE_37__riskManagement_ipBlockView__["a" /* default */],
    riskManagementLoginBan: __WEBPACK_IMPORTED_MODULE_38__riskManagement_loginBan__["a" /* default */],
    riskManagementOperateLoginBanUserList: __WEBPACK_IMPORTED_MODULE_39__riskManagement_operateLoginBanUserList__["a" /* default */],
    sdkAdjustToken: __WEBPACK_IMPORTED_MODULE_40__sdk_adjustToken__["a" /* default */],
    sdkConfigEdit: __WEBPACK_IMPORTED_MODULE_41__sdk_configEdit__["a" /* default */],
    sdkConfigList: __WEBPACK_IMPORTED_MODULE_42__sdk_configList__["a" /* default */],
    sdkDialog: __WEBPACK_IMPORTED_MODULE_43__sdk_dialog__["a" /* default */],
    sdkReleasesEdit: __WEBPACK_IMPORTED_MODULE_44__sdk_releasesEdit__["a" /* default */],
    sdkReleasesEdit1: __WEBPACK_IMPORTED_MODULE_45__sdk_releasesEdit1__["a" /* default */],
    sdkReleasesList: __WEBPACK_IMPORTED_MODULE_46__sdk_releasesList__["a" /* default */],
    systemSdkVersion: __WEBPACK_IMPORTED_MODULE_47__system_sdkVersion__["a" /* default */],
    watchAlarmGroup: __WEBPACK_IMPORTED_MODULE_48__watch_alarmGroup__["a" /* default */],
    watchAlarmPolicy: __WEBPACK_IMPORTED_MODULE_49__watch_alarmPolicy__["a" /* default */],
    watchAttendence: __WEBPACK_IMPORTED_MODULE_50__watch_attendence__["a" /* default */],
    watchDaka: __WEBPACK_IMPORTED_MODULE_51__watch_daka__["a" /* default */],
    watchLine: __WEBPACK_IMPORTED_MODULE_52__watch_line__["a" /* default */]
});

/***/ }),

/***/ "FNTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config"},[_c('el-card',{staticClass:"config-card-box"},[_c('el-form',{ref:"form",attrs:{"model":_vm.params,"rules":_vm.configRules}},[_c('basis-config',{attrs:{"params":_vm.params,"is_configured":_vm.is_configured}}),_vm._v(" "),_c('no-identified',{attrs:{"params":_vm.params,"is_configured":_vm.is_configured}}),_vm._v(" "),_c('h3',[_vm._v("3.已认证玩家配置\n\n                "),_c('el-tooltip',{attrs:{"placement":"top","content":"年龄配置规则：配置年龄范围是包含开始年龄，不包含结束年龄的。"}},[_c('i',{staticClass:"el-icon-question"})])],1),_vm._v(" "),(_vm.is_configured)?_c('el-collapse',{model:{value:(_vm.params.names),callback:function ($$v) {_vm.$set(_vm.params, "names", $$v)},expression:"params.names"}},_vm._l((_vm.params.identified_user_rules),function(item,i){return _c('el-collapse-item',{key:'identified_user_rules'+i,attrs:{"name":i}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex title-change-btn"},[_c('div',{staticStyle:{"padding-left":"15px"}},[_vm._v("\n                                年龄：\n\n\n                                "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.age_from',"rules":{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }}},[_c('el-select',{attrs:{"size":"mini"},on:{"change":function($event){return _vm.changeAgeFrom($event, item)}},model:{value:(item.age_from),callback:function ($$v) {_vm.$set(item, "age_from", $$v)},expression:"item.age_from"}},_vm._l((26),function(_,key){return _c('el-option',{key:_,attrs:{"disabled":i > 0 && key < _vm.params.identified_user_rules[i-1].age_to,"value":key,"label":key+'岁'}})}),1)],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.age_to',"rules":{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }}},[_c('el-select',{attrs:{"size":"mini"},model:{value:(item.age_to),callback:function ($$v) {_vm.$set(item, "age_to", $$v)},expression:"item.age_to"}},[_vm._l((25),function(i){return _c('el-option',{key:i,attrs:{"disabled":item.age_from > 0 && i <= item.age_from,"value":i,"label":i+'岁'}})}),_vm._v(" "),_c('el-option',{attrs:{"label":"26岁及以上","value":150}})],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"margin-right":"15px"}},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-circle-plus-outline","size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.handleAddAgeRange($event)}}}),_vm._v(" "),(i)?_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete","size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.handleDeleteAgeRange(i)}}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"border-card mar-t-0"},[_c('el-form-item',{attrs:{"label":"限制类型：","prop":'identified_user_rules.' + i + '.limit_type',"rules":{
                                required: true, message: ' ', trigger: ['blur', 'change']
                            }}},[_c('el-checkbox-group',{model:{value:(item.limit_type),callback:function ($$v) {_vm.$set(item, "limit_type", $$v)},expression:"item.limit_type"}},[_c('el-checkbox',{attrs:{"label":1}},[_vm._v("登录限制")]),_vm._v(" "),_c('el-checkbox',{attrs:{"label":2}},[_vm._v("消费限制")])],1)],1),_vm._v(" "),(item.limit_type.indexOf(1) > -1)?[_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"节假日登录限制："}}),_vm._v(" "),_vm._l((item.login_rule.holiday.rules),function(timeRange,timeIndex){return _c('div',{key:'timeRange'+ timeIndex},[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.date_type',"rules":{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }}},[_c('el-select',{attrs:{"size":"mini"},on:{"visible-change":function($event){return _vm.changeTimeRange($event, item,'holiday')}},model:{value:(timeRange.date_type),callback:function ($$v) {_vm.$set(timeRange, "date_type", $$v)},expression:"timeRange.date_type"}},_vm._l((item.login_rule.holiday.changeTimeOptions),function(obj,index){return _c('el-option',{key:'change_time_option' + index,attrs:{"label":obj.label,"value":obj.value,"disabled":obj.disable}})}),1)],1),_vm._v(" "),(timeRange.date_type === 1)?[_vm._v("\n                                    当天累计登陆上限\n\n\n                                    "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.daily_max_game_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"precision":0,"controls":false},model:{value:(timeRange.daily_max_game_time),callback:function ($$v) {_vm.$set(timeRange, "daily_max_game_time", $$v)},expression:"timeRange.daily_max_game_time"}})],1),_vm._v("\n                                    min\n\n\n                                ")]:(timeRange.date_type === 2)?[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.start_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"起始时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end:    timeRange.end_time ? timeRange.end_time : '24:00',
                                            maxTime: timeRange.end_time
                                        }},model:{value:(timeRange.start_time),callback:function ($$v) {_vm.$set(timeRange, "start_time", $$v)},expression:"timeRange.start_time"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.end_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"结束时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00',
                                            minTime: timeRange.start_time
                                        }},model:{value:(timeRange.end_time),callback:function ($$v) {_vm.$set(timeRange, "end_time", $$v)},expression:"timeRange.end_time"}})],1),_vm._v("\n                                    强制玩家离线\n\n\n                                ")]:(timeRange.date_type === 3)?[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.start_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"起始时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end:    timeRange.end_time ? timeRange.end_time : '24:00',
                                            maxTime: timeRange.end_time
                                        }},model:{value:(timeRange.start_time),callback:function ($$v) {_vm.$set(timeRange, "start_time", $$v)},expression:"timeRange.start_time"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.end_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"结束时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00',
                                            minTime: timeRange.start_time
                                        }},model:{value:(timeRange.end_time),callback:function ($$v) {_vm.$set(timeRange, "end_time", $$v)},expression:"timeRange.end_time"}})],1),_vm._v("\n                                    玩家可以登陆\n\n\n                                ")]:_vm._e(),_vm._v(" "),_c('i',{staticClass:"el-icon-circle-plus-outline",on:{"click":function($event){return _vm.handleAddTimeRange(item,'holiday')}}}),_vm._v(" "),(timeIndex)?_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.handleDeleteTimeRange(item, timeIndex,'holiday')}}}):_vm._e()],2)}),_vm._v(" "),_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"非节假日（周五）登录限制："}}),_vm._v(" "),_vm._l((item.login_rule.work_day_special.rules),function(timeRangeSpecial,timeIndex){return _c('div',{key:'timeRangeSpecial'+ timeIndex},[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.date_type',"rules":{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }}},[_c('el-select',{attrs:{"size":"mini"},on:{"visible-change":function($event){return _vm.changeTimeRange($event, item,'work_day_special')}},model:{value:(timeRangeSpecial.date_type),callback:function ($$v) {_vm.$set(timeRangeSpecial, "date_type", $$v)},expression:"timeRangeSpecial.date_type"}},_vm._l((item.login_rule.work_day_special.changeTimeOptions),function(obj,index){return _c('el-option',{key:'change_time_option' + index,attrs:{"label":obj.label,"value":obj.value,"disabled":obj.disable}})}),1)],1),_vm._v(" "),(timeRangeSpecial.date_type === 1)?[_vm._v("\n                                    当天累计登陆上限\n\n\n                                    "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.daily_max_game_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"precision":0,"controls":false},model:{value:(timeRangeSpecial.daily_max_game_time),callback:function ($$v) {_vm.$set(timeRangeSpecial, "daily_max_game_time", $$v)},expression:"timeRangeSpecial.daily_max_game_time"}})],1),_vm._v("\n                                    min\n\n\n                                ")]:(timeRangeSpecial.date_type === 2)?[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.start_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"起始时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end:    timeRangeSpecial.end_time ? timeRangeSpecial.end_time : '24:00',
                                            maxTime: timeRangeSpecial.end_time
                                        }},model:{value:(timeRangeSpecial.start_time),callback:function ($$v) {_vm.$set(timeRangeSpecial, "start_time", $$v)},expression:"timeRangeSpecial.start_time"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.end_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"结束时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00',
                                            minTime: timeRangeSpecial.start_time
                                        }},model:{value:(timeRangeSpecial.end_time),callback:function ($$v) {_vm.$set(timeRangeSpecial, "end_time", $$v)},expression:"timeRangeSpecial.end_time"}})],1),_vm._v("\n                                    强制玩家离线\n\n\n                                ")]:(timeRangeSpecial.date_type === 3)?[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.start_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"起始时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end:    timeRangeSpecial.end_time ? timeRangeSpecial.end_time : '24:00',
                                            maxTime: timeRangeSpecial.end_time
                                        }},model:{value:(timeRangeSpecial.start_time),callback:function ($$v) {_vm.$set(timeRangeSpecial, "start_time", $$v)},expression:"timeRangeSpecial.start_time"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.end_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"结束时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00',
                                            minTime: timeRangeSpecial.start_time
                                        }},model:{value:(timeRangeSpecial.end_time),callback:function ($$v) {_vm.$set(timeRangeSpecial, "end_time", $$v)},expression:"timeRangeSpecial.end_time"}})],1),_vm._v("\n                                    玩家可以登陆\n\n\n                                ")]:_vm._e(),_vm._v(" "),_c('i',{staticClass:"el-icon-circle-plus-outline",on:{"click":function($event){return _vm.handleAddTimeRange(item,'work_day_special')}}}),_vm._v(" "),(timeIndex)?_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.handleDeleteTimeRange(item, timeIndex,'work_day_special')}}}):_vm._e()],2)}),_vm._v(" "),_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"非节假日（非周五）登录限制："}}),_vm._v(" "),_vm._l((item.login_rule.work_day_normal.rules),function(timeRangeNormal,timeIndex){return _c('div',{key:'timeRangeNormal'+ timeIndex},[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.date_type',"rules":{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }}},[_c('el-select',{attrs:{"size":"mini"},on:{"visible-change":function($event){return _vm.changeTimeRange($event, item,'work_day_normal')}},model:{value:(timeRangeNormal.date_type),callback:function ($$v) {_vm.$set(timeRangeNormal, "date_type", $$v)},expression:"timeRangeNormal.date_type"}},_vm._l((item.login_rule.work_day_normal.changeTimeOptions),function(obj,index){return _c('el-option',{key:'change_time_option' + index,attrs:{"label":obj.label,"value":obj.value,"disabled":obj.disable}})}),1)],1),_vm._v(" "),(timeRangeNormal.date_type === 1)?[_vm._v("\n                                    当天累计登陆上限\n\n\n                                    "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.daily_max_game_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"precision":0,"controls":false},model:{value:(timeRangeNormal.daily_max_game_time),callback:function ($$v) {_vm.$set(timeRangeNormal, "daily_max_game_time", $$v)},expression:"timeRangeNormal.daily_max_game_time"}})],1),_vm._v("\n                                    min\n\n\n                                ")]:(timeRangeNormal.date_type === 2)?[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.start_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"起始时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end:    timeRangeNormal.end_time ? timeRangeNormal.end_time : '24:00',
                                            maxTime: timeRangeNormal.end_time
                                        }},model:{value:(timeRangeNormal.start_time),callback:function ($$v) {_vm.$set(timeRangeNormal, "start_time", $$v)},expression:"timeRangeNormal.start_time"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.end_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"结束时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00',
                                            minTime: timeRangeNormal.start_time
                                        }},model:{value:(timeRangeNormal.end_time),callback:function ($$v) {_vm.$set(timeRangeNormal, "end_time", $$v)},expression:"timeRangeNormal.end_time"}})],1),_vm._v("\n                                    强制玩家离线\n\n\n                                ")]:(timeRangeNormal.date_type === 3)?[_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.start_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"起始时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end:    timeRangeNormal.end_time ? timeRangeNormal.end_time : '24:00',
                                            maxTime: timeRangeNormal.end_time
                                        }},model:{value:(timeRangeNormal.start_time),callback:function ($$v) {_vm.$set(timeRangeNormal, "start_time", $$v)},expression:"timeRangeNormal.start_time"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 8px"}},[_vm._v("至")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-inline",attrs:{"prop":'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.end_time',"rules":{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }}},[_c('el-time-select',{staticClass:"w120",attrs:{"placeholder":"结束时间","size":"mini","picker-options":{
                                            start: '00:00',
                                            step: '00:15',
                                            end: '24:00',
                                            minTime: timeRangeNormal.start_time
                                        }},model:{value:(timeRangeNormal.end_time),callback:function ($$v) {_vm.$set(timeRangeNormal, "end_time", $$v)},expression:"timeRangeNormal.end_time"}})],1),_vm._v("\n                                    玩家可以登陆\n\n\n                                ")]:_vm._e(),_vm._v(" "),_c('i',{staticClass:"el-icon-circle-plus-outline",on:{"click":function($event){return _vm.handleAddTimeRange(item,'work_day_normal')}}}),_vm._v(" "),(timeIndex)?_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){return _vm.handleDeleteTimeRange(item, timeIndex,'work_day_normal')}}}):_vm._e()],2)})]:_vm._e(),_vm._v(" "),(item.limit_type.indexOf(2) > -1)?[_c('el-form-item',{staticClass:"greenitem",attrs:{"label":"消费限制："}}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"单笔单次消费上限金额：","prop":'identified_user_rules.' + i + '.payment_rule.max_consume_per_order',"rules":{
                                    required: true, message: ' ', trigger: ['blur', 'change']
                                }}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"precision":2,"controls":false},model:{value:(item.payment_rule.max_consume_per_order),callback:function ($$v) {_vm.$set(item.payment_rule, "max_consume_per_order", $$v)},expression:"item.payment_rule.max_consume_per_order"}}),_vm._v("\n                                RMB\n\n\n                            ")],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"单月累计消费上限金额：","prop":'identified_user_rules.' + i + '.payment_rule.max_consume_per_month',"rules":{
                                    required: true, message: ' ', trigger: ['blur', 'change']
                                }}},[_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"precision":2,"controls":false},model:{value:(item.payment_rule.max_consume_per_month),callback:function ($$v) {_vm.$set(item.payment_rule, "max_consume_per_month", $$v)},expression:"item.payment_rule.max_consume_per_month"}}),_vm._v("\n                                RMB\n\n\n                            ")],1)]:_vm._e()],2)],2)}),1):_c('identified',{attrs:{"params":_vm.params}})],1),_vm._v(" "),(!_vm.goToConfigure)?[(_vm.is_configured)?_c('div',{staticClass:"submit-btn-box"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.submit}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":function($event){return _vm.initAntiAddictionConfig(false)}}},[_vm._v("取消")])],1):_c('div',{staticClass:"submit-btn-box"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.initAntiAddictionConfig(true)}}},[_vm._v("编辑")])],1)]:(_vm.isConfigBtn)?_c('div',{staticClass:"submit-btn-box"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.openConfig}},[_vm._v("去配置")])],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FTdV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/third_pay_page_google_style.8068a80.png";

/***/ }),

/***/ "FUZH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "InputTrim",
    data: function data() {
        return {
            model: ""
        };
    },


    props: {
        placeholder: {
            type: String,
            required: false
        },
        value: {
            type: [String, Number],
            default: ""
        },
        type: {
            type: String,
            default: ""
        },
        rows: {
            type: Number,
            default: 5
        },
        size: {
            type: String,
            default: 'medium'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler: function handler(val) {
                this.model = val;
            },

            immediate: true
        },
        model: {
            handler: function handler(val) {
                this.$emit("input", val);
            }
        }
    },
    methods: {
        trimValue: function trimValue() {
            this.model = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["trim"])(this.model);
        },
        keyUpEnter: function keyUpEnter() {
            this.$emit("keyUpEnter");
        }
    }
});

/***/ }),

/***/ "Fedn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/android-landscape.66e1747.png";

/***/ }),

/***/ "FrMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"mar-t-0"},[_vm._v("1.基础配置")]),_vm._v(" "),_c('div',{staticClass:"border-card"},[_c('el-form-item',{staticClass:"basis-config-item",attrs:{"label":"即将离线提示时间","prop":"force_offline_notice_before_minutes"}},[_c('span',{staticClass:"span-pad"},[_vm._v("：")]),_vm._v("\n                离线前\n                "),(_vm.is_configured)?_c('el-input-number',{staticClass:"w70",attrs:{"size":"mini","min":0,"max":60,"controls":false,"precision":0},model:{value:(_vm.params.force_offline_notice_before_minutes),callback:function ($$v) {_vm.$set(_vm.params, "force_offline_notice_before_minutes", $$v)},expression:"params.force_offline_notice_before_minutes"}}):_c('span',[_vm._v(_vm._s(_vm.params.force_offline_notice_before_minutes))]),_vm._v("\n                min，弹窗提示玩家即将离线\n            ")],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GK8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputTrim__ = __webpack_require__("H/Bd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ServerDialog__ = __webpack_require__("9tRj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ServerQuery__ = __webpack_require__("+IjS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__antiAddiction_basisConfig__ = __webpack_require__("W8tW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__antiAddiction_configuration__ = __webpack_require__("wlS+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antiAddiction_identified__ = __webpack_require__("Spbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antiAddiction_noIdentified__ = __webpack_require__("4chI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aside__ = __webpack_require__("y42g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__game_apiinfo__ = __webpack_require__("9DvW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__header__ = __webpack_require__("gGMy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout__ = __webpack_require__("hr8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__push_PushContainer__ = __webpack_require__("aBAJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__push_PushDeviceFilter__ = __webpack_require__("W7bp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__push_PushNoticeSubscribe__ = __webpack_require__("7TQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__push_PushScheme__ = __webpack_require__("a0N4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__push_PushTimes__ = __webpack_require__("uK2n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__push_SelectUsers__ = __webpack_require__("3myU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__recharge_detail__ = __webpack_require__("F8sR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sdk_SearchDimension__ = __webpack_require__("UVGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sdk_SetContentAllowed__ = __webpack_require__("CCe3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__sdk_SetIdfaAllowed__ = __webpack_require__("jb01");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sdk_SetLoginAllowed__ = __webpack_require__("y6Tu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sdk_SetPageStyle__ = __webpack_require__("OH8Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sdk_SetPay__ = __webpack_require__("IIt4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sdk_style_DiyTitle__ = __webpack_require__("9yFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sdkUpload__ = __webpack_require__("uhd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__server__ = __webpack_require__("0ZdU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__simpleSearchData__ = __webpack_require__("uEHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__system_list__ = __webpack_require__("R5Gv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__system_search__ = __webpack_require__("Ve3m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__watch_frame__ = __webpack_require__("gNKz");

































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-inputtrim', __WEBPACK_IMPORTED_MODULE_1__InputTrim__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-serverdialog', __WEBPACK_IMPORTED_MODULE_2__ServerDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-serverquery', __WEBPACK_IMPORTED_MODULE_3__ServerQuery__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-antiaddiction-basisconfig', __WEBPACK_IMPORTED_MODULE_4__antiAddiction_basisConfig__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-antiaddiction-configuration', __WEBPACK_IMPORTED_MODULE_5__antiAddiction_configuration__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-antiaddiction-identified', __WEBPACK_IMPORTED_MODULE_6__antiAddiction_identified__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-antiaddiction-noidentified', __WEBPACK_IMPORTED_MODULE_7__antiAddiction_noIdentified__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-aside', __WEBPACK_IMPORTED_MODULE_8__aside__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-game-apiinfo', __WEBPACK_IMPORTED_MODULE_9__game_apiinfo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-header', __WEBPACK_IMPORTED_MODULE_10__header__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('layout', __WEBPACK_IMPORTED_MODULE_11__layout__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-push-pushcontainer', __WEBPACK_IMPORTED_MODULE_12__push_PushContainer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-push-pushdevicefilter', __WEBPACK_IMPORTED_MODULE_13__push_PushDeviceFilter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-push-pushnoticesubscribe', __WEBPACK_IMPORTED_MODULE_14__push_PushNoticeSubscribe__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-push-pushscheme', __WEBPACK_IMPORTED_MODULE_15__push_PushScheme__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-push-pushtimes', __WEBPACK_IMPORTED_MODULE_16__push_PushTimes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-push-selectusers', __WEBPACK_IMPORTED_MODULE_17__push_SelectUsers__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-recharge-detail', __WEBPACK_IMPORTED_MODULE_18__recharge_detail__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-searchdimension', __WEBPACK_IMPORTED_MODULE_19__sdk_SearchDimension__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-setcontentallowed', __WEBPACK_IMPORTED_MODULE_20__sdk_SetContentAllowed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-setidfaallowed', __WEBPACK_IMPORTED_MODULE_21__sdk_SetIdfaAllowed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-setloginallowed', __WEBPACK_IMPORTED_MODULE_22__sdk_SetLoginAllowed__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-setpagestyle', __WEBPACK_IMPORTED_MODULE_23__sdk_SetPageStyle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-setpay', __WEBPACK_IMPORTED_MODULE_24__sdk_SetPay__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdk-style-diytitle', __WEBPACK_IMPORTED_MODULE_25__sdk_style_DiyTitle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-sdkupload', __WEBPACK_IMPORTED_MODULE_26__sdkUpload__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-server', __WEBPACK_IMPORTED_MODULE_27__server__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-simplesearchdata', __WEBPACK_IMPORTED_MODULE_28__simpleSearchData__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-system-list', __WEBPACK_IMPORTED_MODULE_29__system_list__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-system-search', __WEBPACK_IMPORTED_MODULE_30__system_search__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-watch-frame', __WEBPACK_IMPORTED_MODULE_31__watch_frame__["a" /* default */]);

/***/ }),

/***/ "Gp8K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/login-phone-email.b885a23.png";

/***/ }),

/***/ "H/Bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTrim_vue__ = __webpack_require__("FUZH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307d5e82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTrim_vue__ = __webpack_require__("tymY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTrim_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_307d5e82_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTrim_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HAIV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HBXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
//导出例子
// var fileName = '员工信息' + data.now + '.xlsx',
//     exportData = [];
// var tableHead = [
//     '员工编号',
//     '邮箱',
//     '姓名',
//     '电话',
//     '部门',
//     '直属上级',
//     '入职日期',
//     '参加工作日期',
//     '正式合同起始日期',
//     '离职日期',
//     '实习/兼职',
//     '在职/离职',
//     '状态'
// ]
// exportData.push(tableHead);
// data.totalUsers.forEach(function(item) {
//     exportData.push([
//         item.company_id,
//         item.email,
//         item.name,
//         item.tel,
//         item.team_name,
//         item.supervisor_name,
//         item.date_started,
//         item.date_graduated,
//         item.date_joined,
//         item.date_quit,
//         item.internship_name,
//         item.job_name,
//         item.enabled_name
//     ])
// });
// save(fileName, exportData);



var s2ab = function s2ab(s) {
    var buf = void 0;
    if (typeof ArrayBuffer !== 'undefined') {
        buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF;
        }
    } else {
        buf = new Array(s.length);
        for (var _i = 0; _i != s.length; ++_i) {
            buf[_i] = s.charCodeAt(_i) & 0xFF;
        }
    }
    return buf;
};

var xlsHaddle = {
    dataSave: function dataSave(name, data) {
        var wb = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.book_new(),
            st = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.aoa_to_sheet(data);

        wb.SheetNames.push('sheet1');
        wb.Sheets['sheet1'] = st;

        var wbout = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
        try {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_file_saver__["saveAs"])(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), name);
        } catch (e) {
            console.log(e, wbout);
        }
        return wbout;
    },
    tableSave: function tableSave(element) {
        if (element.indexOf('#') !== -1) {
            var str = element.slice(1);
            element = document.getElementById(str);
            if (element.length === 0) {
                console.error('请传入表单id');
                return;
            }
        } else if (element.indexOf('.') !== -1) {
            var _str = element.slice(1);
            element = document.getElementsByClassName(_str);
            if (element.length > 1 || element.length === 0) {
                console.error('传入的表必须是唯一');
                return;
            } else {
                element = element[0];
            }
        }

        var et = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.table_to_book(element); //此处传入table的DOM节点
        var etout = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.write(et, {
            bookType: 'xlsx',
            bookSST: true,
            type: 'array'
        });
        try {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_file_saver__["saveAs"])(new Blob([etout], {
                type: 'application/octet-stream'
            }), 'trade-publish.xlsx'); //trade-publish.xlsx 为导出的文件名
        } catch (e) {
            console.log(e, etout);
        }
        return etout;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (xlsHaddle);

/***/ }),

/***/ "HMcL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sub-system-search',
    props: ['type'],
    data: function data() {
        return {
            form: {
                version: '',
                detail: ''
            }

        };
    },

    components: {},
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment', '$route'])),

    created: function created() {},


    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['ALERT_HANDLE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('systemSdkVersion', ['ADD_BASE_VERSION']), {
        onSubmit: function onSubmit() {
            var reg = /^[0-9\.]{2,}$/;

            if (!this.$helper.helper.tirm(this.form.version)) {
                this.ALERT_HANDLE({ message: '版本号不能为空！例如: 5.2.0' });
                return false;
            }

            if (!this.$helper.helper.tirm(this.form.detail)) {
                this.ALERT_HANDLE({ message: '版本描述不能为空！' });
                return false;
            }

            if (!reg.test(this.form.version)) {
                this.ALERT_HANDLE({ message: '版本号只能包含数字和点，例如: 5.2.0' });
                return false;
            }

            this.ADD_BASE_VERSION({ data: this.form, platform: this.type });
        }
    })
});

/***/ }),

/***/ "HxKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__("zNUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);


var Random = __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.Random;
/**
 * 获取封禁列表
 */
__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock('https://udp.oaslab.net/v6/login_ban/list?game_code=aaen', function () {
    return __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock({
        'result|50': [{
            "type": "uid",
            "player_id": /\d{11}/,
            'device_id': __WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock('@word'),
            "status|1-0": 1,
            'expired_time': Random.date('yyyy-MM-dd'),
            "operation_type|1-2": 1,
            "operate": "@CNAME",
            "updated_time": Random.date('yyyy-MM-dd'),
            "allow_auto_process|0-1": 1,
            "game_code": "mtester",
            'logs': [],
            'note': '备注备注备注备注备注',
            'record_id': Random.increment()
        }]
    });
});

/***/ }),

/***/ "I0GJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "IIXg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/forum.af784f6.png";

/***/ }),

/***/ "IIt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetPay_vue__ = __webpack_require__("/z1W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ee1f65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetPay_vue__ = __webpack_require__("rMe+");
function injectStyle (ssrContext) {
  __webpack_require__("jfVJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73ee1f65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetPay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ee1f65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetPay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "In2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "J1Q6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JFiu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jp+H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/ios-portrait.5bc3e32.png";

/***/ }),

/***/ "Kapi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-menu-box"},[(_vm.$isaccess)?_c('el-col',_vm._l((_vm.filterMaps),function(item,key){return _c('el-menu',{key:key,staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.activeHandle(item, key),"collapse-transition":false},on:{"open":_vm.handleOpen,"close":_vm.handleClose,"select":_vm.subMenuSelected}},[(item.children)?_c('el-submenu',{staticClass:"el-menu-item-has-parent",attrs:{"index":key}},[_c('template',{slot:"title"},[_c('i',{class:("left-menu-icon iconfont " + (item.icon))}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_vm._l((item.children),function(subItem,subkey){return [(subItem.active === subkey)?_c('el-menu-item',{key:subkey,staticClass:"el-menu-item-has-children",attrs:{"index":(key + "-" + (subItem.active))}},[_c('a',{attrs:{"href":subItem.link + _vm.urlParams}},[_c('i',{staticClass:"el-icon-custom el-icon-tickets"}),_vm._v("\n                            "+_vm._s(subItem.title)+"\n                        ")]),_vm._v(" "),_c('a',{attrs:{"href":subItem.link + _vm.urlParams,"target":"_blank"}},[_c('i',{staticClass:"el-icon-plus"})])]):_vm._e()]})],2):_c('el-menu-item',{staticClass:"el-menu-item-no-children",attrs:{"index":key}},[_c('a',{attrs:{"href":item.link + _vm.urlParams}},[_c('i',{class:("left-menu-icon iconfont " + (item.icon))}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.title)}})])])],1)}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kcpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


/**
 * Created by shiyonggao on 2019/11/28.
 */
var tips = {
    operateSuccessMsg: '操作成功！',
    title: '提示'
};

var message = function () {
    function message() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, message);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(message, [{
        key: 'message',


        /***
         * 操作成功
         */
        value: function message(args, _ref) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch,
                rootState = _ref.rootState;

            var message = args.message ? args.message : tips.operateSuccessMsg;
            var options = {
                message: message,
                onClose: function onClose() {
                    commit('PRIVATE_LOADING', false, { root: true });

                    /**回调方法**/
                    if (typeof args.callback === 'function') {
                        args.callback(args);
                    }
                    /**自动刷新**/
                    if (args.reload) {
                        window.location.href = window.location.href;
                    }
                }
            };
            rootState.$vue.$message(options);
        }

        /***
         * 操作成功
         */

    }, {
        key: 'alert',
        value: function alert(args, _ref2) {
            var state = _ref2.state,
                commit = _ref2.commit,
                dispatch = _ref2.dispatch,
                rootState = _ref2.rootState;

            var message = args.message ? args.message : tips.operateSuccessMsg;
            var reload = args.reload !== undefined ? args.reload : false;
            var options = {
                callback: function callback() {
                    commit('PRIVATE_LOADING', false, { root: true });

                    /**回调方法**/
                    if (typeof args.callback === 'function') {
                        args.callback(args);
                    }
                    /**自动刷新**/
                    if (args.reload) {
                        window.location.href = window.location.href;
                    }
                }
            };
            rootState.$vue.$alert(message, tips.title, options);
        }
    }]);

    return message;
}();

/* harmony default export */ __webpack_exports__["a"] = (new message());

/***/ }),

/***/ "KpjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "identified",
    props: {
        params: {
            type: Object,
            default: function _default() {}
        }
    },
    methods: {
        randerLabel: function randerLabel(type) {
            switch (type) {
                case 1:
                    return '累计可玩时长：';
                case 2:
                    return '指定时间不可登陆：';
                case 3:
                    return '指定时间可登陆：';
            }
        }
    }
});

/***/ }),

/***/ "Kz2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'push-scheme',
    data: function data() {
        return {
            pushSchemeForm: {
                push_plan_name: ''
            }
        };
    },

    props: ['isDetail', 'isCopy'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('pushPushPlanOperate', ['data'])),
    watch: {
        data: {
            handler: function handler() {
                if (this.data.push_plan_name) {
                    this.pushSchemeForm.push_plan_name = this.isCopy ? 'copy of ' + this.data.push_plan_name : this.data.push_plan_name;
                }
            },

            deep: true
        }
    },
    methods: {
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this.$emit('submit', _this.pushSchemeForm, 'scheme');
                }
            });
        }
    }
});

/***/ }),

/***/ "L8+Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/third_pay_page_default_style.b2c340f.png";

/***/ }),

/***/ "LBD4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'push-times',
    data: function data() {
        return {
            pushTimesForm: {
                time: ''
            },
            tableData: [],
            formRule: {
                time: [{
                    required: true, message: ' ', trigger: ['blur', 'change']
                }]
            },
            pickerOptions: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$moment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('pushPushPlanOperate', ['data'])),
    props: ['isDetail', 'isCopy'],
    watch: {
        data: {
            handler: function handler() {
                var _this = this;

                if (Array.isArray(this.data.send_time_list) && this.data.send_time_list.length) {
                    this.tableData = this.data.send_time_list.map(function (item) {
                        return {
                            send_time: _this.$moment(item.send_time, 'X').format('YYYY-MM-DD HH:mm'),
                            week_day: week[_this.$moment(item.send_time, 'X').day()],
                            send_status: item.send_status ? '已推送' : '未推送',
                            send_number: item.send_number ? item.send_number : '--'
                        };
                    });
                    if (this.isCopy) {
                        this.tableData = this.tableData.filter(function (item) {
                            return item.send_status !== '已推送';
                        });
                    }
                }
            },

            deep: true
        }
    },
    methods: {
        handlerNext: function handlerNext() {
            var _this2 = this;

            var times = this.tableData.map(function (item) {
                return _this2.$moment(item.send_time).unix();
            });
            if (!times.length) {
                this.$alert('请添加推送时间！');
                return;
            }
            this.$emit('submit', { time_config: times }, 4);
        },
        handleCreateTime: function handleCreateTime() {
            var _this3 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    if (_this3.$moment(_this3.pushTimesForm.time).unix() < _this3.$moment().unix()) {
                        _this3.$alert('请选择未来的时间！');
                        return;
                    }
                    var times = _this3.tableData.map(function (item) {
                        return item.send_time;
                    });
                    if (times.indexOf(_this3.pushTimesForm.time) > -1) {
                        _this3.$alert('添加的推送时间重复，请重试！');
                    } else {
                        _this3.tableData.push({
                            send_time: _this3.pushTimesForm.time,
                            week_day: week[_this3.$moment(_this3.pushTimesForm.time).day()],
                            send_status: '未推送',
                            send_number: '--'
                        });
                        _this3.$refs['form'].resetFields();
                    }
                }
            });
        },
        handleDelete: function handleDelete(index) {
            var _this4 = this;

            this.$confirm('是否删除当前推送时间?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(function () {
                _this4.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                _this4.tableData.splice(index, 1);
            });
        }
    }
});

/***/ }),

/***/ "LI5c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKPO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "LM9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "MTjC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/highlight_background_color.ca0b677.jpeg";

/***/ }),

/***/ "Ng4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"placeholder":"请选择","multiple":"","filterable":"","size":"small","remote":"","disabled":_vm.disabled,"remote-method":_vm.filterData},on:{"focus":_vm.filterData},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.userOptions),function(item){return _c('el-option',{key:item.userId,attrs:{"label":item.fullname,"value":item.userId}},[_c('span',[_vm._v(_vm._s(item.fullname)+" "),_c('span',{staticStyle:{"color":"#8492a6","font-size":"13px"}},[_vm._v("（"+_vm._s(item.companyId)+"）")])])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nvjk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/login-email.65360d9.png";

/***/ }),

/***/ "NzMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "O1ev":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "layout",
    props: ["padding"],
    date: function date() {},

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(["$md5", "$base64", "$page", "$lodash", "$helper", "$loading", "$title", "$routerMapsDefined", "$loadingPrivate", "$jquery", "$iframeHeight", "$jumpProjectTypeRoute1", "$jumpProjectTypeRoute2", "$isAdmin"])),

    created: function created() {
        this.GET_ACTIVE_GAME_INFO();
    },
    mounted: function mounted() {
        var _this = this;

        this.LOADING(false);
        this.SAVE_VUE_OBJECT(this);
        document.title = this.$title;
        // console.log(this.$loadingPrivate)

        this.getContentHeight();
        this.$jquery(window).resize(function () {
            _this.getContentHeight();
        });
    },

    watch: {
        $loading: function $loading(val) {
            var loading = document.getElementById("loading");
            if (val) loading.style.display = "block";else loading.style.display = "none";
        },
        $title: function $title(val) {
            document.title = val;
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(["LOADING", "SAVE_VUE_OBJECT", "GET_ACTIVE_GAME_INFO"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(["SET_CONTENT_HEIGHT"]), {
        checkAsideShow: function checkAsideShow() {
            /** 管理员**/
            if (this.$isAdmin) {
                return true;
            }

            /** 用户有业务和发行入口权限**/
            if (this.$jumpProjectTypeRoute1 || this.$jumpProjectTypeRoute2) {
                return true;
            }

            /** 用户无业务和发行入口权限**/
            return false;
        },
        getContentHeight: function getContentHeight() {
            var height = this.$jquery(window).height() - this.$jquery(".el-header").outerHeight();
            height = height - this.$jquery("#page-main-breadcrumb").outerHeight() - 8;
            // console.log(height);
            this.SET_CONTENT_HEIGHT(height);
        },
        getPadding: function getPadding() {
            if (!this.padding) return;else "padding:" + this.padding;
        },


        /**
         * 设置面包屑
         */
        breadcrumbHandle: function breadcrumbHandle() {
            var pathArr = this.$page.split("/");
            if (pathArr.length === 1) {
                return "<span class=\"route-parent\">" + this.$routerMapsDefined[this.$page]["title"] + "</span>";
            }
            // console.log('111111',pathArr);
            var indexName = this.$routerMapsDefined[pathArr[0]]["title"];
            var pageName = "";
            var pageParentNameHtml = "";
            var children = this.$routerMapsDefined[pathArr[0]]["children"];
            var gameCode = this.$helper.helper.getGameCode();
            gameCode = gameCode.game_code;
            for (var key in children) {
                if (pathArr[1] === key) {
                    pageName = children[key]["title"];
                    if (pathArr[1] !== children[key]["active"]) {
                        var parentRoute = pathArr[0];
                        var parentPage = children[children[key]["active"]];
                        pageParentNameHtml = "<a href=\"/" + parentRoute + "/" + parentPage.url + "?game_code=" + gameCode + "\">" + parentPage.title + "</a><strong> <i class=\"el-icon-arrow-right\"></i> </strong>";
                    }
                    break;
                }
            }
            if (this.$helper.helper.parseURL().params.id && pageName === '新增') {
                pageName = '编辑';
                document.title = document.title.replace('ODP5发行平台 - 新增', 'ODP5发行平台 - 编辑');
            }
            return "<i class=\"el-icon-s-home\"></i> <span class=\"route-parent\">" + indexName + "</span><strong> <i class=\"el-icon-arrow-right\"></i> </strong>" + pageParentNameHtml + "<span class=\"route-page\">" + pageName + "</span>";
        }
    })
});

/***/ }),

/***/ "O4kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectUsers_vue__ = __webpack_require__("3myU");

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'push-notice-subscribe',
    components: {
        SelectUsers: __WEBPACK_IMPORTED_MODULE_2__SelectUsers_vue__["a" /* default */]
    },
    data: function data() {
        return {
            pushNoticeSubscribeForm: {
                users: []
            }
        };
    },

    props: ['isDetail', 'isCopy'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('pushPushPlanOperate', ['users', 'data']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$route', '$activeGameCode']), {
        userOptions: function userOptions() {
            return this.users.map(function (item) {
                return {
                    label: item.fullname,
                    value: item.userId,
                    filter_text: '\'\u3010\'' + item.fullname + item.firstnamePinYin + item.fullnameFirstLetter + item.username + '\'\u3011\''
                };
            });
        }
    }),
    watch: {
        data: {
            handler: function handler() {
                this.pushNoticeSubscribeForm.users = this.data.notice_config ? this.data.notice_config : this.pushNoticeSubscribeForm.users;
            },

            deep: true
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('pushPushPlanOperate', ['getAllUsers']), {
        handlerNext: function handlerNext() {
            this.$emit('submit', { notice_config: this.pushNoticeSubscribeForm.users }, 5);
        },
        cancel: function cancel() {
            window.location.href = '/push/pushplan.html?game_code=' + this.$activeGameCode;
        }
    }),
    created: function created() {
        this.getAllUsers();
    }
});

/***/ }),

/***/ "OH8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetPageStyle_vue__ = __webpack_require__("pS/c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecdffc56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetPageStyle_vue__ = __webpack_require__("icwK");
function injectStyle (ssrContext) {
  __webpack_require__("wUcL")
  __webpack_require__("UyO4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecdffc56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetPageStyle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecdffc56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetPageStyle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OHkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_app_data_product_data_deploy_center_mars_s3_deploy_odp5api_odp5_panel_c_v2_35_26_20260914_160747_slimvue_odp5_theme_oasis_blue_index_css__ = __webpack_require__("AtVe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_app_data_product_data_deploy_center_mars_s3_deploy_odp5api_odp5_panel_c_v2_35_26_20260914_160747_slimvue_odp5_theme_oasis_blue_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_app_data_product_data_deploy_center_mars_s3_deploy_odp5api_odp5_panel_c_v2_35_26_20260914_160747_slimvue_odp5_theme_oasis_blue_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib__ = __webpack_require__("qBF2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__website_filters__ = __webpack_require__("lVf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__);









var PackageInfo = __webpack_require__("7YgM");
var store = __webpack_require__("jLM+")("./" + PackageInfo.name + '/store/app');

/**加载子组件文件夹**/
__webpack_require__("gJHW")("./" + PackageInfo.name + '/subComponents/autoload');
/**
 * 加载ElementUI插件
 */



__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib___default.a);
/**
 * 复制到粘贴板功能
 */

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default.a);

// 引入mockjs
"production" !== "production" && __webpack_require__("HxKs");

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__website_filters__).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_5__website_filters__[key]);
});

// noinspection JSUnresolvedVariable
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = "production" !== "production";

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toCssUrl = function (imageUrl) {
    return "url(" + imageUrl + ")";
};
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$toCssBackgroundImage = function (imageUrl) {
    return {
        backgroundImage: this.$toCssUrl(imageUrl)
    };
};

/* harmony default export */ __webpack_exports__["a"] = ({
    DEBUG_LOG_LEVEL: 0,
    DEFAULT_LOG_LEVEL: 10,
    INFO_LOG_LEVEL: 20,
    WARNING_LOG_LEVEL: 30,
    ERROR_LOG_LEVEL: 40,
    _logLevel: -1,
    set logLevel(val) {
        this._logLevel = val;
    },
    get logLevel() {
        if (this._logLevel === -1) {
            return this.isDebug ? this.DEBUG_LOG_LEVEL : this.INFO_LOG_LEVEL;
        } else {
            return this._logLevel;
        }
    },
    get isDebug() {
        return "production" !== "production";
    },
    get bridge() {
        if (undefined === window.bridge) {
            return __webpack_require__.i({"NODE_ENV":"production"}).bridge;
        } else {
            return window.bridge;
        }
    },
    mount: function mount(vueComponent) {
        console.log("Will start to mount component to slimvue app", vueComponent);
        var div = document.getElementById('slimvue-app');
        if (div === null) {
            div = document.createElement('div');
            div.id = "slimvue-app";
            div.innerHTML = "<slimvue-page></slimvue-page>";
            document.body.appendChild(div);
        } else {
            console.warn("Div element already exists, will replace existing content.");
        }

        /**获取数据仓库**/
        var app = window.slimvue = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
            components: {
                "slimvue-page": vueComponent
            },
            store: store.default,
            el: "#slimvue-app"
        });

        return app;
    },
    log: function log() {
        var _console;

        if (this.logLevel <= this.DEFAULT_LOG_LEVEL) (_console = console).log.apply(_console, arguments);
    },
    debug: function debug() {
        var _console2;

        if (this.logLevel <= this.DEBUG_LOG_LEVEL) (_console2 = console).debug.apply(_console2, arguments);
    },
    info: function info() {
        var _console3;

        if (this.logLevel <= this.INFO_LOG_LEVEL) (_console3 = console).info.apply(_console3, arguments);
    },
    warn: function warn() {
        var _console4;

        if (this.logLevel <= this.WARNING_LOG_LEVEL) (_console4 = console).warn.apply(_console4, arguments);
    },
    error: function error() {
        var _console5;

        if (this.logLevel <= this.ERROR_LOG_LEVEL) (_console5 = console).error.apply(_console5, arguments);
    }
});

/***/ }),

/***/ "OQYA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OXH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subComponents_sdkUpload__ = __webpack_require__("uhd8");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'set-idfa-allowed',
    components: {
        upload: __WEBPACK_IMPORTED_MODULE_3__subComponents_sdkUpload__["a" /* default */]
    },
    data: function data() {
        return {
            showSpecialTimeType: false,
            reviewDialogVisible: false,
            dialogTemplateCustomName: '',
            params: {
                idfa_customize_popup_image: {},
                idfa_allowed: true,
                idfa_call_mode: 'udp',
                idfa_popup_type: 'customize',
                idfa_time: undefined,
                idfa_time_type: 'after_login',
                after_login_time: undefined,
                after_start_time: undefined,
                step: 'idfa'
            }
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(["$activeGameInfo", "$lodash"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])("sdkReleasesEdit", ["releasesInfo", "sdkVersion", "data"]), {
        isShowTime: function isShowTime() {
            if (!this.params.idfa_allowed) {
                return false;
            } else if (this.params.idfa_call_mode === 'cp') {
                return false;
            } else {
                return true;
            }
        }
    }),
    methods: {
        handleIdfaCustomChecked: function handleIdfaCustomChecked(key) {
            var currentKeyChecked = this.params.idfa_customize_popup_image[key].checked;
            for (var keys in this.params.idfa_customize_popup_image) {
                this.params.idfa_customize_popup_image[keys].checked = false;
            }
            this.params.idfa_customize_popup_image[key].checked = currentKeyChecked;
            this.params.idfa_customize_popup_default_lang = currentKeyChecked ? key : '';
        },
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    var params = _this.$lodash.cloneDeep(_this.params);
                    if (!params.idfa_allowed) {
                        delete params.idfa_time;
                        delete params.idfa_time_type;
                        delete params.idfa_popup_type;
                        delete params.idfa_call_mode;
                        delete params.idfa_customize_popup_image;
                    } else if (!_this.isShowTime) {
                        delete params.idfa_time;
                        delete params.idfa_time_type;
                    }
                    if (params.idfa_popup_type === 'customize') {
                        try {
                            var isChecked = true;
                            _this.$lodash.forEach(params.idfa_customize_popup_image, function (item, key) {
                                if (item.checked && (!item.popup_background || !item.allow_tracking_button || !item.popup_close_button)) {
                                    _this.errorAlert();
                                    throw console.log('break');
                                } else if (!item.popup_background || !item.allow_tracking_button || !item.popup_close_button) {
                                    delete params.idfa_customize_popup_image[key];
                                    isChecked = false;
                                }
                            });
                            if (!isChecked && !params.idfa_customize_popup_default_lang) {
                                _this.errorAlert();
                                throw console.log('break');
                            }
                        } catch (_) {
                            return false;
                        }
                    }
                    if (_this.isShowTime) {
                        params.idfa_time = params[params.idfa_time_type + '_time'];
                    }
                    _this.$emit('submit', params, 'save');
                }
            });
        },
        errorAlert: function errorAlert() {
            this.$alert('请检查IDFA定制弹框配置。您可以给所有语言配置弹框图片资源或将某个语言设置为默认语言。', '提示');
        },
        justifyVersion: function justifyVersion(version) {
            var versionarr = version.split(".");
            var version_convert = '';
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            } else {
                version_convert = version;
            }
            return version_convert;
        }
    },
    props: ['isDetail', 'isCopy', 'labelWidth'],
    watch: {
        $activeGameInfo: function $activeGameInfo() {
            var _this2 = this;

            /**
             * 初始化定制弹窗
             */
            if (Array.isArray(this.$activeGameInfo.lang) && this.$activeGameInfo.lang.length) {
                this.$activeGameInfo.lang.forEach(function (item) {
                    _this2.$set(_this2.params.idfa_customize_popup_image, item.full_code.toLowerCase(), {
                        popup_background: '',
                        allow_tracking_button: '',
                        popup_close_button: '',
                        checked: false
                    });
                });
                this.dialogTemplateCustomName = this.$activeGameInfo.lang[0].fullCode;
            }
        },
        'data.idfa': function dataIdfa() {
            var _this3 = this;

            this.params = this.$lodash.cloneDeep(this.data.idfa);
            var idfa_customize_popup_image = {};
            this.$activeGameInfo.lang.forEach(function (item) {
                idfa_customize_popup_image[item.full_code.toLowerCase()] = {
                    popup_background: '',
                    allow_tracking_button: '',
                    popup_close_button: '',
                    checked: false
                };
            });
            this.$lodash.forEach(this.params.idfa_customize_popup_image, function (item, key) {
                if (_this3.params.idfa_customize_popup_default_lang === key) {
                    _this3.$set(_this3.params.idfa_customize_popup_image[key], 'checked', true);
                } else {
                    _this3.$set(_this3.params.idfa_customize_popup_image[key], 'checked', false);
                }
            });
            this.params[this.params.idfa_time_type + '_time'] = this.params.idfa_time;
            this.params.idfa_customize_popup_image = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(idfa_customize_popup_image, this.params.idfa_customize_popup_image);
            this.params.step = 'idfa';
        },
        'data.query': function dataQuery(value) {
            var version = "";
            this.sdkVersion.forEach(function (item) {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            });
            var versionStr = version.substr(0, 2);
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
            console.log(versionStr, this.version);
            if (['6.'].includes(versionStr) && this.version >= 6.04) {
                this.showSpecialTimeType = true;
            }

            if (!this.showSpecialTimeType && this.version >= 7.09) {
                this.showSpecialTimeType = true;
            }
        }
    }
});

/***/ }),

/***/ "OpBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'search-dimension',
    data: function data() {
        return {
            gameVersionDialogFormVisible: false,
            isNotConfigVisible: false,
            selDisable: false,
            operate_type: '',
            params: {
                package_id: '',
                game_version_id: '',
                store_id: '',
                sdk_version_id: '',
                step: 'query'
            },
            gameVersionForm: {
                game_version: ''
            },
            paramsRules: {
                package_id: [{
                    required: true, message: '请选择包名！'
                }],
                game_version_id: [{
                    required: true, message: '请选择游戏版本！'
                }],
                store_id: [{
                    required: true, message: '请选择发行渠道！'
                }],
                sdk_version_id: [{
                    required: true, message: '请选择SDK版本！'
                }]
            }
        };
    },

    props: ['isDetail', 'isCopy', 'labelWidth'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$helper', '$routerMapsDefined', '$activeGameCode']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])("sdkReleasesEdit", ["gameVersion", "packageList", "packageStoreList", "sdkVersion", "releasePlan", "data"]), {
        isDisabled: function isDisabled() {
            return this.operate_type === 'edit';
        }
    }),
    watch: {
        'data.query': function dataQuery() {
            this.params = {
                package_id: parseInt(this.data.query.package_id),
                game_version_id: parseInt(this.data.query.game_version_id),
                store_id: this.data.query.store_id,
                sdk_version_id: parseInt(this.data.query.sdk_version_id),
                step: 'query'
            };
            this.GET_RELEASE_PLAN({
                platform: this.$helper.helper.getParamers("platform"),
                sdk_version_id: this.params.sdk_version_id,
                store_id: this.params.store_id,
                package_id: this.params.package_id
            });
        },

        params: {
            handler: function handler() {
                if (this.params.package_id !== '' && this.params.game_version_id !== '' && this.params.sdk_version_id !== '' && this.params.store_id !== '') {
                    this.GET_RELEASE_PLAN({
                        platform: this.$helper.helper.getParamers("platform"),
                        sdk_version_id: this.params.sdk_version_id,
                        store_id: this.params.store_id,
                        package_id: this.params.package_id
                    });
                    this.operate_type = 'add';
                    //this.isNotConfigVisible = !this.releasePlan.length
                }
            },
            deep: true
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])("sdkReleasesEdit", ["GET_PACKAGE_STORE", "GET_RELEASE_PLAN", "NEW_GAME_VERSION"]), {
        gameVersionNew: function gameVersionNew() {
            this.NEW_GAME_VERSION({
                version: this.gameVersionForm.game_version
            });
            this.gameVersionForm.game_version = "";
        },
        handlerPackage: function handlerPackage(value) {
            this.GET_PACKAGE_STORE({
                package_id: value,
                platform: this.$helper.helper.getParamers("platform")
            }).then(function () {
                // if (
                //     this.operate_type === "copy" ||
                //     (this.params.sdk_version_id &&
                //         this.params.store_id &&
                //         this.params.package_id)
                // ) {
                //     this.SdkVersionChanged();
                // }
            });
        },
        SdkVersionChanged: function SdkVersionChanged() {
            // this.GET_RELEASE_PLAN({
            //     platform: this.$helper.helper.getParamers("platform"),
            //     sdk_version_id: this.params.sdk_version_id,
            //     store_id: this.params.store_id,
            //     package_id: this.params.package_id,
            // });
        },
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    if (!_this.releasePlan.length) {
                        _this.isNotConfigVisible = true;
                        return;
                    }
                    _this.operate_type = 'edit';
                    _this.$emit('submit', _this.params, 1);
                }
            });
        },
        configUrl: function configUrl() {
            var url = "/sdk/" + this.$routerMapsDefined.sdk.children.configEdit.url;
            url += '?game_code=' + this.$activeGameCode + '&platform=' + this.$helper.helper.getParamers("platform").toLowerCase();
            return url;
        }
    }),
    created: function created() {
        this.operate_type = this.$helper.helper.getParamers("operate_type");
        this.selDisable = this.operate_type === 'edit';
    }
});

/***/ }),

/***/ "OukJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    gameVersion: [],
    sdkVersion: [],
    packageList: [],
    androidPackageList: [],
    packageStoreList: [],
    androidPackageStoreList: [],
    releasePlan: [],
    termsList: [],
    data: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_SDK_VERSION: function GET_SDK_VERSION(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {}).then(function (res) {
            data = res.data.sdk_versions;
            commit('_sdkVersion', data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_GAME_VERSION: function GET_GAME_VERSION(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/games/' + gameCode + '/versions', { game_code: gameCode }).then(function (res) {
            data = res.data.versions;
            commit('_gameVersion', data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    NEW_GAME_VERSION: function NEW_GAME_VERSION(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/versions/new', { version: args.version }).then(function (res) {
            data = res.data.created;
            commit('_newGameVersion', data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PACKAGE_LIST: function GET_PACKAGE_LIST(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenamelist', {
            game_code: gameCode,
            platform: args.platform
        }).then(function (res) {
            data = res.data.result;
            commit('_packageList', data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PACKAGE_STORE: function GET_PACKAGE_STORE(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        var data = [];
        return rootState.$helper.request.get('/ajaxrela/getpackagenamestorelist', { package_id: args.package_id }).then(function (res) {
            data = res.data.result;
            commit('_packageStoreList', data);
            return res;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_RELEASE_SUBMIT: function PUT_RELEASE_SUBMIT(_ref6, args) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.put('/games/' + gameCode + '/releases/new', args).then(function (res) {
            data = res.data.created;
            commit('_setData', data);
            return true;
        });
    },
    GET_RELEASE_PLAN: function GET_RELEASE_PLAN(_ref7, args) {
        var state = _ref7.state,
            commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            rootState = _ref7.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        if (args.plan_id) {
            return rootState.$helper.request.get('/games/' + gameCode + '/plans/' + args.plan_id).then(function (res) {
                data[0] = res.data.plan;
                commit('_releasePlan', data);
                return data;
            }).catch(function (res) {
                dispatch('ERROR_HANDLE', res, { root: true });
            });
        } else {
            return rootState.$helper.request.get('/games/' + gameCode + '/plans', {
                platform: args.platform,
                sdk_version_id: args.sdk_version_id,
                store_id: args.store_id,
                package_id: args.package_id
            }).then(function (res) {
                data = res.data.plans;
                commit('_releasePlan', data);
                return data;
            }).catch(function (res) {
                dispatch('ERROR_HANDLE', res, { root: true });
            });
        }
    },
    GET_EDIT_RELEASE: function GET_EDIT_RELEASE(_ref8, args) {
        var state = _ref8.state,
            commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            rootState = _ref8.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        commit("PRIVATE_LOADING", true, { root: true });
        return rootState.$helper.request.get('/games/' + gameCode + '/releases/' + args.release_id, {
            platform: args.platform
        }).then(function (res) {
            data = res.data.release;
            commit('_setData', data);
            commit("PRIVATE_LOADING", false, { root: true });
            return data;
        }).catch(function (res) {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_RELEASE_EDIT_SUBMIT: function PUT_RELEASE_EDIT_SUBMIT(_ref9, args) {
        var state = _ref9.state,
            commit = _ref9.commit,
            dispatch = _ref9.dispatch,
            rootState = _ref9.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.put('/games/' + gameCode + '/releases/' + args.release_id, args).then(function (res) {
            data = res.data.edited;
            commit('_setData', data);
            return data;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_RELEASE_COPY_SUBMIT: function PUT_RELEASE_COPY_SUBMIT(_ref10, args) {
        var state = _ref10.state,
            commit = _ref10.commit,
            dispatch = _ref10.dispatch,
            rootState = _ref10.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/releases/new', args).then(function (res) {
            data = res.data.created;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '复制成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/releaseslist', { platform: args.platform });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '复制失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/releaseslist');
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_TERMS_LIST: function GET_TERMS_LIST(_ref11, args) {
        var state = _ref11.state,
            commit = _ref11.commit,
            dispatch = _ref11.dispatch,
            rootState = _ref11.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/termslist', args).then(function (res) {
            data = res.data.terms;
            commit('_termsList', data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _setData: function _setData(state, args) {
        state.data = args;
    },
    _sdkVersion: function _sdkVersion(state, args) {
        state.sdkVersion = args;
    },
    _gameVersion: function _gameVersion(state, args) {
        state.gameVersion = args;
    },
    _packageList: function _packageList(state, args) {
        state.packageList = args;
    },
    _packageStoreList: function _packageStoreList(state, args) {
        state.packageStoreList = args;
    },
    _newGameVersion: function _newGameVersion(state, args) {
        var newVersionData = [].concat(args, state.gameVersion);
        state.gameVersion = newVersionData;
    },
    _releasePlan: function _releasePlan(state, args) {
        state.releasePlan = args;
    },
    _termsList: function _termsList(state, args) {
        state.termsList = args;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "P0b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "PXhh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "PmJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box__ = __webpack_require__("+TD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__message__ = __webpack_require__("Kcpt");




/**
 * Created by shiyonggao on 2019/11/28.
 */


var tips = {
    operateFailMsg: '操作失败！'
};

var error = function () {
    function error() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, error);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(error, [{
        key: 'noAccessPage',


        /**
         * 无权限用户处理
         * @param message
         * @param rootState
         */
        value: function noAccessPage(message, rootState) {
            var arrToken = ['A Token was not found in the TokenStorage', 'Access JWT Token string not found in request or Jwt Token Invalid'];
            var flag = false;
            for (var key in arrToken) {
                if (message.indexOf(arrToken[key]) !== -1) {
                    flag = true;
                    break;
                }
            }

            if (flag) {
                rootState.$helper.helper.login();
            }
        }

        /***
         * 错误统一处理
         */

    }, {
        key: 'error',
        value: function error(_error, _ref) {
            var state = _ref.state,
                commit = _ref.commit,
                dispatch = _ref.dispatch,
                rootState = _ref.rootState;

            if (rootState.$config.isDebug) {
                if (_error['response']) {
                    console.error(_error['response']);
                } else {
                    console.error(_error);
                }
                if (typeof _error['response'].data.extra.error_type !== 'undefined' || _error.data && typeof _error.data.extra.error_type !== 'undefined') {
                    var errorType = _error['response'].data.extra.error_type || _error.data.extra.error_type;
                    if (errorType === 'third_party_api') {
                        setTimeout(function () {
                            rootState.$helper.helper.logout();
                        }, 300);
                        return;
                    }
                }

                if (_error['response'].data.exception.message || _error.data.exception.message) {
                    __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message_box___default.a.alert(_error['response'].data.exception.message || _error.data.exception.message, '提示', {
                        type: 'error'
                    });
                } else {
                    alert('ajax-erro ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_error['response']));
                }

                return;
            }

            var message = tips.operateFailMsg;

            /** 无权限返回内容**/
            if (_error['response'] && _error['response']['data'] && _error['response']['data']['mess']) {
                var _message = _error['response']['data']['mess'];
                if (_message === 'No permission to access this url') {
                    /** 已在无权限提示页面不再跳转**/
                    if (rootState.$page !== 'noAccess') {
                        console.log('error-response-noAccess');
                        // rootState.$route('noAccess');
                    }
                    return;
                }
            }

            /** 无权限处理**/
            if (_error['response'] && _error['response']['data'] && _error['response']['data']['exception'] && _error['response']['data']['exception']['message']) {

                message = _error['response']['data']['exception']['message'];
                this.noAccessPage(message, rootState);
            }

            /** 统一提示**/
            __WEBPACK_IMPORTED_MODULE_4__message__["a" /* default */].alert({
                message: message,
                reload: false
            }, { state: state, commit: commit, dispatch: dispatch, rootState: rootState });
        }
    }]);

    return error;
}();

/* harmony default export */ __webpack_exports__["a"] = (new error());

/***/ }),

/***/ "Q8VG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cookie__ = __webpack_require__("wwIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__localStorage__ = __webpack_require__("RFTr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);




/**
 * Created by shiyonggao on 2019/11/28.
 */





var Config = __webpack_require__("wFsZ");


var Helper = function () {
    function Helper() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Helper);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Helper, [{
        key: "tirm",

        /***
         * 去掉两端空格
         * @param s
         * @returns {s}
         */
        value: function tirm(s) {
            return s.replace(/^\s+|\s+$/gm, "");
        }

        /**
         * 清除缓存在本地Cookie和localStorage中的数据
         */

    }, {
        key: "clearCookie",
        value: function clearCookie() {
            var cookieArrkes = ["odp-baseSdkSelectedPlatfrom", "odp-projectType", "odp-selectedGameCode", "odp-projectType-hide", "access-token", "oasis-ces-token", "oasis-udc-token", "oasis-watch-token", "oasis-odp5-token", "odp5-access-token", "oasis-passport-token"];
            var len = cookieArrkes.length;
            for (var i = 0; i < len; i++) {
                __WEBPACK_IMPORTED_MODULE_5__cookie__["a" /* default */].remove(cookieArrkes[i]);
            }

            __WEBPACK_IMPORTED_MODULE_6__localStorage__["a" /* default */].remove("odp_gameList");
        }

        /**
         * 用户登陆页面
         */

    }, {
        key: "login",
        value: function login() {
            console.log("Jump UDP login url");
            this.clearCookie();
            var p = window.location.pathname,
                g = this.getGameCode().game_code;
            p = p.replace(/\.html$/, "").replace(/^\//, "");
            window.location.href = Config.userLogin + "?game_code=" + g + "&page=" + p;
        }

        /**
         * 用户退出
         */

    }, {
        key: "logout",
        value: function logout() {
            this.token = this.getToken();
            var headers = {};
            if (this.token) {
                headers[Config.userLoginAccessTokenKey] = this.token;
            }
            var axios = __WEBPACK_IMPORTED_MODULE_8_axios___default.a.create({
                timeout: 120 * 60,
                responseType: "json",
                baseURL: Config.apiBaseUrl,
                headers: headers
            });

            var haddle = function haddle() {
                /**跳转退出页面**/
                window.location.href = "" + Config.baseUrl + Config.userLogout;
            };

            /**清除ODPcookie**/
            this.clearCookie();

            /**用户退出**/
            axios.get(Config.userLogoutApi).then(function () {
                haddle();
            }).catch(function () {
                haddle();
            });
            /**Core 退出**/
            // let coreUrl = Config.coreUrl;
            // let appId = Config.coreAppId;
            // let oauthUrl = Config.coreOauthUrl;
            // let redirectUrl = `${oauthUrl}/oauth/authorize?response_type=code&client_id=${appId}`;
            // window.location.href = `${coreUrl}/panel/logout?redirect_uri=${encodeURIComponent(redirectUrl)}`;
        }

        /**
         * unset 对象特定的key
         * @param key
         * @param obj
         */

    }, {
        key: "unsetObject",
        value: function unsetObject(key, obj) {
            var temp = {};
            for (var k in obj) {
                if (key === k) continue;else temp[k] = obj[k];
            }
            return temp;
        }

        /**
         * 获取当前key的上一个key的值
         * @param key
         * @param obj
         */

    }, {
        key: "prevObjectValue",
        value: function prevObjectValue(key, obj) {
            var temp = void 0;
            for (var k in obj) {
                if (key === k) break;else {
                    var te = {};
                    te["key"] = k;
                    te["value"] = obj[k];
                    temp = te;
                }
            }
            return temp;
        }

        /**
         * 获取当前key的下一个key的值
         * @param key
         * @param obj
         */

    }, {
        key: "nextObjectValue",
        value: function nextObjectValue(key, obj) {
            var temp = {};
            var active = false;
            for (var k in obj) {
                if (key === k) {
                    active = true;
                    continue;
                } else {
                    if (active) {
                        temp["key"] = k;
                        temp["value"] = obj[k];
                        break;
                    }
                }
            }
            return temp;
        }

        /**
         * 获取游戏code
         * @returns {{gameCode: string}}
         */

    }, {
        key: "getGameCode",
        value: function getGameCode() {
            // let gamecode = {};
            // if (Cookie.get("odp-selectedGameCode")) {
            //     gamecode["game_code"] = Cookie.get("odp-selectedGameCode");
            // }
            return {
                game_code: this.getParamter("game_code")
            };
        }

        /**
         * 获取用户token，无用户token直接去登陆
         * @returns {null}
         */

    }, {
        key: "getToken",
        value: function getToken() {
            var token = __WEBPACK_IMPORTED_MODULE_5__cookie__["a" /* default */].get(Config.userLoginAccessTokenKey);
            console.log("getToken", token);

            /**无用户登陆跳转到登陆页面**/
            if (!token) {
                this.login();
            }
            return token;
        }

        /**
         * 获取用户token，无用户token直接去登陆
         * @returns {null}
         */

    }, {
        key: "getUdcToken",
        value: function getUdcToken() {
            var token = __WEBPACK_IMPORTED_MODULE_5__cookie__["a" /* default */].get(Config.udcAccessTokenKey);
            console.log("getUdcToken", token);
            return token;
        }

        /**
         * 路由跳转
         * @param routeName
         * @param data
         * @param blank
         */

    }, {
        key: "route",
        value: function route(routeName) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var blank = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (routeName === "index") {
                data = {};
            }
            if (!data["game_code"]) {
                data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data, this.getGameCode());
            }
            var params = this.paramJSON(data);
            var reg = /^((http|https):\/\/)\S+(\.html)$/;
            var url = "";
            /**有参数设置参数**/
            if (params) params = "?" + params;

            if (reg.test(routeName)) {
                url = "" + routeName.toLocaleLowerCase() + params;
            } else {
                url = "" + Config.baseUrl + routeName.toLocaleLowerCase() + ".html" + params;
            }
            if (blank) {
                window.open(url);
            } else {
                window.location.href = url;
            }
        }
    }, {
        key: "getUrlParams",
        value: function getUrlParams() {
            var urlParams = window.location.search;
            if (urlParams) {
                urlParams = urlParams.substr(1);
                urlParams = __WEBPACK_IMPORTED_MODULE_7_qs___default.a.parse(urlParams);
            } else {
                urlParams = {};
            }
            return urlParams;
        }

        /**
         * 获取URL参数
         * @param key
         * @returns {string}
         */

    }, {
        key: "getParamers",
        value: function getParamers(key) {
            var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["unescape"])(r[2]);
            return "";
        }

        /**
         * 获取URL参数
         * @param key
         * @returns {string}
         */

    }, {
        key: "getParamter",
        value: function getParamter(key) {
            return this.getParamers(key);
        }

        /***
         * 解析url地址
         * @param url
         * @returns {}
         */

    }, {
        key: "parseURL",
        value: function parseURL(url) {
            if (!url) url = window.location.href;
            var a = document.createElement("a");
            a.href = url;
            return {
                source: url,
                protocol: a.protocol.replace(":", ""),
                host: a.hostname,
                port: a.port,
                query: a.search,
                params: function () {
                    var ret = {},
                        seg = a.search.replace(/^\?/, "").split("&"),
                        len = seg.length,
                        i = 0,
                        s = void 0;
                    for (; i < len; i++) {
                        if (!seg[i]) {
                            continue;
                        }
                        s = seg[i].split("=");
                        if (s[1]) {
                            ret[s[0]] = decodeURI(s[1]);
                        }
                    }
                    return ret;
                }(),
                file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ""])[1],
                hash: a.hash.replace("#", ""),
                path: a.pathname.replace(/^([^\/])/, "/$1"),
                relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ""])[1],
                segments: a.pathname.replace(/^\//, "").split("/")
            };
        }

        /**
         * object to request params
         * @param o
         * @returns string   b=1&b=2
         */

    }, {
        key: "paramJSON",
        value: function paramJSON(o) {
            var s = [],
                add = function add(key, valueOrFunction) {
                var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isFunction"])(valueOrFunction) ? valueOrFunction() : valueOrFunction;
                s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
            },
                buildParams = function buildParams(prefix, obj) {
                if (Array.isArray(obj)) {
                    obj.forEach(function (value, i) {
                        buildParams(prefix + "[" + ((typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === "object" && value != null ? i : "") + "]", value);
                    });
                } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isPlainObject"])(obj)) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forIn"])(obj, function (value, key) {
                        buildParams(prefix + "[" + key + "]", value);
                    });
                } else {
                    add(prefix, obj);
                }
            };

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(o)) {
                return "";
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["forIn"])(o, function (value, prefix) {
                buildParams(prefix, value);
            });

            return s.join("&");
        }

        /**
         * version1>version2 返回1，version1<version2 返回-1，version1=version2 返回0
         *
         * @param version1
         * @param version2
         * @returns {number}
         */

    }, {
        key: "compareVersion",
        value: function compareVersion(version1, version2) {
            var arr1 = version1.split(".");
            var arr2 = version2.split(".");

            var len = Math.max(arr1.length, arr2.length);
            for (var i = 0; i < len; i++) {

                var data1 = 0,
                    data2 = 0;
                if (i < arr1.length) {
                    data1 = parseInt(arr1[i]);
                }
                if (i < arr2.length) {
                    data2 = parseInt(arr2[i]);
                }

                if (data1 < data2) {
                    return -1;
                } else if (data1 > data2) {
                    return 1;
                }
            }
            return 0;
        }
    }]);

    return Helper;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Helper());

/***/ }),

/***/ "QRQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sub-watch-frame',
    data: function data() {
        return {
            url: ''
        };
    },

    props: ['urlType'],
    components: {},
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment', '$route', '$iframeHeight'])),

    created: function created() {
        var gameCode = this.$helper.helper.getGameCode().game_code;
        var accessToken = this.$helper.cookie.get('oasis-watch-token');
        console.log('type=>' + this.urlType);

        switch (this.urlType) {
            case 'attendence':
                this.url = this.$config.attendenceUrl;
                break;
            case 'line':
                this.url = this.$config.lineUrl;
                break;
            case 'alarmPolicy':
                this.url = this.$config.alarmPolicyUrl;
                break;
            case 'alarmGroup':
                this.url = this.$config.alarmGroupUrl;
                break;
            default:
                this.url = 'http://';
                break;
        }
        this.url = this.url + '?gamecode=' + gameCode + '&token=' + accessToken + '&udp=true';
    },


    methods: {}
});

/***/ }),

/***/ "QpaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/**
 * Created by shiyonggao on 2019/2/25.
 */



/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    gameCodeLang: [],
    pushTopicGroupList: [],
    pushListByLang: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_GAME_CODE_LANG: function GET_GAME_CODE_LANG(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var push_ajax_rela_get_game_code_lang_url = rootState.$config.api.push_ajax_rela_get_game_code_lang_url;
        rootState.$helper.request.get(push_ajax_rela_get_game_code_lang_url, args).then(function (res) {
            commit('_getGameCodeLang', res.data.result);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PUSH_TOPIC_GROUP_LIST: function GET_PUSH_TOPIC_GROUP_LIST(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;


        var push_games_code_push_topic_group_url = rootState.$config.api.push_games_code_push_topic_group_url;
        push_games_code_push_topic_group_url = push_games_code_push_topic_group_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.get(push_games_code_push_topic_group_url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ limit: 1000 }, args)).then(function (res) {
            commit('_setPushTopicGroupList', res.data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PUSH_LIST_BY_LANG: function GET_PUSH_LIST_BY_LANG(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;


        var push_push_topics_url = rootState.$config.api.push_push_topics_url;

        rootState.$helper.request.get(push_push_topics_url, { lang: args.lang, limit: 1000 }).then(function (res) {
            commit('_setPushListByLang', res.data);
            if (typeof args.callback === 'function') {
                args.callback();
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    ADD_PUSH_TOPIC_GROUP: function ADD_PUSH_TOPIC_GROUP(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var push_add_games_code_push_topic_group_url = rootState.$config.api.push_add_games_code_push_topic_group_url;
        push_add_games_code_push_topic_group_url = push_add_games_code_push_topic_group_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.put(push_add_games_code_push_topic_group_url, args).then(function (res) {
            dispatch('GET_PUSH_TOPIC_GROUP_LIST', { game_code: args.game_code, lang: args.now_lang });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    EDIT_PUSH_TOPIC_GROUP: function EDIT_PUSH_TOPIC_GROUP(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;


        var push_edit_games_code_push_topic_group_id_url = rootState.$config.api.push_edit_games_code_push_topic_group_id_url;
        push_edit_games_code_push_topic_group_id_url = push_edit_games_code_push_topic_group_id_url.replace('{game_code}', args.game_code);
        push_edit_games_code_push_topic_group_id_url = push_edit_games_code_push_topic_group_id_url.replace('{topic_group_id}', args.topic_group_id);

        rootState.$helper.request.put(push_edit_games_code_push_topic_group_id_url, args).then(function (res) {
            dispatch('GET_PUSH_TOPIC_GROUP_LIST', { game_code: args.game_code, lang: args.now_lang });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    ADD_PLAN_SCHEDULES: function ADD_PLAN_SCHEDULES(_ref6, args) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;

        var push_add_schedules_url = rootState.$config.api.push_add_schedules_url;
        push_add_schedules_url = push_add_schedules_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.put(push_add_schedules_url, args).then(function (res) {
            dispatch('GET_PUSH_TOPIC_GROUP_LIST', { game_code: args.game_code, lang: args.now_lang });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    SET_PUSH_LIST_BY_LANG: function SET_PUSH_LIST_BY_LANG(_ref7, args) {
        var state = _ref7.state,
            commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            rootState = _ref7.rootState;


        commit('_setPushListByLang', []);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _getGameCodeLang: function _getGameCodeLang(state, args) {
        state.gameCodeLang = args;
    },
    _setPushTopicGroupList: function _setPushTopicGroupList(state, args) {
        state.pushTopicGroupList = args.topic_groups;
    },
    _setPushListByLang: function _setPushListByLang(state, args) {
        state.pushListByLang = args.topics;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "R19o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R5Gv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("kdcc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8a5ad1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("dqQ/");
function injectStyle (ssrContext) {
  __webpack_require__("JFiu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8a5ad1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8a5ad1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RFTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * Created by shiyonggao on 2019/12/13.
 */

var LocalStorage = function () {
    function LocalStorage() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LocalStorage);

        this.regKey = /^[a-zA-Z_]{1,}$/;
        this.store = window.localStorage ? window.localStorage : null;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LocalStorage, [{
        key: "check",
        value: function check(key) {
            if (!this.store) {
                throw "Browser don't support localStorage";
            }

            if (!this.regKey.test(key)) {
                throw "Key the rules is error";
            }
        }
    }, {
        key: "getTime",
        value: function getTime() {
            return Math.floor(new Date().getTime() / 1000);
        }

        /***
         * 设置值
         * @param key [a-zA-Z_]
         * @param value
         * @param expire 小时单位 type='number'
         */

    }, {
        key: "set",
        value: function set(key, value, expire) {
            this.check(key);
            value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);

            /**已设置过期期间处理**/
            if (expire && typeof expire === 'number') {
                var expireKey = key + "_expire_date";
                var expireValue = this.getTime() + expire * 60 * 60;
                this.store.setItem(expireKey, expireValue);
                this.store.setItem(key, value);
            } else {
                this.store.setItem(key, value);
            }
        }

        /**
         * 获取值
         * @param key
         * @returns {string|null}
         */

    }, {
        key: "get",
        value: function get(key) {
            this.check(key);
            var value = this.store.getItem(key);

            /**有值**/
            if (value) {
                var expireKey = key + "_expire_date";
                var time = this.store.getItem(expireKey);
                /**判断是否设置有效期**/
                if (time) {
                    /**数据已过期**/
                    if (time < this.getTime()) {
                        this.remove(key);
                        this.remove(expireKey);
                        return null;
                    } else {
                        return JSON.parse(value);
                    }
                } else {
                    return JSON.parse(value);
                }
            } else {
                return null;
            }
        }

        /**
         * 删除值
         * @param key
         */

    }, {
        key: "remove",
        value: function remove(key) {
            this.check(key);
            var expireKey = key + "_expire_date";
            var time = this.store.getItem(expireKey);
            this.store.removeItem(key);
            if (time) this.store.removeItem(expireKey);
        }
    }]);

    return LocalStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (new LocalStorage());

/***/ }),

/***/ "S/4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * Created by shiyonggao on 2019/2/25.
 */

var handler = {
    _getUrl: function _getUrl(rootState) {
        var url = rootState.$config.api.app.baseinfo;
        return _.replace(url, '{game_code}', rootState.$helper.helper.getGameCode().game_code);
    }
};

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    gameInfo: [],
    allSdkTye: [{
        value: 0,
        label: '常规SDK'
    }, {
        value: 1,
        label: 'DD SDK'
    }],
    demoStatus: false
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_GAME_INFO_ACTIONS: function GET_GAME_INFO_ACTIONS(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;


        var url = handler._getUrl(rootState);
        var options = [{ 'url': url, data: {}, method: 'get', 'key': 'gameInfo' }, {
            'url': '/available-s2s-proxies',
            data: {},
            method: 'get',
            'key': 's2s'
        }];

        rootState.$helper.request.all(options, function (data) {
            console.log(data);
            var ret = data['gameInfo'].data.game;
            var language = '';
            _.forEach(ret.lang, function (value, key) {
                language += ' ' + value.name;
            });
            var s2sData = data['s2s'].data.proxies;
            var s2sName = '';
            _.forEach(s2sData, function (value, key) {

                if (value.proxy_id == ret.proxy_id) {
                    s2sName = value.proxy_name;
                }
            });
            var sdkTypeName = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(state.allSdkTye[ret.is_ddsdk]) ? state.allSdkTye[ret.is_ddsdk].label : '';
            console.log(sdkTypeName);

            data = {
                game_product: ret.family_detail.name,
                language: language,
                game_show_name_cn: ret.name,
                game_name: ret.local_name,
                gameCode: ret.game_code,
                mdataId: ret.mdata_app_id,
                gaId: ret.ga_account_id,
                fbAppId: ret.facebook_app_id,
                fbAppUrl: ret.facebook_app_url,
                googleDownLoadUrl: ret.google_download_url,
                iosDownLoadUrl: ret.ios_download_url,
                windowsDownLoadUrl: ret.windows_download_url,
                localDownLoadUrl: ret.local_download_url,
                commonUrl: ret.common_download_url,
                s2sAgent: ret.proxy_id,
                sdkType: ret.is_ddsdk,
                's2sName': s2sName,
                's2sData': s2sData,
                'sdkTypeName': sdkTypeName
            };
            commit('_updateGameInfo', data);
        }, function (res) {
            // dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    UPDATE_GAME_INFO_ACTION: function UPDATE_GAME_INFO_ACTION(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var url = handler._getUrl(rootState);
        rootState.$helper.request.put(url, args).then(function () {
            dispatch('GET_GAME_INFO_ACTIONS', { args: 1 });
        }).catch(function (res) {
            // dispatch('ERROR_HANDLE', res, {root: true});
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateGameInfo: function _updateGameInfo(state, args) {
        state.gameInfo = args;
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "SDic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    demoList: [],
    demoStatus: false
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    DEMO_ACTIONS: function DEMO_ACTIONS(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        console.log('DEMO_ACTIONS=>', args, rootState);
        var data = [{ id: 1, data: 'aata1' }, { id: 2, data: 'aata2' }, { id: 3, data: 'aata3' }];
        commit('_updateDemoList', data);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateDemoList: function _updateDemoList(state, args) {
        state.demoList = args;
        console.log(state.demoList);
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "SDvU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    demoList: [],
    demoStatus: false
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    DEMO_ACTIONS: function DEMO_ACTIONS(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        console.log('DEMO_ACTIONS=>', args, rootState);
        var data = [{ id: 1, data: 'aata1' }, { id: 2, data: 'aata2' }, { id: 3, data: 'aata3' }];
        commit('_updateDemoList', data);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateDemoList: function _updateDemoList(state, args) {
        state.demoList = args;
        console.log(state.demoList);
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "SIS3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SLxa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subComponents_sdkUpload__ = __webpack_require__("uhd8");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'set-login-allowed',
    components: {
        upload: __WEBPACK_IMPORTED_MODULE_2__subComponents_sdkUpload__["a" /* default */]
    },
    data: function data() {
        return {
            login_buttons_check_all: '',
            isIndeterminate: false,
            operate_type: '',
            platform: '',
            is_anti_addiction_turn_on: false,
            params: {
                logins: [],
                login_featured: [],
                recommend_login_mode: '',
                priority_to_confirm_allowed: false,
                email_registration_verify_allowed: false,
                recaptcha_allowed: false,
                recaptcha_low_risk_score: 0.8,
                recaptcha_high_risk_score: 0.3,
                step: 'login',
                login_page_logo: '',
                password_level: "low",
                licence_show_type: "merge",
                must_confirm_licence: {
                    user_licence: true,
                    secure_licence: true,
                    years_old: false
                },
                confirm_licence_years_old: 0
            },
            urlLoding: false,
            isVersion5x: false,
            version: '',
            storeCode: "",
            copyCheckeds: [],
            licenceShowTypeSingle: false,
            licenceShowTypeMerge: false,
            loginMethods: [{
                label: '邮箱',
                key: 'email_allowed',
                disabled: true
            }, {
                label: '邮箱',
                key: 'email_allowed',
                disabled: true,
                platform: 'H5'
            }, {
                label: '邮箱',
                key: 'email_allowed',
                disabled: true,
                platform: 'WINDOWS'
            }, {
                label: '手机号',
                key: 'mobile_allowed'
            }, {
                label: 'Apple',
                key: 'apple_allowed',
                platform: 'IOS'
            }, {
                label: 'Gamecenter',
                key: 'gamecenter_allowed',
                platform: 'IOS'
            }, {
                label: 'Facebook',
                key: 'facebook_allowed'
            }, {
                label: 'Facebook',
                key: 'facebook_allowed',
                platform: 'H5'
            }, {
                label: 'Facebook',
                key: 'facebook_allowed',
                platform: 'WINDOWS'
            }, {
                label: 'Line',
                key: 'line_allowed'
            }, {
                label: 'VK',
                key: 'vk_allowed'
            }, {
                label: 'Google',
                key: 'google_allowed',
                platform: 'ANDROID'
            }, {
                label: 'Google',
                key: 'google_allowed',
                platform: 'H5'
            }, {
                label: 'Google',
                key: 'google_allowed',
                platform: 'WINDOWS'
            }, {
                label: 'Twitter',
                key: 'twitter_allowed'
            }, {
                label: 'QooApp',
                key: 'qooapp_allowed',
                platform: 'ANDROID'
            }]
        };
    },

    props: ['isDetail', 'isCopy', 'labelWidth'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$helper', '$lodash']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])("sdkReleasesEdit", ["gameVersion", "packageList", "packageStoreList", "sdkVersion", "data"]), {
        activeUrl: function activeUrl() {
            var urls = {
                mobile_and_email: __webpack_require__("Gp8K"),
                email: __webpack_require__("Nvjk"),
                mobile: __webpack_require__("3q9L")
            };
            return this.params.recommend_login_mode ? urls[this.params.recommend_login_mode] : '';
        },
        loginOptions: function loginOptions() {
            var _this = this;

            return this.loginMethods.filter(function (item, i) {
                // if(this.isVersion5x && item.label === 'Twitter') {
                //     return false;
                // }
                if (_this.platform === "H5") {
                    return item.platform && item.platform === "H5";
                } else if (_this.platform === "WINDOWS") {
                    return item.platform && item.platform === "WINDOWS";
                } else {
                    return !(item.platform && item.platform !== _this.platform);
                }
            });
        }
    }),
    watch: {
        'data.query': function dataQuery(value) {
            var version = "",
                storeCode = "";
            this.sdkVersion.forEach(function (item) {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            });
            var versionStr = version.substr(0, 2);
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
            if (!['5.'].includes(versionStr)) {
                this.isVersion5x = true;
            }
            this.packageStoreList.forEach(function (item) {
                if (parseInt(value.store_id) === parseInt(item.store_id)) {
                    storeCode = item.store_code;
                }
            });
            this.storeCode = storeCode;
        },
        'data.login': function dataLogin() {
            var options = this.loginOptions.map(function (item) {
                return item.key;
            });
            console.log("aaaaa", options);

            this.data.login.logins = this.data.login.logins.filter(function (item) {
                return !!options.includes(item);
            });
            console.log(123123, this.data.login);
            this.params = this.$lodash.cloneDeep(this.data.login);
            this.params.step = 'login';
            this.handleCheckedCitiesChange(this.params.logins, true);
            if (this.params.email_registration_verify_allowed) {
                this.params.recaptcha_allowed = false;
            }
        },
        'data.feature': function dataFeature() {
            this.is_anti_addiction_turn_on = typeof this.data.feature.is_anti_addiction_turn_on !== 'undefined' ? this.data.feature.is_anti_addiction_turn_on : false;

            if (this.storeCode === 'qooapp') {
                console.log(this.params.login_featured);
                this.params.login_featured.splice(this.params.login_featured.indexOf('silence_login_allowed'), 1);
                this.loginMethods.forEach(function (item) {
                    if (item.key === "qooapp_allowed") {
                        item.disabled = false;
                        // item.ischecked = false;
                    }
                });
            } else {
                // this.params.logins.splice(this.params.logins.indexOf('qooapp_allowed'), 1);
                this.loginMethods.forEach(function (item) {
                    if (item.key === "qooapp_allowed") {
                        item.disabled = true;
                    }
                });
            }
        }
    },
    methods: {
        handleFeaturedLogins: function handleFeaturedLogins() {
            var _this2 = this;

            this.urlLoding = true;
            setTimeout(function () {
                _this2.urlLoding = false;
            }, 500);
        },
        selectMerageShowType: function selectMerageShowType(isChecked) {
            if (isChecked) {
                this.params.must_confirm_licence.years_old = false;
                this.params.confirm_licence_years_old = 0;
            }
        },
        checkYearsOld: function checkYearsOld(isChecked) {
            if (isChecked) {
                this.params.confirm_licence_years_old = 14;
            } else {
                this.params.confirm_licence_years_old = 0;
            }
        },
        handleCheckAllChange: function handleCheckAllChange(isChecked) {

            console.log("bbbbb", this.loginOptions);
            console.log('ccc', this.params.logins);
            this.params.logins = isChecked ? this.loginOptions.map(function (item) {
                return item.key;
            }) : ['email_allowed'];
            console.log('dddd', this.params.logins);
            this.params.recommend_login_mode = isChecked ? 'mobile_and_email' : 'email';
            this.isIndeterminate = false;
            if (this.platform == 'ANDROID' && this.storeCode !== 'qooapp' && isChecked) {
                this.params.logins.splice(this.params.logins.indexOf('qooapp_allowed'), 1);
            }
            console.log('eeeee', this.params.logins);
        },
        handleCheckedCitiesChange: function handleCheckedCitiesChange(checkeds) {
            var bOk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var checkedCount = checkeds.length;
            console.log(checkeds.length);
            this.login_buttons_check_all = checkedCount === this.loginOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.loginOptions.length;
            var check = ['mobile_allowed', 'email_allowed'].includes(this.$lodash.difference(checkeds, this.copyCheckeds).join()),
                r_check = ['mobile_allowed', 'email_allowed'].includes(this.$lodash.difference(this.copyCheckeds, checkeds).join());
            if (!bOk && check || !bOk && r_check) {
                this.params.recommend_login_mode = checkeds.indexOf('mobile_allowed') > -1 ? 'mobile_and_email' : 'email';
            }
            this.copyCheckeds = checkeds;
            if (this.params.logins.indexOf('gamecenter_allowed') === -1 && this.params.login_featured.indexOf('silent_game_center_login_allowed') > -1) {
                this.params.login_featured.splice(this.params.login_featured.indexOf('silent_game_center_login_allowed'), 1);
            }
        },
        handlerNext: function handlerNext() {
            var _this3 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this3.$emit('submit', _this3.params);
                    console.log(_this3.params);
                }
            });
        },
        justifyVersion: function justifyVersion(version) {
            var versionarr = version.split(".");
            var version_convert = '';
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            } else {
                version_convert = version;
            }
            return version_convert;
        }
    },
    created: function created() {
        this.operate_type = this.$helper.helper.getParamers("operate_type");
        this.platform = this.$helper.helper.getParamers("platform");
    }
});

/***/ }),

/***/ "SSdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.$config.apiBaseUrl + '/upload-img',"on-success":_vm.handleSuccess,"before-upload":_vm.beforeUpload,"on-error":_vm.errorUpload,"show-file-list":false}},[(_vm.imgUrl)?_c('div',{staticClass:"avatar-box"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.imgUrl,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"shade"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('em',{staticClass:"el-icon-refresh-left"}),_vm._v(" "),_c('div',{staticClass:"upload-size"},[_vm._v(_vm._s(_vm.size))])])]):_c('div',{staticClass:"upload"},[_c('em',{staticClass:"el-icon-plus avatar-uploader-icon"}),_vm._v(" "),_c('div',{staticClass:"upload-size"},[_vm._v(_vm._s(_vm.size))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SiJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},[(_vm.tags.length)?_c('div',_vm._l((_vm.tags),function(item,i){return (Array.isArray(item.value) && item.value.length)?_c('el-tag',{key:i,attrs:{"effect":"dark"}},[_vm._v(_vm._s(item.label)+_vm._s(item.value[0])+"  "),(item.value.length>1 && item.key !== 'date')?_c('span',[_c('span',[_vm._v("...")]),_vm._v(" "+_vm._s(item.value.length)+"个")]):_vm._e()]):_vm._e()}),1):_c('span',[_vm._v("请选择")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Spbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_identified_vue__ = __webpack_require__("KpjD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab1f92c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_identified_vue__ = __webpack_require__("9DxC");
function injectStyle (ssrContext) {
  __webpack_require__("v55N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_identified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab1f92c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_identified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TZaV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "TdxR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/avatar_icon.dcdcf23.png";

/***/ }),

/***/ "TepT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/container-ios1.5b6d6ac.png";

/***/ }),

/***/ "Tg3l":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/color_of_button.4d47ba9.jpeg";

/***/ }),

/***/ "Tgt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('sub-header')],1),_vm._v(" "),_c('el-container',{staticClass:"inner-container"},[(_vm.checkAsideShow())?_c('el-aside',{staticClass:"sub-menu-box"},[_c('sub-aside')],1):_vm._e(),_vm._v(" "),_c('el-main',{attrs:{"id":"page-main"}},[_c('div',{staticClass:"sub-breadcrumb",attrs:{"id":"page-main-breadcrumb"},domProps:{"innerHTML":_vm._s(_vm.breadcrumbHandle())}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$loadingPrivate),expression:"$loadingPrivate"}],staticClass:"loading-private",attrs:{"id":"loading-private"}},[_c('div',{staticClass:"loading-private-wrap"}),_vm._v(" "),_c('div',{staticClass:"loading-private-animate"})]),_vm._v(" "),_c('div',{staticClass:"sub-content-box",style:(_vm.getPadding()),attrs:{"id":"page-main-content"}},[_c('div',{staticClass:"sub-content"},[_vm._t("default")],2)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UVGf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDimension_vue__ = __webpack_require__("OpBl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a04e31f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDimension_vue__ = __webpack_require__("3E/M");
function injectStyle (ssrContext) {
  __webpack_require__("6pTf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a04e31f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchDimension_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a04e31f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchDimension_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UuKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdk-dimension-container"},[_c('el-form',{ref:"form",attrs:{"model":_vm.params,"label-width":_vm.labelWidth,"rules":_vm.rules}},[(_vm.platform !=='WINDOWS')?_c('el-form-item',{attrs:{"label":"个人中心页面开关："}},[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleCheckAllChange},model:{value:(_vm.login_buttons_check_all),callback:function ($$v) {_vm.login_buttons_check_all=$$v},expression:"login_buttons_check_all"}},[_vm._v("全选")]),_vm._v(" "),_c('el-checkbox-group',{on:{"change":_vm.handleCheckedCitiesChange},model:{value:(_vm.params.user_center_alloweds),callback:function ($$v) {_vm.$set(_vm.params, "user_center_alloweds", $$v)},expression:"params.user_center_alloweds"}},_vm._l((_vm.userCenterOptions),function(item){return _c('el-checkbox',{key:item.key,class:{'margin_left0': true},attrs:{"label":item.key,"disabled":item.disabled}},[_c('el-tooltip',{attrs:{"content":item.content,"placement":"top"}},[_c('span',[_vm._v(_vm._s(item.label))])])],1)}),1)],1):_vm._e(),_vm._v(" "),(_vm.platform !== 'H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"激励广告："}},[_c('el-radio-group',{model:{value:(_vm.params.admob_allowed),callback:function ($$v) {_vm.$set(_vm.params, "admob_allowed", $$v)},expression:"params.admob_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"允许欧盟隐私弹窗:"}},[_c('el-radio-group',{model:{value:(_vm.params.eu_consent_allowed),callback:function ($$v) {_vm.$set(_vm.params, "eu_consent_allowed", $$v)},expression:"params.eu_consent_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("允许")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1),_vm._v(" "),(_vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"论坛："}},[_c('el-checkbox-group',{model:{value:(_vm.params.forum_allowed),callback:function ($$v) {_vm.$set(_vm.params, "forum_allowed", $$v)},expression:"params.forum_allowed"}},[_c('el-checkbox',{attrs:{"label":"forum_allowed","disabled":_vm.params.forum_allowed.indexOf('plug_allowed') > -1}},[_vm._v("KTPlay论坛")]),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"plug_allowed","disabled":_vm.params.forum_allowed.indexOf('forum_allowed') > -1}},[_vm._v("PLUG论坛")])],1)],1):_vm._e(),_vm._v(" "),(_vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"防沉迷功能："}},[_c('el-radio',{staticClass:"anti-left",attrs:{"label":true},model:{value:(_vm.params.is_anti_addiction_turn_on),callback:function ($$v) {_vm.$set(_vm.params, "is_anti_addiction_turn_on", $$v)},expression:"params.is_anti_addiction_turn_on"}},[_vm._v("启用")]),_vm._v(" "),_c('span',{staticClass:"anti-addiction-view",on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("（"),_c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.handleAntiAddictionViewConfig($event)}}},[_vm._v("防沉迷规则预览")]),_vm._v("）")]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"开启防沉迷功能，登录逻辑中默认关闭静默登录","placement":"top"}},[_c('em',{staticClass:"el-icon-question"})]),_vm._v(" "),_c('el-radio',{staticClass:"anti-right",attrs:{"label":false},model:{value:(_vm.params.is_anti_addiction_turn_on),callback:function ($$v) {_vm.$set(_vm.params, "is_anti_addiction_turn_on", $$v)},expression:"params.is_anti_addiction_turn_on"}},[_vm._v("禁用")])],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"动态协议配置："}},[_c('el-radio',{staticClass:"sdkconfigedit-ckitem-style",attrs:{"label":""},model:{value:(_vm.params.dynamic_terms),callback:function ($$v) {_vm.$set(_vm.params, "dynamic_terms", $$v)},expression:"params.dynamic_terms"}},[_vm._v("通用配置")]),_vm._v(" "),(_vm.termsList)?_c('div',{staticStyle:{"display":"inline-block","margin-left":"-4px"}},_vm._l((_vm.termsList),function(term,i){return _c('el-radio',{key:i,staticClass:"sdkconfigedit-ckitem-style",attrs:{"label":term.id},model:{value:(_vm.params.dynamic_terms),callback:function ($$v) {_vm.$set(_vm.params, "dynamic_terms", $$v)},expression:"params.dynamic_terms"}},[_vm._v("\n                    "+_vm._s(term.name)+"\n                ")])}),1):_vm._e()],1),_vm._v(" "),(_vm.isShowImageUploadAllowed && _vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"用户权限申请："}},[_c('el-checkbox',{model:{value:(_vm.params.image_upload_allowed),callback:function ($$v) {_vm.$set(_vm.params, "image_upload_allowed", $$v)},expression:"params.image_upload_allowed"}},[_vm._v("获取相册权限")])],1):_vm._e(),_vm._v(" "),(_vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"AppsFlyer："}},[_c('el-radio-group',{model:{value:(_vm.params.appsflyer_allowed),callback:function ($$v) {_vm.$set(_vm.params, "appsflyer_allowed", $$v)},expression:"params.appsflyer_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(
                    _vm.params.appsflyer_allowed && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
                )?_c('el-form-item',{attrs:{"label":"AF等待IDFA时长："}},[_c('el-input-number',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","min":0,"precision":0,"controls":false},model:{value:(_vm.params.appsflyer_wait_for_idfa_time),callback:function ($$v) {_vm.$set(_vm.params, "appsflyer_wait_for_idfa_time", $$v)},expression:"params.appsflyer_wait_for_idfa_time"}}),_vm._v("\n            秒\n        ")],1):_vm._e(),_vm._v(" "),(_vm.platform !=='WINDOWS')?_c('el-form-item',{attrs:{"label":"分享功能："}},[_c('el-checkbox-group',{model:{value:(_vm.params.share),callback:function ($$v) {_vm.$set(_vm.params, "share", $$v)},expression:"params.share"}},[_c('el-checkbox',{attrs:{"label":"fb_share_button_allowed"}},[_vm._v("Facebook分享")]),_vm._v(" "),(_vm.platform !=='H5')?_c('el-checkbox',{attrs:{"label":"vk_share_button_allowed"}},[_vm._v("VK分享")]):_vm._e(),_vm._v(" "),(_vm.showTwitterShare && _vm.platform !=='H5')?_c('el-checkbox',{attrs:{"label":"twitter_share_button_allowed"}},[_vm._v("Twitter分享")]):_vm._e(),_vm._v(" "),(_vm.platform !=='H5')?_c('el-checkbox',{attrs:{"label":"instagram_share_button_allowed"}},[_vm._v("Instagram分享")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.params.share.indexOf('fb_share_button_allowed') > -1  && _vm.platform !='WINDOWS')?_c('el-form-item',{key:"facebook",attrs:{"label":"Facebook分享地址：","prop":"facebook_sharing_url"}},[_c('el-input',{attrs:{"size":"small","placeholder":"https://"},model:{value:(_vm.params.facebook_sharing_url),callback:function ($$v) {_vm.$set(_vm.params, "facebook_sharing_url", $$v)},expression:"params.facebook_sharing_url"}})],1):_vm._e(),_vm._v(" "),(_vm.params.share.indexOf('vk_share_button_allowed') > -1 && _vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{key:"vk",attrs:{"label":"VK分享地址：","prop":"vk_sharing_url"}},[_c('el-input',{attrs:{"size":"small","placeholder":"https://"},model:{value:(_vm.params.vk_sharing_url),callback:function ($$v) {_vm.$set(_vm.params, "vk_sharing_url", $$v)},expression:"params.vk_sharing_url"}})],1):_vm._e(),_vm._v(" "),(_vm.showTwitterShare && _vm.params.share.indexOf('twitter_share_button_allowed') > -1 && _vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{key:"twitter",attrs:{"label":"Twitter分享地址：","prop":"twitter_sharing_url"}},[_c('el-input',{attrs:{"size":"small","placeholder":"https://"},model:{value:(_vm.params.twitter_sharing_url),callback:function ($$v) {_vm.$set(_vm.params, "twitter_sharing_url", $$v)},expression:"params.twitter_sharing_url"}})],1):_vm._e(),_vm._v(" "),(_vm.platform==='H5' || _vm.platform ==='WINDOWS')?_c('el-form-item',{attrs:{"label":"网页icon："}},[_c('div',{staticClass:"dialog-upload-btn-box"},[_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[_c('div',[_vm._v("尺寸要求： 32*32px "),_c('font',{attrs:{"color":"red"}},[_vm._v("(请上传png格式)")])],1),_vm._v(" "),_c('upload',{attrs:{"size":"32 * 32px","formatlimit":"png"},model:{value:(_vm.params.page_icon),callback:function ($$v) {_vm.$set(_vm.params, "page_icon", $$v)},expression:"params.page_icon"}})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.platform==='WINDOWS')?_c('el-form-item',{attrs:{"label":"网页背景图："}},[_c('div',{staticClass:"dialog-upload-btn-box"},[_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[_c('div',[_vm._v("尺寸要求：宽度至少1080px,宽度可根据预期页面效果调整"),_c('font',{attrs:{"color":"red"}},[_vm._v("(请上传png格式)")])],1),_vm._v(" "),_c('upload',{attrs:{"formatlimit":"png","size":"1920*1080px"},model:{value:(_vm.params.page_right_background_image),callback:function ($$v) {_vm.$set(_vm.params, "page_right_background_image", $$v)},expression:"params.page_right_background_image"}})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.platform==='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"游戏左侧背景图："}},[_c('div',{staticClass:"dialog-upload-btn-box"},[_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[_c('div',[_vm._v("尺寸要求：宽度至少1080px,宽度可根据预期页面效果调整，"),_c('font',{attrs:{"color":"red"}},[_vm._v("(请上传png格式)")])],1),_vm._v(" "),_c('upload',{attrs:{"formatlimit":"png"},model:{value:(_vm.params.page_left_background_image),callback:function ($$v) {_vm.$set(_vm.params, "page_left_background_image", $$v)},expression:"params.page_left_background_image"}})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.platform==='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"游戏右侧背景图："}},[_c('div',{staticClass:"dialog-upload-btn-box"},[_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[_c('div',[_vm._v("尺寸要求：宽度至少1080px,宽度可根据预期页面效果调整，与左侧背景图保持大小一致，"),_c('font',{attrs:{"color":"red"}},[_vm._v("(请上传png格式)")])],1),_vm._v(" "),_c('upload',{attrs:{"formatlimit":"png"},model:{value:(_vm.params.page_right_background_image),callback:function ($$v) {_vm.$set(_vm.params, "page_right_background_image", $$v)},expression:"params.page_right_background_image"}})],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":_vm.networkName}},[_c('el-radio-group',{model:{value:(_vm.params.ping_stats_collection_allowed),callback:function ($$v) {_vm.$set(_vm.params, "ping_stats_collection_allowed", $$v)},expression:"params.ping_stats_collection_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(
                    _vm.params.ping_stats_collection_allowed && _vm.version < 7.10 && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
                )?_c('el-form-item',{attrs:{"label":"ping次数：","prop":"ping_count"}},[_c('el-input-number',{ref:"ping_count",staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","min":0,"precision":0,"controls":false},model:{value:(_vm.params.ping_count),callback:function ($$v) {_vm.$set(_vm.params, "ping_count", $$v)},expression:"params.ping_count"}}),_vm._v("\n            次\n        ")],1):_vm._e(),_vm._v(" "),(
                _vm.params.ping_stats_collection_allowed && _vm.version < 7.10 && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
            )?_c('el-form-item',{attrs:{"prop":"ping_domain_list","label":"ping地址："}},[_c('el-input',{ref:"ping_domain_list",attrs:{"placeholder":"建议最多填写5个，用回车分隔。","size":"small","type":"textarea","rows":"4"},model:{value:(_vm.params.ping_domain_list),callback:function ($$v) {_vm.$set(_vm.params, "ping_domain_list", $$v)},expression:"params.ping_domain_list"}})],1):_vm._e(),_vm._v(" "),(
                    _vm.params.ping_stats_collection_allowed && _vm.version >= 7.10 && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
                )?_c('el-form-item',{attrs:{"prop":"ping_frequency","label":"ping频率："}},[_vm._v("\n            每\n            "),_c('el-input-number',{ref:"ping_frequency",staticClass:"ping-formitem-width",attrs:{"size":"small","min":30,"precision":0,"controls":false,"placeholder":"最少为30分钟"},model:{value:(_vm.params.ping_frequency),callback:function ($$v) {_vm.$set(_vm.params, "ping_frequency", $$v)},expression:"params.ping_frequency"}}),_vm._v("分钟执行一次,每个域名ping\n\n            "),_c('el-input-number',{ref:"ping_count",staticClass:"ping-formitem-width",attrs:{"size":"small","min":1,"max":10,"precision":0,"controls":false,"placeholder":"最多为10次"},model:{value:(_vm.params.ping_count),callback:function ($$v) {_vm.$set(_vm.params, "ping_count", $$v)},expression:"params.ping_count"}}),_vm._v("\n            次\n      ")],1):_vm._e(),_vm._v(" "),(
                _vm.params.ping_stats_collection_allowed && _vm.version >= 7.10 && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
            )?_c('el-form-item',{attrs:{"prop":"ping_domain_list","label":"ping地址："}},[_c('el-input',{ref:"ping_domain_list",attrs:{"placeholder":"注：填写URL时去掉http/https部分，支持填写IP地址","size":"small","type":"textarea","rows":"4"},model:{value:(_vm.params.ping_domain_list),callback:function ($$v) {_vm.$set(_vm.params, "ping_domain_list", $$v)},expression:"params.ping_domain_list"}})],1):_vm._e(),_vm._v(" "),(
                    _vm.params.ping_stats_collection_allowed && _vm.version >= 7.10 && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
                )?_c('el-form-item',{attrs:{"label":"traceroute频率："}},[_vm._v("\n            每\n            "),_c('el-input-number',{ref:"trace_route_frequency",staticClass:"ping-formitem-width",attrs:{"size":"small","min":30,"precision":0,"controls":false,"placeholder":"最少为30分钟"},model:{value:(_vm.params.trace_route_frequency),callback:function ($$v) {_vm.$set(_vm.params, "trace_route_frequency", $$v)},expression:"params.trace_route_frequency"}}),_vm._v("\n            分钟执行一次,traceroute 1次。\n        ")],1):_vm._e(),_vm._v(" "),(
                _vm.params.ping_stats_collection_allowed && _vm.version >= 7.10 && _vm.platform !=='H5' && _vm.platform !='WINDOWS'
            )?_c('el-form-item',{attrs:{"label":"traceroute地址："}},[_c('el-input',{ref:"trace_route_domain_list",attrs:{"placeholder":_vm.tracerouteHint,"size":"small","type":"textarea","rows":"4"},model:{value:(_vm.params.trace_route_domain_list),callback:function ($$v) {_vm.$set(_vm.params, "trace_route_domain_list", $$v)},expression:"params.trace_route_domain_list"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"国家年龄限制：","prop":"country_age_constrains_config"}},[_c('el-input',{attrs:{"size":"small","placeholder":"例如: 'US:18,BR:17' 表示美国18岁以上，巴西17岁以上"},model:{value:(_vm.params.country_age_constrains_config),callback:function ($$v) {_vm.$set(_vm.params, "country_age_constrains_config", $$v)},expression:"params.country_age_constrains_config"}})],1),_vm._v(" "),(_vm.platform === 'ANDROID')?_c('el-form-item',{attrs:{"label":"PlayGameService成就:"}},[_c('el-radio-group',{model:{value:(_vm.params.play_game_service_achievements_allowed),callback:function ($$v) {_vm.$set(_vm.params, "play_game_service_achievements_allowed", $$v)},expression:"params.play_game_service_achievements_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.platform === 'IOS')?_c('el-form-item',{attrs:{"label":"GameCenter成就:"}},[_c('el-radio-group',{model:{value:(_vm.params.game_center_achievements_allowed),callback:function ($$v) {_vm.$set(_vm.params, "game_center_achievements_allowed", $$v)},expression:"params.game_center_achievements_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.compareVersion(_vm.version,'7.13') && _vm.platform !='WINDOWS'  && _vm.platform !='H5')?_c('el-form-item',{attrs:{"label":"截屏分享提示："}},[_c('el-radio-group',{model:{value:(_vm.params.screenshot_share_allowed),callback:function ($$v) {_vm.$set(_vm.params, "screenshot_share_allowed", $$v)},expression:"params.screenshot_share_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isShowQuestionnaireUrl && _vm.platform !=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"调查问卷地址：","prop":"questionnaire_url"}},[_c('el-input',{attrs:{"size":"small"},model:{value:(_vm.params.questionnaire_url),callback:function ($$v) {_vm.$set(_vm.params, "questionnaire_url", $$v)},expression:"params.questionnaire_url"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',[(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog-configuration",attrs:{"title":"防沉迷规则预览","visible":_vm.antiAddictionVisible,"width":"650px"},on:{"update:visible":function($event){_vm.antiAddictionVisible=$event}}},[_c('configuration',{attrs:{"go-to-configure":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uul0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    iosPackageList: [],
    androidPackageList: [],
    h5PackageList: [],
    windowsPackageList: [],

    iosSdkVersion: [],
    androidSdkVersion: [],
    h5SdkVersion: [],
    windowsSdkVersion: [],

    iosPackageStoreList: [],
    androidPackageStoreList: [],
    h5PackageStoreList: [],
    windowsPackageStoreList: [],

    planInfo: []

};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_PACKAGE_LIST: function GET_PACKAGE_LIST(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenamelist', {
            game_code: gameCode,
            platform: args.platform
        }).then(function (res) {
            data = res.data.result;
            if (args.platform === 'IOS') {
                commit('_iosPackageList', data);
            } else if (args.platform === 'H5') {
                commit('_h5PackageList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsPackageList', data);
            } else {
                commit('_androidPackageList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_SDK_VERSION: function GET_SDK_VERSION(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {}).then(function (res) {
            data = res.data.sdk_versions;
            if (args.platform === 'IOS') {
                commit('_iosSdkVersion', data);
            } else if (args.platform === 'H5') {
                commit('_h5SdkVersion', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsSdkVersion', data);
            } else {
                commit('_androidSdkVersion', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_EDIT_PLAN: function GET_EDIT_PLAN(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/games/' + gameCode + '/plans/' + args.plan_id, {}).then(function (res) {
            data = res.data.plan;
            data['plan_id'] = parseInt(data['plan_id']);
            if (args.operate_type === 'copy') {
                data['package_id'] = '';
                data['sdk_version_id'] = '';
                data['store_id'] = '';
            } else {
                data['package_id'] = parseInt(data['package_id']);
                data['sdk_version_id'] = parseInt(data['sdk_version_id']);
                data['store_id'] = data['store_id'] + '';
            }

            commit('_planInfo', data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PACKAGE_STORE: function GET_PACKAGE_STORE(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var data = [];
        rootState.$helper.request.get('/ajaxrela/getpackagenamestorelist', { package_id: args.package_id }).then(function (res) {
            data = res.data.result;
            if (args.platform === 'IOS') {
                commit('_iosPackageStoreList', data);
            } else if (args.platform === 'H5') {
                commit('_h5PackageStoreList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsPackageStoreList', data);
            } else {
                commit('_androidPackageStoreList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_ANDROID_SUBMIT: function PUT_ANDROID_SUBMIT(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/plans/new', args).then(function (res) {
            data = res.data.created;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '添加成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '编辑失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist');
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_ANDROID_COPY_SUBMIT: function PUT_ANDROID_COPY_SUBMIT(_ref6, args) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/plans/new', args).then(function (res) {
            data = res.data.created;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '复制成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '复制失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist');
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_ANDROID_EDIT_SUBMIT: function PUT_ANDROID_EDIT_SUBMIT(_ref7, args) {
        var state = _ref7.state,
            commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            rootState = _ref7.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/plans/' + args.plan_id, args).then(function (res) {
            data = res.data.edited;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '编辑成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '编辑失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/configlist');
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GAME_SYNC: function GAME_SYNC(_ref8, args) {
        var state = _ref8.state,
            commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            rootState = _ref8.rootState;

        var data = [];
        var dataRes = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getcoregames', { game_code: gameCode }).then(function (res) {
            data = res.data;
            if (data) {
                dataRes['mdata_app_id'] = data['mdata_app_id'];
                dataRes['facebook_app_id'] = data['facebook_app_id'];
                dataRes['facebook_app_url'] = data['facebook_app_url'];
            } else {}
            args.callback(dataRes);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _iosPackageList: function _iosPackageList(state, args) {
        state.iosPackageList = args;
        console.log('_iosPackageList=', state.iosPackageList);
    },
    _androidPackageList: function _androidPackageList(state, args) {
        state.androidPackageList = args;
        console.log('_androidPackageList=', state.androidPackageList);
    },
    _h5PackageList: function _h5PackageList(state, args) {
        state.h5PackageList = args;
        console.log('_h5PackageList=', state.h5PackageList);
    },
    _windowsPackageList: function _windowsPackageList(state, args) {
        state.windowsPackageList = args;
        console.log('_windowsPackageList=', state.windowsPackageList);
    },
    _iosSdkVersion: function _iosSdkVersion(state, args) {
        state.iosSdkVersion = args;
        console.log('_iosSdkVersion=', state.iosSdkVersion);
    },
    _androidSdkVersion: function _androidSdkVersion(state, args) {
        state.androidSdkVersion = args;
        console.log('_androidSdkVersion=', state.androidSdkVersion);
    },
    _h5SdkVersion: function _h5SdkVersion(state, args) {
        state.h5SdkVersion = args;
        console.log('_h5SdkVersion=', state.h5SdkVersion);
    },
    _windowsSdkVersion: function _windowsSdkVersion(state, args) {
        state.windowsSdkVersion = args;
        console.log('_windowsSdkVersion=', state.windowsSdkVersion);
    },
    _iosPackageStoreList: function _iosPackageStoreList(state, args) {
        state.iosPackageStoreList = args;
        console.log('_iosPackageStoreList=', state.iosPackageStoreList);
    },
    _androidPackageStoreList: function _androidPackageStoreList(state, args) {
        state.androidPackageStoreList = args;
        console.log('_androidPackageStoreList=', state.androidPackageStoreList);
    },
    _h5PackageStoreList: function _h5PackageStoreList(state, args) {
        state.h5PackageStoreList = args;
        console.log('_h5PackageStoreList=', state.h5PackageStoreList);
    },
    _windowsPackageStoreList: function _windowsPackageStoreList(state, args) {
        state.windowsPackageStoreList = args;
        console.log('_windowsPackageStoreList=', state.windowsPackageStoreList);
    },
    _planInfo: function _planInfo(state, args) {
        state.planInfo = args;
        console.log('_planInfo=', state.planInfo);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "UyO4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UzzN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "VKDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sub-aside",
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(["$md5", "$base64", "$page", "$lodash", "$helper", "$route", "$routerMaps", "$projectType", "$isaccess", "$activeGameCode"]), {
        filterMaps: function filterMaps() {
            var _this = this;

            var tmp = {};
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forIn"])(this.$routerMaps, function (item, key) {
                if (key !== "system" && item.projectType === _this.$projectType) {
                    var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
                        link: ("/" + item.url + "?").toLowerCase()
                    });
                    if (obj.children) {
                        var children = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj.children);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["forIn"])(children, function (child, ck) {
                            children[ck].link = ("/" + key + "/" + child.url + "?").toLowerCase();
                            if (child.jumpToRoute) {
                                children[ck].link = ("/" + child.jumpToRoute + ".html?").toLowerCase();
                            }
                        });
                        obj.children = children;
                    }

                    tmp[key] = obj;
                }
            });
            return tmp;
        },
        urlParams: function urlParams() {
            var tmp = this.getUrlParams();
            if (this.$page.indexOf('recharge') > -1) {
                var obj = {};
                obj.game_code = tmp.game_code;
                tmp = obj;
            } else {
                tmp = {
                    game_code: tmp.game_code
                };
            }
            return __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, tmp, {
                game_code: this.$activeGameCode
            }));
        }
    }),

    created: function created() {},

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])(["LOADING", "SAVE_VUE_OBJECT", "LOGOUT"]), {
        getUrlParams: function getUrlParams() {
            var urlParams = window.location.search;
            if (urlParams) {
                urlParams = urlParams.substr(1);
                urlParams = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.parse(urlParams);
            } else {
                urlParams = {};
            }
            return urlParams;
        },

        /**
         * 设置当前选择样式
         * @returns {string}
         */
        activeHandle: function activeHandle() {
            var patharr = this.$page.split("/");

            if (patharr.length > 1) {
                var mune = this.$routerMaps[patharr[0]]["children"][patharr[1]];
                return patharr[0] + "-" + mune.active;
            } else {
                return this.$page;
            }
        },


        /**
         * 选择Menu页面跳转
         * @param key
         * @param keyPath
         */
        subMenuSelected: function subMenuSelected(key, keyPath) {
            //console.log("--------->0",key, keyPath);
            //this.LOADING(true);
            /**无子节点菜单**/
            // if (keyPath.length === 1) {
            //     let menu = this.$routerMaps[keyPath];
            //     /**自定义路由跳转**/
            //     if (menu["jumpToRoute"]) {
            //         this.$route(menu["jumpToRoute"].toLocaleLowerCase());
            //     } else {
            //         this.$route(keyPath[0].toLocaleLowerCase());
            //     }
            //     return;
            // }
            // /**有子节点菜单**/
            // let arr = keyPath[1].split("-");
            // let menu = this.$routerMaps[arr[0]]["children"][arr[1]];
            // if (menu["jumpToRoute"]) {
            //     this.$route(menu["jumpToRoute"].toLocaleLowerCase());
            // } else {
            //     this.$route(arr.join("/").toLocaleLowerCase());
            // }
        },
        handleOpen: function handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose: function handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
    })
});

/***/ }),

/***/ "VPC1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var mergeCustomizer = function mergeCustomizer(objValue, srcValue) {
    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(objValue)) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(objValue.concat(srcValue));
    }
};

var setChildrenInfo = function setChildrenInfo() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var tmp = {
        children_auto_ids: [],
        children_types: [],
        children_status: [],
        children_type_object: {},
        children_status_object: {}
    };
    data.forEach(function (item) {
        var obj = {};
        if (item.children && item.children.length) {
            obj = setChildrenInfo(item.children);
        }
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forIn(obj, function (value, key) {
            item[key] = value;
        });

        tmp.children_auto_ids.push(item.server_info.server_auto_id);
        tmp.children_types.push(item.server_info.server_type);
        tmp.children_status.push(item.server_info.server_status);

        tmp.children_type_object[item.server_info.server_auto_id] = item.server_info.server_type;
        tmp.children_status_object[item.server_info.server_auto_id] = item.server_info.server_status;
        tmp = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.mergeWith({}, tmp, obj, mergeCustomizer);
    });
    return tmp;
};

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    serverList: [],
    regionList: {},
    currentRegion: "",
    demoStatus: false,
    servers: {},
    srcServers: {},
    regionTips: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_SERVERS: function GET_SERVERS(_ref, args) {
        var commit = _ref.commit,
            rootState = _ref.rootState,
            dispatch = _ref.dispatch;

        commit("PRIVATE_LOADING", true, { root: true });
        var data = "",
            servers = "";
        return rootState.$helper.request.get(rootState.$config.api.serverlist).then(function (res) {
            data = res.data.server_rela;
            servers = res.data.servers;
            commit("_updateServerList", data);
            commit("_updateServers", servers);
            commit("_updateSrcServers", servers);
            commit("PRIVATE_LOADING", false, { root: true });
            return res;
        }).catch(function (err) {
            commit("PRIVATE_LOADING", false, { root: true });
            dispatch("ERROR_HANDLE", err, { root: true });
        });
    },
    GET_REGIONS: function GET_REGIONS(_ref2, args) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState,
            dispatch = _ref2.dispatch;

        rootState.$helper.request.get(rootState.$config.api.region).then(function (res) {
            commit("_updateRegion", res.data.result);
        }).catch(function (err) {
            dispatch("ERROR_HANDLE", err, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.serverList = state.serverList.concat(data);
        return state.serverList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateServerList: function _updateServerList(state, args) {
        var tmp = [];
        _.forEach(args, function (value, key) {
            tmp = tmp.concat(value.root_server.map(function (item) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ parent: true }, item);
            }));

            if (state.regionList[key]) {
                if (!state.currentRegion) state.currentRegion = key;
                state.regionTips[key] = [value.open_num, value.close_num];
            }
        });

        setChildrenInfo(tmp);
        state.serverList = tmp;
    },
    _updateServers: function _updateServers(state, args) {
        state.servers = {};
        _.forEach(args, function (value, key) {
            if (value.merge_target == 0) {
                state.servers[key] = value;
            }
        });
    },
    _updateSrcServers: function _updateSrcServers(state, servers) {
        state.srcServers = servers;
    },
    _updateRegion: function _updateRegion(state, args) {
        state.regionList = {};
        _.forEach(args, function (value, key) {
            state.regionList[value.region_code] = value.region_name;
        });
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "VUCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Ve3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__("HMcL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8b3fcec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("CuWD");
function injectStyle (ssrContext) {
  __webpack_require__("tCok")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8b3fcec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8b3fcec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W7bp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushDeviceFilter_vue__ = __webpack_require__("s2HP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e80533_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushDeviceFilter_vue__ = __webpack_require__("6OKO");
function injectStyle (ssrContext) {
  __webpack_require__("0nXr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e80533"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushDeviceFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e80533_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushDeviceFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W8tW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basisConfig_vue__ = __webpack_require__("hv0W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15847ca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basisConfig_vue__ = __webpack_require__("FrMB");
function injectStyle (ssrContext) {
  __webpack_require__("LI5c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15847ca6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basisConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15847ca6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basisConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WNVH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/rechargerecord.ace573e.png";

/***/ }),

/***/ "WW6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    demoList: [],
    demoStatus: false
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    DEMO_ACTIONS: function DEMO_ACTIONS(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        console.log('DEMO_ACTIONS=>', args, rootState);
        var data = [{ id: 1, data: 'aata1' }, { id: 2, data: 'aata2' }, { id: 3, data: 'aata3' }];
        commit('_updateDemoList', data);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateDemoList: function _updateDemoList(state, args) {
        state.demoList = args;
        console.log(state.demoList);
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "WX7q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WfUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Wtzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Y0eg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basisConfig__ = __webpack_require__("W8tW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__noIdentified__ = __webpack_require__("4chI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identified__ = __webpack_require__("Spbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var requiredConfig = [{ required: true, message: ' ' }];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "config",
    components: {
        basisConfig: __WEBPACK_IMPORTED_MODULE_4__basisConfig__["a" /* default */],
        noIdentified: __WEBPACK_IMPORTED_MODULE_5__noIdentified__["a" /* default */],
        identified: __WEBPACK_IMPORTED_MODULE_6__identified__["a" /* default */]
    },
    props: {
        goToConfigure: {
            type: Boolean,
            default: false
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['$activeGameCode', '$isGameAdmin', '$isAdmin', '$roles']), {
        isConfigBtn: function isConfigBtn() {
            if (this.goToConfigure && (this.$isAdmin || this.$isGameAdmin && (this.$roles.indexOf('ROLE_APP_ODP5_CUSTOM_ANTIADDICTION') > -1 || this.$roles.indexOf('ROLE_APP_ODP5_CUSTOM_ANTIADDICTION_CONFIGURATION') > -1))) {
                return true;
            } else {
                return false;
            }
        }
    }),
    data: function data() {
        return {
            params: {
                names: [],
                regular_timing_from: '',
                force_offline_notice_before_minutes: undefined,
                no_identified_user_rule: {
                    timing_period_days: undefined,
                    total_game_minutes: undefined
                },
                identified_user_rules: [{
                    age_from: "",
                    age_to: "",
                    limit_type: [1, 2],
                    payment_rule: {
                        currency_type: 1,
                        max_consume_per_order: '',
                        max_consume_per_month: ''
                    },
                    login_rule: {
                        holiday: {
                            rules: [this.initLoginRules({}).login_rule],
                            changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                        },
                        work_day_normal: {
                            rules: [this.initLoginRules({}).login_rule],
                            changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                        },
                        work_day_special: {
                            rules: [this.initLoginRules({}).login_rule],
                            changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                        }
                    },
                    changeTimeOptions: {
                        holiday: this.initLoginRules({}).changeTimeOptions,
                        work_day_normal: this.initLoginRules({}).changeTimeOptions,
                        work_day_special: this.initLoginRules({}).changeTimeOptions
                    }
                }]
            },
            is_configured: false,
            is_edit: true,
            configRules: {
                force_offline_notice_before_minutes: requiredConfig,
                'no_identified_user_rule.timing_period_days': requiredConfig,
                'no_identified_user_rule.total_game_minutes': requiredConfig
            }
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('antiAddictionConfiguration', ['updateAntiAddictionConfig', 'getAntiAddictionConfig']), {
        openConfig: function openConfig() {
            var url = '/antiaddiction/configuration.html?game_code=' + this.$activeGameCode;
            window.open(url);
        },
        initLoginRules: function initLoginRules(_ref) {
            var options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, []);

            return {
                login_rule: {
                    date_type: options.date_type,
                    daily_max_game_time: options.daily_max_game_time,
                    start_time: options.start_time,
                    end_time: options.end_time
                },
                changeTimeOptions: [{
                    label: '累计可玩时长',
                    value: 1,
                    disable: false
                }, {
                    label: '指定时间不可登陆',
                    value: 2,
                    disable: false
                }, {
                    label: '指定时间可登陆',
                    value: 3,
                    disable: false
                }]
            };
        },
        handleAddTimeRange: function handleAddTimeRange(currentAgeRange, type) {
            if (type === "holiday") {
                currentAgeRange.login_rule.holiday.rules.push(this.initLoginRules({}).login_rule);
            } else if (type === "work_day_normal") {
                currentAgeRange.login_rule.work_day_normal.rules.push(this.initLoginRules({}).login_rule);
            } else if (type === "work_day_special") {
                currentAgeRange.login_rule.work_day_special.rules.push(this.initLoginRules({}).login_rule);
            }
        },
        handleDeleteTimeRange: function handleDeleteTimeRange(item, timeIndex, type) {
            if (type === "holiday") {
                item.login_rule.holiday.rules.splice(timeIndex, 1);
                this.changeTimeRange(false, item, "holiday");
            } else if (type === "work_day_normal") {
                item.login_rule.work_day_normal.rules.splice(timeIndex, 1);
                this.changeTimeRange(false, item, "work_day_normal");
            } else if (type === "work_day_special") {
                item.login_rule.work_day_special.rules.splice(timeIndex, 1);
                this.changeTimeRange(false, item, "work_day_special");
            }
        },
        handleAddAgeRange: function handleAddAgeRange() {
            this.params.names.push(this.params.identified_user_rules.length);
            this.params.identified_user_rules.push({
                age_from: "",
                age_to: "",
                limit_type: [1, 2],
                payment_rule: {
                    currency_type: 1,
                    max_consume_per_order: '',
                    max_consume_per_month: ''
                },
                login_rule: {
                    holiday: {
                        rules: [this.initLoginRules({}).login_rule],
                        changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                    },
                    work_day_normal: {
                        rules: [this.initLoginRules({}).login_rule],
                        changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                    },
                    work_day_special: {
                        rules: [this.initLoginRules({}).login_rule],
                        changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                    }
                },
                changeTimeOptions: {
                    holiday: this.initLoginRules({}).changeTimeOptions,
                    work_day_normal: this.initLoginRules({}).changeTimeOptions,
                    work_day_special: this.initLoginRules({}).changeTimeOptions
                }
            });
        },
        handleDeleteAgeRange: function handleDeleteAgeRange(index) {
            this.params.identified_user_rules.splice(index, 1);
            if (this.params.names.indexOf(index) > -1) {
                this.params.names.splice(this.params.names.indexOf(index), 1);
            }
        },
        submit: function submit() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    /**
                     * check ages
                     * */
                    _this.params.identified_user_rules.forEach(function (item, i) {
                        if (i && item.age_from < _this.params.identified_user_rules[i - 1].age_to) {
                            _this.$alert(item.age_from + '\u5C81 \u81F3 ' + item.age_to + '\u5C81\u7684\u5E74\u9F84\u6709\u91CD\u5408\uFF0C\u8BF7\u91CD\u65B0\u914D\u7F6E\uFF01', '提示');
                            throw '年龄重合';
                        }
                    });
                    if (_this.params.no_identified_user_rule.timing_period_days * _this.params.no_identified_user_rule.total_game_minutes > _this.params.no_identified_user_rule.timing_period_days * 1440) {
                        _this.$alert('未认证玩家配置中的累计登录时长应小于配置天数的总时长！', '提示');
                        return false;
                    }

                    _this.updateAntiAddictionConfig({
                        params: _this.params,
                        is_edit: _this.is_edit
                    }).then(function () {
                        _this.$alert('保存成功！', '提示');
                        _this.is_configured = false;
                    });
                } else {
                    _this.$alert('请您完善配置！', '提示');
                }
            });
        },
        changeTimeRange: function changeTimeRange(event, item, type) {
            if (!event) {
                /*
                 const currentAgeRangeTypes =  item.login_rule.map(item => item.date_type);
                 item.changeTimeOptions.forEach(keys => {
                 keys.disable = !!(currentAgeRangeTypes.indexOf(keys.value) > -1 && keys.value !== 3);
                 })
                 if(currentAgeRangeTypes.indexOf(1) > -1 || currentAgeRangeTypes.indexOf(2) > -1) {
                 item.changeTimeOptions[3].disable = true
                 }
                 if(currentAgeRangeTypes.indexOf(4) > -1 ) {
                 item.changeTimeOptions[0].disable = true
                 item.changeTimeOptions[1].disable = true
                 }
                 */
                if (type === "holiday") {
                    var currentAgeRangeTypes = item.login_rule.holiday.rules.map(function (item) {
                        return item.date_type;
                    });
                    item.login_rule.holiday.changeTimeOptions.forEach(function (keys) {
                        keys.disable = !!(currentAgeRangeTypes.indexOf(keys.value) > -1 && keys.value === 1);
                    });
                    if (currentAgeRangeTypes.indexOf(1) > -1) {
                        item.login_rule.holiday.changeTimeOptions[0].disable = true;
                    }
                } else if (type === "work_day_normal") {
                    var _currentAgeRangeTypes = item.login_rule.work_day_normal.rules.map(function (item) {
                        return item.date_type;
                    });
                    item.login_rule.work_day_normal.changeTimeOptions.forEach(function (keys) {
                        keys.disable = !!(_currentAgeRangeTypes.indexOf(keys.value) > -1 && keys.value === 1);
                    });
                    if (_currentAgeRangeTypes.indexOf(1) > -1) {
                        item.login_rule.work_day_normal.changeTimeOptions[0].disable = true;
                    }
                } else if (type === "work_day_special") {
                    var _currentAgeRangeTypes2 = item.login_rule.work_day_special.rules.map(function (item) {
                        return item.date_type;
                    });
                    item.login_rule.work_day_special.changeTimeOptions.forEach(function (keys) {
                        keys.disable = !!(_currentAgeRangeTypes2.indexOf(keys.value) > -1 && keys.value === 1);
                    });
                    if (_currentAgeRangeTypes2.indexOf(1) > -1) {
                        item.login_rule.work_day_special.changeTimeOptions[0].disable = true;
                    }
                }
            }
        },
        changeAgeFrom: function changeAgeFrom(e, item) {
            if (item.age_to <= e) {
                item.age_to = '';
            }
        },
        initAntiAddictionConfig: function initAntiAddictionConfig() {
            var _this2 = this;

            var isEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.getAntiAddictionConfig().then(function (res) {
                var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(res.data);
                /**
                 * daily_max_game_minutes_of_natural_day  = 4
                 * forbidden_game_minutes_periods = 3
                 * daily_max_game_minutes_of_work_day = 2
                 * daily_max_game_minutes_of_holiday  = 1
                 *
                 * daily_max_game_minutes = 1
                 * forbidden_game_minutes_periods = 2
                 * allow_game_minutes_periods =  3
                 * */
                console.log("res.data");
                console.log(res.data);
                res.data.identified_user_rules.forEach(function (item, index) {
                    /*
                     if(!Array.isArray(data.identified_user_rules[index].login_rule.holiday)){
                     data.identified_user_rules[index].login_rule.holiday = [];
                     }
                     if (!Array.isArray(data.identified_user_rules[index].login_rule.work_day_normal)) {
                     data.identified_user_rules[index].login_rule.work_day_normal = [];
                     }
                     if (!Array.isArray(data.identified_user_rules[index].login_rule.work_day_special)) {
                     data.identified_user_rules[index].login_rule.work_day_special = [];
                     }*/

                    data.identified_user_rules[index].limit_type = item.limit_type;

                    //holiday......
                    console.log("holiday......");
                    data.identified_user_rules[index].login_rule.holiday.changeTimeOptions = _this2.initLoginRules({}).changeTimeOptions;
                    data.identified_user_rules[index].login_rule.holiday.rules = [];
                    console.log(data.identified_user_rules[index]);

                    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.login_rule.holiday);
                    console.log(keys);

                    keys.forEach(function (key) {
                        if (key === 'daily_max_game_minutes') {
                            data.identified_user_rules[index].login_rule.holiday.rules.push(_this2.initLoginRules({
                                date_type: 1,
                                daily_max_game_time: item.login_rule.holiday[key]
                            }).login_rule);
                        }
                    });
                    console.log(data.identified_user_rules[index]);

                    _this2.changeTimeRange(false, data.identified_user_rules[index], 'holiday');
                    if (Array.isArray(item.login_rule.holiday.forbidden_game_minutes_periods) && item.login_rule.holiday.forbidden_game_minutes_periods.length) {
                        item.login_rule.holiday.forbidden_game_minutes_periods.forEach(function (times) {
                            data.identified_user_rules[index].login_rule.holiday.rules.push(_this2.initLoginRules({
                                date_type: 2,
                                start_time: times[0],
                                end_time: times[1]
                            }).login_rule);
                        });
                    }
                    if (Array.isArray(item.login_rule.holiday.allow_game_minutes_periods) && item.login_rule.holiday.allow_game_minutes_periods.length) {
                        item.login_rule.holiday.allow_game_minutes_periods.forEach(function (times) {
                            data.identified_user_rules[index].login_rule.holiday.rules.push(_this2.initLoginRules({
                                date_type: 3,
                                start_time: times[0],
                                end_time: times[1]
                            }).login_rule);
                        });
                    }

                    //work_day_normal......
                    console.log("work_day_normal......");
                    data.identified_user_rules[index].login_rule.work_day_normal.changeTimeOptions = _this2.initLoginRules({}).changeTimeOptions;
                    data.identified_user_rules[index].login_rule.work_day_normal.rules = [];
                    console.log(data.identified_user_rules[index]);

                    var keys_normal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.login_rule.work_day_normal);
                    console.log(keys_normal);

                    keys_normal.forEach(function (key) {
                        if (key === 'daily_max_game_minutes') {
                            data.identified_user_rules[index].login_rule.work_day_normal.rules.push(_this2.initLoginRules({
                                date_type: 1,
                                daily_max_game_time: item.login_rule.work_day_normal[key]
                            }).login_rule);
                        }
                    });
                    console.log(data.identified_user_rules[index]);

                    _this2.changeTimeRange(false, data.identified_user_rules[index], 'work_day_normal');
                    if (Array.isArray(item.login_rule.work_day_normal.forbidden_game_minutes_periods) && item.login_rule.work_day_normal.forbidden_game_minutes_periods.length) {
                        item.login_rule.work_day_normal.forbidden_game_minutes_periods.forEach(function (times) {
                            data.identified_user_rules[index].login_rule.work_day_normal.rules.push(_this2.initLoginRules({
                                date_type: 2,
                                start_time: times[0],
                                end_time: times[1]
                            }).login_rule);
                        });
                    }
                    if (Array.isArray(item.login_rule.work_day_normal.allow_game_minutes_periods) && item.login_rule.work_day_normal.allow_game_minutes_periods.length) {
                        item.login_rule.work_day_normal.allow_game_minutes_periods.forEach(function (times) {
                            data.identified_user_rules[index].login_rule.work_day_normal.rules.push(_this2.initLoginRules({
                                date_type: 3,
                                start_time: times[0],
                                end_time: times[1]
                            }).login_rule);
                        });
                    }

                    //work_day_special......
                    data.identified_user_rules[index].login_rule.work_day_special.changeTimeOptions = _this2.initLoginRules({}).changeTimeOptions;
                    data.identified_user_rules[index].login_rule.work_day_special.rules = [];
                    console.log(data.identified_user_rules[index]);

                    var keys_special = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item.login_rule.work_day_special);
                    console.log(keys_special);

                    keys_special.forEach(function (key) {
                        if (key === 'daily_max_game_minutes') {
                            data.identified_user_rules[index].login_rule.work_day_special.rules.push(_this2.initLoginRules({
                                date_type: 1,
                                daily_max_game_time: item.login_rule.work_day_special[key]
                            }).login_rule);
                        }
                    });
                    console.log(data.identified_user_rules[index]);

                    _this2.changeTimeRange(false, data.identified_user_rules[index], 'work_day_special');
                    if (Array.isArray(item.login_rule.work_day_special.forbidden_game_minutes_periods) && item.login_rule.work_day_special.forbidden_game_minutes_periods.length) {
                        item.login_rule.work_day_special.forbidden_game_minutes_periods.forEach(function (times) {
                            data.identified_user_rules[index].login_rule.work_day_special.rules.push(_this2.initLoginRules({
                                date_type: 2,
                                start_time: times[0],
                                end_time: times[1]
                            }).login_rule);
                        });
                    }
                    if (Array.isArray(item.login_rule.work_day_special.allow_game_minutes_periods) && item.login_rule.work_day_special.allow_game_minutes_periods.length) {
                        item.login_rule.work_day_special.allow_game_minutes_periods.forEach(function (times) {
                            data.identified_user_rules[index].login_rule.work_day_special.rules.push(_this2.initLoginRules({
                                date_type: 3,
                                start_time: times[0],
                                end_time: times[1]
                            }).login_rule);
                        });
                    }
                });

                data.names = [];
                _this2.params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(data);
                data.identified_user_rules.forEach(function (_, i) {
                    _this2.params.names.push(i);
                });
                if (!res.id) {
                    _this2.is_edit = false;
                } else {
                    _this2.params.id = res.id;
                    _this2.is_edit = true;
                }
                console.log(isEdit);

                console.log("data");
                console.log(data);

                console.log("this.params");
                console.log(_this2.params);

                _this2.is_configured = isEdit;
            });
        }
    }),
    created: function created() {
        this.initAntiAddictionConfig();
    }
});

/***/ }),

/***/ "YQOc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "YVX7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"set-idfa-content"},[_c('el-form',{ref:"form",attrs:{"model":_vm.params,"label-width":_vm.labelWidth}},[_c('el-form-item',{attrs:{"label":"启用状态："}},[_c('el-radio-group',{model:{value:(_vm.params.idfa_allowed),callback:function ($$v) {_vm.$set(_vm.params, "idfa_allowed", $$v)},expression:"params.idfa_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("启用")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("禁用")])],1)],1),_vm._v(" "),(_vm.params.idfa_allowed)?_c('el-form-item',{attrs:{"label":"调用方式："}},[_c('el-radio-group',{model:{value:(_vm.params.idfa_call_mode),callback:function ($$v) {_vm.$set(_vm.params, "idfa_call_mode", $$v)},expression:"params.idfa_call_mode"}},[_c('el-radio',{attrs:{"label":"udp"}},[_vm._v("UDP")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"cp"}},[_vm._v("CP")])],1)],1):_vm._e(),_vm._v(" "),(_vm.params.idfa_allowed)?_c('el-form-item',{staticStyle:{"position":"relative"},attrs:{"label":"弹窗类型："}},[_c('el-radio-group',{model:{value:(_vm.params.idfa_popup_type),callback:function ($$v) {_vm.$set(_vm.params, "idfa_popup_type", $$v)},expression:"params.idfa_popup_type"}},[_c('el-radio',{attrs:{"label":"customize"}},[_vm._v("定制弹窗 ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"system"}},[_vm._v("苹果系统弹窗")])],1),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();_vm.reviewDialogVisible = true}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"}},[(_vm.isShowTime)?_c('el-form-item',{attrs:{"label":"弹窗时机："}},[_c('el-radio-group',{model:{value:(_vm.params.idfa_time_type),callback:function ($$v) {_vm.$set(_vm.params, "idfa_time_type", $$v)},expression:"params.idfa_time_type"}},[_c('el-radio',{attrs:{"label":"after_login"}},[_vm._v("\n                        登录后\n                        "),_c('el-input-number',{staticClass:"w70 hidden",attrs:{"size":"mini"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" 分钟")])],1),_vm._v(" "),(_vm.showSpecialTimeType)?_c('el-radio',{attrs:{"label":"after_start"}},[_vm._v("\n                        启动后\n                        "),_c('el-input-number',{staticClass:"w70 hidden",attrs:{"size":"mini"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" 分钟")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"color":"#e6a23c"}},[_vm._v("注：至多1440分钟")])],1):_vm._e(),_vm._v(" "),(_vm.isShowTime)?_c('el-form-item',{staticClass:"after-login",attrs:{"label-width":"0","prop":"after_login_time","rules":[
                    {
                        required: _vm.params.idfa_time_type === 'after_login',
                        message: ' '
                    }
                ]}},[_c('el-input-number',{staticClass:"w70",attrs:{"precision":1,"min":0,"max":1440,"controls":false,"size":"mini"},model:{value:(_vm.params.after_login_time),callback:function ($$v) {_vm.$set(_vm.params, "after_login_time", $$v)},expression:"params.after_login_time"}})],1):_vm._e(),_vm._v(" "),(_vm.isShowTime && _vm.showSpecialTimeType)?_c('el-form-item',{staticClass:"after-start",attrs:{"label-width":"0","prop":"after_start_time","rules":[
                    {
                        required: _vm.params.idfa_time_type === 'after_start',
                        message: ' '
                    }
                ]}},[_c('el-input-number',{staticClass:"w70",attrs:{"precision":1,"min":0,"max":1440,"controls":false,"size":"mini"},model:{value:(_vm.params.after_start_time),callback:function ($$v) {_vm.$set(_vm.params, "after_start_time", $$v)},expression:"params.after_start_time"}})],1):_vm._e()],1),_vm._v(" "),(_vm.params.idfa_allowed && _vm.params.idfa_popup_type === 'customize')?_c('div',{staticStyle:{"display":"flex"}},[_c('el-form-item',{attrs:{"label":"定制弹窗："}}),_vm._v(" "),_c('div',{staticClass:"dialog-upload-btn-box"},[_c('el-tabs',{model:{value:(_vm.dialogTemplateCustomName),callback:function ($$v) {_vm.dialogTemplateCustomName=$$v},expression:"dialogTemplateCustomName"}},_vm._l((_vm.params.idfa_customize_popup_image),function(item,key){return _c('el-tab-pane',{key:key,attrs:{"name":key}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                            "+_vm._s(key.toUpperCase())+"\n                            "),_c('em',{class:item.popup_background && item.allow_tracking_button && item.popup_close_button ? 'upload-success': 'upload-warning'})]),_vm._v(" "),_c('el-checkbox',{on:{"change":function($event){return _vm.handleIdfaCustomChecked(key)}},model:{value:(item.checked),callback:function ($$v) {_vm.$set(item, "checked", $$v)},expression:"item.checked"}},[_vm._v("将当前语言设置为默认语言")]),_vm._v(" "),_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[_c('div',[_vm._v("弹窗背景图")]),_vm._v(" "),_c('upload',{attrs:{"size":"840 * 628px","formatlimit":"all"},model:{value:(item.popup_background),callback:function ($$v) {_vm.$set(item, "popup_background", $$v)},expression:"item.popup_background"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label-width":"20px"}},[_c('div',[_vm._v("弹框允许追踪按钮")]),_vm._v(" "),_c('upload',{attrs:{"size":"320 * 80px","formatlimit":"all"},model:{value:(item.allow_tracking_button),callback:function ($$v) {_vm.$set(item, "allow_tracking_button", $$v)},expression:"item.allow_tracking_button"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label-width":"20px"}},[_c('div',[_vm._v("关闭弹框按钮")]),_vm._v(" "),_c('upload',{attrs:{"size":"48 * 40px","formatlimit":"all"},model:{value:(item.popup_close_button),callback:function ($$v) {_vm.$set(item, "popup_close_button", $$v)},expression:"item.popup_close_button"}})],1)],1)],1)}),1)],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("完成")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"el-dialog__body_self",attrs:{"title":"IDFA设置指南","visible":_vm.reviewDialogVisible,"width":"820px"},on:{"update:visible":function($event){_vm.reviewDialogVisible=$event}}},[_c('img',{staticStyle:{"margin-top":"-100px"},attrs:{"src":__webpack_require__("bSdx"),"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yaey":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/ios-portrait1.8005d3c.png";

/***/ }),

/***/ "Yxl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Zmtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-scheme-container"},[_c('span',{staticClass:"title-description"},[_vm._v("方案名称只在内部系统做方案表示，不对外显示")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.pushSchemeForm}},[_c('el-form-item',{attrs:{"prop":"push_plan_name","rules":[{
            required: true, message: ' ', trigger: ['blur', 'change']
        }]}},[_c('sub-inputtrim',{attrs:{"size":"small","disabled":_vm.isDetail},model:{value:(_vm.pushSchemeForm.push_plan_name),callback:function ($$v) {_vm.$set(_vm.pushSchemeForm, "push_plan_name", $$v)},expression:"pushSchemeForm.push_plan_name"}})],1),_vm._v(" "),(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a0N4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushScheme_vue__ = __webpack_require__("Kz2x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5ac112_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushScheme_vue__ = __webpack_require__("Zmtm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushScheme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5ac112_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushScheme_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a5BF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/pay_page_sample_and_size.fc0a492.png";

/***/ }),

/***/ "aAVc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        detailRowData: {
            type: Object,
            default: function _default() {}
        },
        dialogCategory: {
            type: Boolean,
            default: null
        }
    },
    data: function data() {
        return {
            dialogFormVisible: false,
            data: []
        };
    },

    watch: {
        dialogVisible: function dialogVisible(newVal) {
            this.dialogFormVisible = newVal;
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['$page']), {
        pageCategory: function pageCategory() {
            /**
             * 区分CP 导入 还是自生成码  (push = CP导入 & self-generated = 自生成)
             */
            var category = this.$page === 'recharge/pushRechargeCodeList' ? 'push' : 'self-generated';
            return category;
        },
        rander: function rander() {
            var _this = this;

            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.detailRowData).length) {
                return [];
            }
            var options = [{
                key: '兑换充值码的操作系统',
                value: this.detailRowData.exchange_type ? '我司提供' : 'cp提供'
            }, {
                key: '礼包ID',
                value: this.detailRowData.gift_id
            }, {
                key: '活动名称',
                value: this.detailRowData.activity_name
            }, {
                key: '礼包名称',
                value: this.detailRowData.gift_name
            }, {
                key: 'CD key',
                value: this.detailRowData.cdkey
            }, {
                key: '充值码类型',
                value: !this.detailRowData.type ? '通用码' : '单次码'
            }, {
                key: '通用码',
                value: this.detailRowData.code
            }, {
                key: '使用纬度',
                value: this.detailRowData.use_dimension ? 'Role ID' : 'Player ID'
            }, {
                key: '同一账号支持领取多码',
                value: this.detailRowData.use_times ? '是' : '否'
            }, {
                key: '充值码总数',
                value: this.detailRowData.total
            }, {
                key: '剩余数量',
                value: this.detailRowData.left_total
            }, {
                key: '开始时间',
                value: this.detailRowData.start_time ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.detailRowData.start_time, 'X').format('YYYY-MM-DD HH:mm:ss') : '永久'
            }, {
                key: '结束时间',
                value: this.detailRowData.end_time ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.detailRowData.end_time, 'X').format('YYYY-MM-DD HH:mm:ss') : '永久'
            }, {
                key: '启用状态',
                value: this.detailRowData.status ? '启用' : '关闭'
            }, {
                key: '服范围',
                value: this.detailRowData.allow_server ? this.detailRowData.allow_server : '--'
            }, {
                key: '角色vip等级',
                value: this.detailRowData.allow_viplevel ? this.detailRowData.allow_viplevel : '--'
            }, {
                key: '最近操作人',
                value: this.detailRowData.operator ? this.detailRowData.operator : '--'
            }, {
                key: '最近操作时间',
                value: this.detailRowData.updated_time ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.detailRowData.updated_time, 'X').format('YYYY-MM-DD HH:mm:ss') : '--'
            }];
            if (this.pageCategory === 'self-generated') {
                options.splice(0, 1);
            }
            if (this.detailRowData.type) {
                options = options.filter(function (item) {
                    if (_this.pageCategory === 'push') {
                        if (_this.detailRowData.exchange_type) {
                            return !(item.key === '通用码') && !(item.key === '充值码类型');
                        } else {
                            return !(item.key === '通用码') && !(item.key === '充值码类型') && !(item.key === 'CD key');
                        }
                    } else {
                        return !(item.key === '通用码');
                    }
                });
            } else {
                options = options.filter(function (item) {
                    return !(item.key === '同一账号支持领取多码');
                });
            }
            return options;
        }
    }),
    methods: {
        handleDialog: function handleDialog() {
            this.dialogFormVisible = false;
            this.$emit('changeDialogVisible', false);
        },
        doCopy: function doCopy(code) {
            this.$emit('doCopy', code);
        }
    }
});

/***/ }),

/***/ "aBAJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushContainer_vue__ = __webpack_require__("47f9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2167de6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushContainer_vue__ = __webpack_require__("9oi5");
function injectStyle (ssrContext) {
  __webpack_require__("61bN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2167de6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aCwl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/container-ios2.e6bcafb.png";

/***/ }),

/***/ "asZg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__("Q8VG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cookie__ = __webpack_require__("wwIW");






var Config = __webpack_require__("wFsZ");

var request = function () {
    function request() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, request);

        this.token = __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].getToken();
        var headers = {};
        if (this.token) {
            headers[Config.userLoginAccessTokenKey] = this.token;
        }
        this.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
            timeout: 1000 * 60,
            responseType: 'json',
            baseURL: Config.apiBaseUrl,
            headers: headers
        });

        this.cdcToken = __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].getUdcToken();
        var uheaders = {};
        if (this.cdcToken) {
            uheaders['oasis-core-token'] = this.cdcToken;
        }

        this.uaxios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
            timeout: 1000 * 60,
            responseType: 'json',
            baseURL: Config.udcApiBaseUrl,
            headers: uheaders
        });
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(request, [{
        key: "isNeedGameCode",
        value: function isNeedGameCode(data) {
            var isCode = data['isGameCode'] !== undefined ? data['isGameCode'] : true;
            if (isCode) {
                data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].getGameCode(), data);
            }
            return data;
        }

        /***
         *
         * @param ajaxOtions
         * @returns {[]}
         * @private
         */

    }, {
        key: "__getAjaxArrFn",
        value: function __getAjaxArrFn(ajaxOtions) {
            var _this = this;

            var temp = [];
            var len = ajaxOtions.length;

            var _loop = function _loop(i) {
                var fn = void 0;
                if (ajaxOtions[i]['method'] === 'get') {
                    fn = function fn() {
                        var url = _this.replaceGameCode(ajaxOtions[i]['url']);
                        return _this.get(url, ajaxOtions[i]['data'], ajaxOtions[i]['header']);
                    };
                }
                if (ajaxOtions[i]['method'] === 'post') {
                    var isFormData = ajaxOtions[i]['isFormData'] === undefined ? true : ajaxOtions[i]['isFormData'];
                    fn = function fn() {
                        var url = _this.replaceGameCode(ajaxOtions[i]['url']);
                        return _this.post(url, ajaxOtions[i]['data'], ajaxOtions[i]['header'], isFormData);
                    };
                }
                temp.push(fn());
            };

            for (var i = 0; i < len; i++) {
                _loop(i);
            }
            return temp;
        }

        /**
         * ajax get request
         * @param url
         * @param data
         * @param header
         * @returns {AxiosPromise}
         */

    }, {
        key: "get",
        value: function get(url) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            url = this.replaceGameCode(url);
            data = this.isNeedGameCode(data);
            return this.axios({
                url: url,
                method: 'get',
                params: data
            });
        }

        /**
         * 替换url中有{game_code}字符串
         * @param url
         * @returns {*}
         */

    }, {
        key: "replaceGameCode",
        value: function replaceGameCode(url) {
            // let code = Cookie.get('odp-selectedGameCode');
            var code = __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].getGameCode().game_code;
            if (!url && Config.isDebug) {
                alert('请检查你的配置（../website/config）中的API地址是否已配置');
                return;
            }

            if (url.indexOf('{game_code}') !== -1) {
                url = url.replace(/\{game_code\}/g, code);
            }
            return url;
        }

        /**
         * ajax put request
         * @param url
         * @param data
         * @param header
         * @returns {AxiosPromise}
         */

    }, {
        key: "put",
        value: function put(url) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            url = this.replaceGameCode(url);
            data = this.isNeedGameCode(data);
            return this.axios({
                url: url,
                method: 'put',
                data: data
            });
        }

        /**
         * ajax delete request
         * @param url
         * @param data
         * @param header
         * @returns {AxiosPromise}
         */

    }, {
        key: "delete",
        value: function _delete(url) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            url = this.replaceGameCode(url);
            data = this.isNeedGameCode(data);
            return this.axios({
                url: url,
                method: 'delete',
                data: data
            });
        }

        /**
         * ajax post request
         * @param url
         * @param data
         * @param header
         * @param isFormData
         * @returns {AxiosPromise}
         */

    }, {
        key: "post",
        value: function post(url) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var isFormData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            url = this.replaceGameCode(url);
            data = this.isNeedGameCode(data);

            /** 使用FormData格式**/
            if (isFormData) {
                header['Content-Type'] = 'application/x-www-form-urlencoded';
                data = __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].paramJSON(data);
            }

            return this.axios({
                url: url,
                method: 'post',
                headers: header,
                data: data
            });
        }
    }, {
        key: "filePost",
        value: function filePost(url) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            url = this.replaceGameCode(url);
            header['Content-Type'] = 'application/x-www-form-urlencoded';
            console.log(data);
            return this.axios({
                url: url,
                method: 'post',
                headers: header,
                data: data
            });
        }

        /**
         * 一次请求多个接口方法
         * @param ajaxOtions [
         *      {url: url, data: {},header:{},method:'get', key: 'key1'},
         *      {url: url, data: {},header:{},method:'post',isFormData: false, key: 'key1'}
         * ]
         * @param callback;
         * @param errorCallback
         */

    }, {
        key: "all",
        value: function all() {
            var ajaxOtions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var callback = arguments[1];
            var errorCallback = arguments[2];

            if (ajaxOtions.length === 0) {
                console.error('Param is not empty');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all(this.__getAjaxArrFn(ajaxOtions)).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function () {
                for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
                    values[_key] = arguments[_key];
                }

                var len = values.length;
                var data = {};
                for (var i = 0; i < len; i++) {
                    if (ajaxOtions[i]['key']) {
                        data[ajaxOtions[i]['key']] = values[i];
                    } else {
                        data[i] = values[i];
                    }
                }
                callback(data);
            })).catch(function (res) {
                errorCallback(res);
            });
        }

        /** udc项目请求**/

    }, {
        key: "upost",
        value: function upost(url) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var header = arguments[2];

            data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { gamecode: __WEBPACK_IMPORTED_MODULE_4__helper__["a" /* default */].getGameCode().game_code }, data);
            var params = new FormData();
            for (var key in data) {
                params.append(key, data[key]);
            }
            params = new URLSearchParams(params);
            return this.uaxios({
                url: url,
                method: 'post',
                data: params
            });
        }
    }]);

    return request;
}();

;

/* harmony default export */ __webpack_exports__["a"] = (new request());

/***/ }),

/***/ "bSdx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/idfa_notice.5d0cf36.png";

/***/ }),

/***/ "boqd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cpArgExportPrivacyPolicy = {
    special_data: [{
        lang: '英语',
        privacy_url: 'https://profile.mars.games/static-page/privacy-policy-en.html',
        service_url: 'https://profile.mars.games/static-page/terms-of-service-en.html'
    }],
    not_special_data: [{
        lang: '阿语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(AR).html',
        service_url: 'http://www.oasgames.com/TermsofService(AR).html'
    }, {
        lang: '德语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(DE).html',
        service_url: 'http://www.oasgames.com/TermsofService(DE).html'
    }, {
        lang: '希腊语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(EL).html',
        service_url: 'http://www.oasgames.com/TermsofService(EL).html'
    }, {
        lang: '英语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(EN).html',
        service_url: 'http://www.oasgames.com/TermsofService(EN).html'
    }, {
        lang: '西班牙语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(ES).html',
        service_url: 'http://www.oasgames.com/TermsofService(ES).html'
    }, {
        lang: '法语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(FR).html',
        service_url: 'http://www.oasgames.com/TermsofService(FR).html'
    }, {
        lang: '意大利语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(IT).html',
        service_url: 'http://www.oasgames.com/TermsofService(IT).html'
    }, {
        lang: '波兰语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(PL).html',
        service_url: 'http://www.oasgames.com/TermsofService(PL).html'
    }, {
        lang: '俄语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(RU).html',
        service_url: 'http://www.oasgames.com/TermsofService(RU).html'
    }, {
        lang: '荷兰语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(NL).html',
        service_url: 'http://www.oasgames.com/TermsofService(NL).html'
    }, {
        lang: '葡萄牙语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(PT).html',
        service_url: 'http://www.oasgames.com/TermsofService(PT).html'
    }, {
        lang: '瑞典语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(SV).html',
        service_url: 'http://www.oasgames.com/TermsofService(SV).html'
    }, {
        lang: '土耳其语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(TR).html',
        service_url: 'http://www.oasgames.com/TermsofService(TR).html'
    }, {
        lang: '繁体中文',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(TW).html',
        service_url: 'http://www.oasgames.com/TermsofService(TW).html'
    }, {
        lang: '韩语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(KO).html',
        service_url: 'http://www.oasgames.com/TermsofService(KO).html'
    }, {
        lang: '泰语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(TH).html',
        service_url: 'http://www.oasgames.com/TermsofService(TH).html'
    }, {
        lang: '越南语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(VI).html',
        service_url: 'http://www.oasgames.com/TermsofService(VI).html'
    }, {
        lang: '日语',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(JA).html',
        service_url: 'http://www.oasgames.com/TermsofService(JA).html'
    }, {
        lang: '简体中文',
        privacy_url: 'http://www.oasgames.com/PrivacyPolicy(ZH).html',
        service_url: 'http://www.oasgames.com/TermsofService(ZH).html'
    }]
};

/* harmony default export */ __webpack_exports__["a"] = (cpArgExportPrivacyPolicy);

/***/ }),

/***/ "dpKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        params: {
            type: Object,
            default: function _default() {}
        }
    },
    data: function data() {
        return {
            tags: [],
            labels: {
                order_ids: '订单号：',
                codes: '充值码：',
                gift_ids: '礼包ID：',
                player_ids: '领码PID：',
                date: '兑换时间：',
                order_type: '订单类型：',
                exchange_status: '兑换状态：'
            }
        };
    },

    watch: {
        params: {
            handler: function handler() {
                var _this = this;

                this.tags = [];
                var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.params);
                if (Array.isArray(keys) && keys.length) {
                    keys.forEach(function (item) {
                        var vals = '';
                        if (_this.params[item] && item !== 'player_type' && item !== 'date_type') {
                            var str = '';
                            if (typeof _this.params[item] === 'string') {
                                str = _this.params[item].replace(/\s+|[\r\n]/g, ',').replace(/，/g, ',');
                            }

                            vals = str.split(',').map(function (item) {
                                if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(item)) {
                                    return item;
                                }
                            }).filter(function (item) {
                                return item;
                            });
                        }
                        if (item !== 'player_type') {
                            if (item === 'player_ids') {
                                var player_type = _this.params.player_type === 1 ? '领码PID：' : '兑换PID：';
                                _this.labels[item] = player_type;
                            }
                            if (item === 'date') {
                                var date = _this.params.date_type === 1 ? '兑换时间：' : '领码时间：';
                                _this.labels[item] = date;
                                vals = [_this.params.date.join(' - ')];
                            }
                            _this.tags.push({
                                label: _this.labels[item],
                                value: vals,
                                key: item
                            });
                        }
                    });
                }
            },

            deep: true,
            immediate: true
        }
    }
});

/***/ }),

/***/ "dqQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sub-system-list"},[_c('div',{staticClass:"sub-system-list-warpper"},_vm._l((_vm.datalist),function(item){return _c('div',{staticClass:"sub-system-item-box"},[_c('div',{staticClass:"sub-system-item-btn"},[_c('div',[_c('el-button',{attrs:{"size":"mini","type":"warning","icon":"el-icon-edit"},on:{"click":function($event){return _vm.edit(item)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('div',[_c('el-button',{attrs:{"size":"mini","icon":"el-icon-delete","type":"danger"},on:{"click":function($event){return _vm.remove(item)}}},[_vm._v("删除")])],1)]),_vm._v(" "),_c('div',{staticClass:"sub-system-item-cont"},[_c('div',{staticClass:"sub-system-item-version"},[_c('strong',[_vm._v("SDK版本：")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.version)}})]),_vm._v(" "),_c('div',{staticClass:"sub-system-item-desc"},[_c('strong',[_vm._v("SDK描述：")]),_vm._v(" "),_c('span',{attrs:{"title":item.detail},domProps:{"innerHTML":_vm._s(item.detail)}})])]),_vm._v(" "),_c('div',{staticClass:"clear"})])}),0)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"编辑版本信息","visible":_vm.dialogVisible,"width":"600px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"form",staticClass:"sub-system-search-from",attrs:{"model":_vm.form,"label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"SDK版本"}},[_c('el-input',{staticStyle:{"width":"85%"},attrs:{"size":"small","placeholder":"SDK版本"},model:{value:(_vm.form.version),callback:function ($$v) {_vm.$set(_vm.form, "version", $$v)},expression:"form.version"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"描述"}},[_c('el-input',{staticStyle:{"width":"85%"},attrs:{"type":"textarea","size":"small","placeholder":"描述"},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eE6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);




/**
 * Created by shiyonggao on 2019/12/13.
 */



var loginHandle = function () {
    function loginHandle(store, res, callback) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, loginHandle);

        this.res = res;
        this.store = store;
        this.callback = callback;

        /**测试数据**/
        // this.res['gamelist']['data']['games'] = [];
        // this.res['gamelist']['data']['user'] = {};
        // this.res['gamelist']['data']['user']['email'] = 'gaoshiyong@oasgames.com';

        /**初始化**/
        this.init();
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(loginHandle, [{
        key: "init",
        value: function init() {
            var _this = this;

            /**设置权限**/
            this.store.commit("updateUserRoles", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ res: this.res }, this.store));

            /**初始化Menu**/
            //this.initMenu();

            /** 用户无游戏列表 **/
            if (this.res["gamelist"] && this.res["gamelist"]["data"] && this.res["gamelist"]["data"]["games"] && this.res["gamelist"]["data"]["games"].length === 0) {
                /**用户无权限页面跳转无权限提示页面**/
                if (this.store.rootState.$page !== "noAccess") {
                    this.store.rootState.$route("noAccess");
                    return;
                }

                /**设置用户信息和游戏信息**/
                this.store.commit("updateAppInfo", this.res);

                /**设置用户无权限对象**/
                this.store.commit("NO_ACCESS_PAGE", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    args: this.res,
                    status: false
                }, this.store));

                /**设置完成回调方法**/
                this.callback(this.res);
                return;
            }
            /*
            let pageKeys = this.store.rootState.$page.split('/'),
                pageInfo = this.store.rootState.$routerMaps;
             pageInfo = pageInfo[pageKeys[0]];
            if (pageInfo && pageInfo.projectType) {
                this.store.state.$helper.cookie.set(
                    'odp-projectType',
                    pageInfo.projectType
                );
            }
            */
            /**设置游戏信息**/
            this.store.commit("updateAppInfo", this.res);
            this.store.commit("updateAppGameCode");
            // this.store.commit('updateProjectType');

            /**初始化Menu**/
            this.initMenu();
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["isEmpty"])(this.menu)) {
                if (this.store.rootState.$page !== "noAccess") {
                    this.store.rootState.$route("noAccess");
                    return;
                }
                /**设置用户无权限对象**/
                this.store.commit("NO_ACCESS_PAGE", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                    args: this.res,
                    status: false
                }, this.store));
                /**设置完成回调方法**/
                this.callback(this.res);
                return;
            }

            this.checkRedirect();

            /**用户有权限访问页面，但是访问在noAccess页面跳转到首页进行路由选择**/
            if (this.store.rootState.$page === "noAccess") {
                this.store.rootState.$route("index");
                return;
            }

            /**用户直接页面检查是否有权限**/
            if (this.checkRole()) {
                /**初始化数据完成回调方法**/
                this.store.dispatch("GET_ACTIVE_GAME_INFO", function (res) {
                    /**首页检查自动路由到业务管理和发行配置**/
                    if (_this.store.rootState.$page === "index") {
                        _this.checkFirst();
                        return;
                    }
                    _this.setProjectType();
                    _this.callback(_this.res);
                });
            } else {
                this.store.rootState.$route("index");
            }
        }
    }, {
        key: "setProjectType",
        value: function setProjectType() {
            var page = this.store.rootState.$page.toLocaleLowerCase(),
                type = this.menuObj[page] && this.menuObj[page].projectType;

            this.store.commit("updateProjectType", type);
        }
    }, {
        key: "checkRedirect",
        value: function checkRedirect() {
            var urlParams = this.store.rootState.$helper.helper.getUrlParams(),
                page = urlParams.page;

            page = decodeURIComponent(page);
            if (page && this.menuObj[page]) {
                this.store.rootState.$helper.helper.route(page);
                return false;
            }
            if (page !== undefined) {
                delete urlParams.page;
                window.history.pushState(null, null, "?" + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(urlParams));
            }
        }
        /**
         * 首页访问路由处理
         */

    }, {
        key: "checkFirst",
        value: function checkFirst() {
            /**非首次访问带cookie**/
            // if (this.store.state.$helper.cookie.get("odp-projectType")) {
            //     console.log(
            //         "！首次",
            //         this.store.state.$helper.cookie.get("odp-projectType")
            //     );
            //     let projectType = parseInt(
            //         this.store.state.$helper.cookie.get("odp-projectType")
            //     );
            //     if (projectType === 1) {
            //         this.checkDefinedAccessEntry(1);
            //     } else {
            //         this.checkDefinedAccessEntry(2);
            //     }
            //     return;
            // }

            /**公测、封测 ---> 业务管理**/
            var status = this.store.state.$activeGameInfo["game_status"];
            console.log("首次", status);
            if (status === 2 || status === 3) {
                // this.store.state.$helper.cookie.set("odp-projectType", 2);
                this.checkDefinedAccessEntry(2);

                /**除非公测、封测的状态 ---> 发行配置**/
            } else {
                // this.store.state.$helper.cookie.set("odp-projectType", 1);
                this.checkDefinedAccessEntry(1);
            }
        }
    }, {
        key: "inArrayRole",
        value: function inArrayRole(key) {
            var role = this.store.rootState.$roles;
            var len = role.length;
            var status = false;
            if (key === "") {
                return true;
            }
            for (var i = 0; i < len; i++) {
                if (role[i] === key) {
                    if (key === "ROLE_APP_ODP5_CUSTOM_IPBLOCK") {
                        if (this.store.rootState.$isGameAdmin === 1) {
                            status = true;
                        } else {
                            status = false;
                        }
                    } else {
                        status = true;
                    }
                }
            }

            return status;
        }

        /***
         * 初始化右侧导航
         */

    }, {
        key: "initMenu",
        value: function initMenu() {
            var map = this.store.rootState.$routerMapsDefined;
            var menu = {};
            var pathCount = 0;
            var projectTypeRoute1 = "";
            var projectTypeRoute2 = "";
            var projectTypeRoute1Status = false;
            var projectTypeRoute2Status = false;
            // /**管理员权限设置**/
            if (this.store.rootState.$isAdmin === 1) {
                menu = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, map);
                this.updateMenu(menu);
                return;
            }
            /**非管理员权限设置**/
            for (var key in map) {
                /**有子页面权限设置**/
                if (map[key]["children"]) {
                    /**有功能目录权限**/
                    if (this.inArrayRole(map[key]["role"])) {
                        if (this.store.rootState.$isGameAdmin === 0) {
                            for (var _key in map) {
                                if (_key === "riskManagement") {
                                    delete map[_key].children.ipBlockView;
                                }
                            }
                        }
                        menu[key] = map[key];
                        var temp = "";
                        for (var k in map[key]["children"]) {
                            if (temp) {
                                break;
                            } else {
                                temp = key + "/" + k;
                            }
                        }

                        /**设定拥有业务管理权限**/
                        if (key === "watch") {
                            projectTypeRoute2Status = true;
                        }
                        /**设定拥有发行配置权限**/
                        if (key === "gameConfig") {
                            projectTypeRoute1Status = true;
                        }

                        if (!projectTypeRoute1 && map[key]["projectType"] === 1) projectTypeRoute1 = temp;
                        if (!projectTypeRoute2 && map[key]["projectType"] === 2) projectTypeRoute2 = temp;
                        pathCount++;
                    } else {
                        var count = 0;
                        var children = map[key]["children"];
                        var _temp = {};
                        for (var _k in children) {
                            if (this.inArrayRole(children[_k]["role"])) {
                                _temp[_k] = children[_k];
                                if (!projectTypeRoute1 && map[key]["projectType"] === 1) projectTypeRoute1 = key + "/" + _k;
                                if (!projectTypeRoute2 && map[key]["projectType"] === 2) projectTypeRoute2 = key + "/" + _k;
                                /**设定拥有业务管理权限**/
                                if (_k === "line") {
                                    projectTypeRoute2Status = true;
                                }
                                /**设定拥有发行配置权限**/
                                if (key === "gameConfig") {
                                    projectTypeRoute1Status = true;
                                }
                                count++;
                                pathCount++;
                            }
                        }

                        if (count > 0) {
                            menu[key] = {};
                            menu[key]["title"] = map[key]["title"];
                            menu[key]["icon"] = map[key]["icon"];
                            menu[key]["projectType"] = map[key]["projectType"];
                            menu[key]["role"] = map[key]["role"];
                            menu[key]["children"] = _temp;
                        }
                    }
                } else {
                    /**无子页面权限设置**/
                    /**无需访问权限页面设置**/
                    if (!map[key]["role"]) {
                        menu[key] = map[key];
                    } else {
                        /**需访问权限页面设置**/
                        if (this.inArrayRole(map[key]["role"])) {
                            menu[key] = map[key];
                            if (!projectTypeRoute1 && map[key]["projectType"] === 1) projectTypeRoute1 = key;
                            if (!projectTypeRoute2 && map[key]["projectType"] === 2) projectTypeRoute2 = key;
                            pathCount++;
                        }
                    }
                }
            }

            /**无访问页面权限**/
            if (pathCount === 0) {
                // this.res["gamelist"]["data"]["games"] = [];
                // this.store.rootState.$helper.localStorage.set(
                //     "odp_gameList",
                //     this.res,
                //     0.5
                // );
                if (this.store.rootState.$page !== "noAccess") {
                    this.store.rootState.$route("noAccess");
                }
                this.updateMenu({});
                return;
            }

            /**有访问页面权限**/
            this.store.commit("_updateJumpProjectType", {
                projectTypeRoute1: projectTypeRoute1,
                projectTypeRoute2: projectTypeRoute2
            });
            this.updateMenu(menu);

            //console.log(map, menu, projectTypeRoute1, projectTypeRoute2);
        }
    }, {
        key: "getMenuObject",
        value: function getMenuObject() {
            var tmp = {},
                item = void 0,
                child = void 0;
            for (var key in this.menu) {
                item = this.menu[key];
                if (item.children) {
                    for (var k in item.children) {
                        child = item.children[k];
                        tmp[key.toLocaleLowerCase() + "/" + k.toLocaleLowerCase()] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, child, {
                            projectType: item.projectType || item._projectType
                        });
                    }
                } else {
                    tmp[key.toLocaleLowerCase()] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
                        projectType: item.projectType || item._projectType
                    });
                }
            }

            return tmp;
        }
    }, {
        key: "updateMenu",
        value: function updateMenu(menu) {
            this.store.commit("_updateMune", menu);
            this.menu = menu;
            this.menuObj = this.getMenuObject();
        }
    }, {
        key: "checkDefinedAccessEntry",
        value: function checkDefinedAccessEntry(status) {
            /**管理员权限不检查**/
            if (this.store.rootState.$isAdmin === 1) {
                if (status === 1) {
                    this.store.rootState.$route(this.store.rootState.$config.projectTypeRoute1);
                }
                if (status === 2) {
                    this.store.rootState.$route(this.store.rootState.$config.projectTypeRoute2);
                }
                return;
            }

            var defR1 = this.store.rootState.$config.projectTypeRoute1,
                defR2 = this.store.rootState.$config.projectTypeRoute2;

            if (status === 1) {
                if (this.menuObj[defR1.toLocaleLowerCase()]) {
                    this.store.rootState.$route(defR1);
                } else if (this.store.rootState.$jumpProjectTypeRoute1) {
                    this.store.rootState.$route(this.store.rootState.$jumpProjectTypeRoute1);
                } else if (this.store.rootState.$jumpProjectTypeRoute2) {
                    this.store.rootState.$route(this.store.rootState.$jumpProjectTypeRoute2);
                } else {
                    this.checkSystem();
                }
            } else if (status === 2) {
                if (this.menuObj[defR2.toLocaleLowerCase()]) {
                    this.store.rootState.$route(defR2);
                } else if (this.store.rootState.$jumpProjectTypeRoute2) {
                    this.store.rootState.$route(this.store.rootState.$jumpProjectTypeRoute2);
                } else if (this.store.rootState.$jumpProjectTypeRoute1) {
                    this.store.rootState.$route(this.store.rootState.$jumpProjectTypeRoute1);
                } else {
                    this.checkSystem();
                }
            }

            return;
            /**非管理员**/
            // let map = this.store.rootState.$routerMapsDefined;
            // if (
            //     status === 1 &&
            //     !this.inArrayRole(map["gameConfig"]["children"]["baseInfo"]["role"])
            // ) {
            //     console.log(
            //         "baseInfo no role",
            //         this.store.rootState.$jumpProjectTypeRoute1
            //     );
            //     // this.store.rootState.$helper.cookie.set("odp-projectType", status);
            //     if (this.store.rootState.$jumpProjectTypeRoute1) {
            //         this.store.rootState.$route(
            //             this.store.rootState.$jumpProjectTypeRoute1
            //         );
            //     } else {
            //         if (this.store.rootState.$jumpProjectTypeRoute2) {
            //             this.store.rootState.$route(
            //                 this.store.rootState.$jumpProjectTypeRoute2
            //             );
            //             // this.store.commit("_updateShowProjectType", 1);
            //             // this.store.rootState.$helper.cookie.set(
            //             //     "odp-projectType",
            //             //     2
            //             // );
            //         } else {
            //             this.checkSystem();
            //         }
            //     }
            // }

            // /**用户无业务管理默认入口权限**/
            // if (
            //     status === 2 &&
            //     !this.inArrayRole(map["watch"]["children"]["line"]["role"])
            // ) {
            //     // this.store.rootState.$helper.cookie.set("odp-projectType", status);
            //     console.log(
            //         "watch no role",
            //         this.store.rootState.$jumpProjectTypeRoute2
            //     );

            //     /**用户无无业务管理权限默认入口权限，跳转到用户拥有业务管理权限的第一页面入口**/
            //     if (this.store.rootState.$jumpProjectTypeRoute2) {
            //         this.store.rootState.$route(
            //             this.store.rootState.$jumpProjectTypeRoute2
            //         );

            //         /**用户无无业务管理权限任何权限，尝试跳转到发行配置权限**/
            //     } else {
            //         if (this.store.rootState.$jumpProjectTypeRoute1) {
            //             // this.store.commit("_updateShowProjectType", 2);
            //             // this.store.rootState.$helper.cookie.set(
            //             //     "odp-projectType",
            //             //     1
            //             // );
            //             this.store.rootState.$route(
            //                 this.store.rootState.$jumpProjectTypeRoute1
            //             );
            //         } else {
            //             this.checkSystem();
            //         }
            //     }
            // }
        }
    }, {
        key: "checkSystem",
        value: function checkSystem() {
            var systemMenu = this.store.rootState.$routerMaps.system.children;
            var firstMenu = "system/";
            for (var key in systemMenu) {
                if (firstMenu === "system/") {
                    firstMenu += systemMenu[key]["active"];
                    break;
                }
            }
            this.store.rootState.$route(firstMenu);
        }

        /**
         * 用户权限处理
         */

    }, {
        key: "checkRole",
        value: function checkRole() {
            var page = this.store.rootState.$page.toLocaleLowerCase();
            return !!this.menuObj[page];

            // let path = this.store.rootState.$page.split("/");
            // let map = this.store.rootState.$routerMapsDefined;
            // /**管理员权限不判断无权限**/
            // if (this.store.rootState.$isAdmin === 1) {
            //     return true;
            // }

            // if (path.length > 1) {
            //     /**有功能权限不判断无权限**/
            //     if (this.inArrayRole(map[path[0]]["role"])) {
            //         return true;
            //     }

            //     /**访问的页面无权限**/
            //     if (!this.inArrayRole(map[path[0]]["children"][path[1]]["role"])) {
            //         console.error("访问的页面无权限");
            //         this.store.rootState.$route("index");
            //         return false;
            //     }
            // } else {
            //     /**访问的页面无权限**/
            //     if (!this.inArrayRole(map[path[0]]["role"])) {
            //         console.error("访问的页面无权限");
            //         this.store.rootState.$route("index");
            //         return false;
            //     }
            // }

            // console.log(this.store.rootState.$page, this.store.rootState.$roles);
            // return true;
        }
    }]);

    return loginHandle;
}();

/* harmony default export */ __webpack_exports__["a"] = (loginHandle);

/***/ }),

/***/ "edJP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/changepassword.6f226b8.png";

/***/ }),

/***/ "fEwg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdk-dimension-container"},[_c('el-form',{ref:"form",attrs:{"model":_vm.params,"label-width":_vm.labelWidth}},[_c('el-form-item',{attrs:{"label":"登录方式："}},[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminate},on:{"change":_vm.handleCheckAllChange},model:{value:(_vm.login_buttons_check_all),callback:function ($$v) {_vm.login_buttons_check_all=$$v},expression:"login_buttons_check_all"}},[_vm._v("全选")]),_vm._v(" "),_c('el-checkbox-group',{on:{"change":_vm.handleCheckedCitiesChange},model:{value:(_vm.params.logins),callback:function ($$v) {_vm.$set(_vm.params, "logins", $$v)},expression:"params.logins"}},_vm._l((_vm.loginOptions),function(item){return _c('span',{key:item.key},[_c('el-checkbox',{class:{'margin_left0': true},attrs:{"label":item.key,"disabled":item.disabled}},[_c('el-tooltip',{attrs:{"content":item.label+'登录',"placement":"top"}},[_c('span',[_vm._v(_vm._s(item.label))])])],1)],1)}),0)],1),_vm._v(" "),(_vm.platform !=='H5')?_c('el-form-item',{attrs:{"label":"登录相关功能："}},[_c('el-checkbox-group',{model:{value:(_vm.params.login_featured),callback:function ($$v) {_vm.$set(_vm.params, "login_featured", $$v)},expression:"params.login_featured"}},[_c('el-checkbox',{attrs:{"label":"silence_login_allowed","disabled":_vm.is_anti_addiction_turn_on || _vm.storeCode=='qooapp' || _vm.platform=='WINDOWS'}},[_vm._v("自动登录")]),_vm._v(" "),(_vm.platform === 'IOS')?_c('el-checkbox',{attrs:{"label":"silent_game_center_login_allowed","disabled":_vm.params.logins.indexOf('gamecenter_allowed') < 0}},[_vm._v("GC静默关联")]):_vm._e(),_vm._v(" "),(_vm.platform !=='WINDOWS')?_c('el-checkbox',{attrs:{"label":"prompt_to_bind_anonymous_account"}},[_vm._v("关联提示")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.14 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"邮箱注册验证："}},[_c('el-radio-group',{on:{"change":function($event){_vm.params.recaptcha_allowed = false;}},model:{value:(_vm.params.email_registration_verify_allowed),callback:function ($$v) {_vm.$set(_vm.params, "email_registration_verify_allowed", $$v)},expression:"params.email_registration_verify_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.14 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"reCAPTCHA开关："}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","placement":"top-start"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("开启时，请确认reCAPTCHA Sign-Up Key是否配置。生成reCAPTCHA Sign-Up Key请联系平台产品组；"),_c('br'),_vm._v("开启后，针对玩家的注册行为将启用Google的机器人验证功能，可一定程度防止刷号。")]),_vm._v(" "),_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"-17px"}})]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.params.recaptcha_allowed),callback:function ($$v) {_vm.$set(_vm.params, "recaptcha_allowed", $$v)},expression:"params.recaptcha_allowed"}},[_c('el-radio',{attrs:{"label":true,"disabled":_vm.params.email_registration_verify_allowed}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false,"disabled":_vm.params.email_registration_verify_allowed}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.14 && _vm.platform!=='H5' && _vm.platform !='WINDOWS' && _vm.params.recaptcha_allowed && !_vm.params.email_registration_verify_allowed)?_c('el-form-item',{attrs:{"label":"reCAPTCHA分值："}},[_c('div',[_vm._v("\n                低风险\n                "),_c('el-input-number',{staticClass:"w70 hidden",attrs:{"size":"mini","precision":2,"max":1,"step":0.01,"min":0},model:{value:(_vm.params.recaptcha_low_risk_score),callback:function ($$v) {_vm.$set(_vm.params, "recaptcha_low_risk_score", $$v)},expression:"params.recaptcha_low_risk_score"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("  请输入0-1区间的小数，精确到小数点后两位，如0.85")])],1),_vm._v(" "),_c('div',[_vm._v("\n                高风险\n                "),_c('el-input-number',{staticClass:"w70 hidden",attrs:{"size":"mini","precision":2,"step":0.01,"max":1,"min":0},model:{value:(_vm.params.recaptcha_high_risk_score),callback:function ($$v) {_vm.$set(_vm.params, "recaptcha_high_risk_score", $$v)},expression:"params.recaptcha_high_risk_score"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("  请输入0-1区间的小数，精确到小数点后两位，如0.35")])],1),_vm._v(" "),_c('div',{staticStyle:{"color":"#e6a23c","line-height":"28px"}},[_vm._v("\n                说明：reCAPTCHA会根据访问者与您网站的互动情况提供一个分数，1.0 表示很可能完全正常的互动，0.0 表明很可能具有滥用性质的操作。\n                "),_c('br'),_vm._v("SDK会根据reCAPTCHA互动情况把0.8-1的玩家定义为安全玩家，0.3-0.8为需要二次验证的玩家，0-0.3的玩家为危险玩家系统将拒绝玩家继续操作。\n              ")])]):_vm._e(),_vm._v(" "),(_vm.version >= 7.15 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"密码复杂程度要求"}},[_c('el-radio-group',{model:{value:(_vm.params.password_level),callback:function ($$v) {_vm.$set(_vm.params, "password_level", $$v)},expression:"params.password_level"}},[_c('el-radio',{attrs:{"label":"low"}},[_vm._v("\n                  简单\n                    "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"6-20位字符，可输入大写字母、小写字母、数字和常见特殊字符。","placement":"top-start"}},[_c('i',{staticClass:"el-icon-question"})])],1),_vm._v(" "),_c('el-radio',{attrs:{"label":"high"}},[_vm._v("\n                  复杂\n                  "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"8-20位字符，可输入大写字母、小写字母、数字和常见特殊字符，至少两种组合。","placement":"top-start"}},[_c('i',{staticClass:"el-icon-question"})])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.07 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"是否优先确认协议："}},[_c('el-radio-group',{model:{value:(_vm.params.priority_to_confirm_allowed),callback:function ($$v) {_vm.$set(_vm.params, "priority_to_confirm_allowed", $$v)},expression:"params.priority_to_confirm_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.15 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"用户注册协议展示方式"}},[_c('el-radio-group',{model:{value:(_vm.params.licence_show_type),callback:function ($$v) {_vm.$set(_vm.params, "licence_show_type", $$v)},expression:"params.licence_show_type"}},[_c('el-radio',{attrs:{"label":"merge"},on:{"change":_vm.selectMerageShowType}},[_vm._v("\n                  与注册页面合并展示"),_c('em',{staticClass:"el-icon-view icon-view1",on:{"click":function($event){$event.stopPropagation();_vm.licenceShowTypeMerge = true}}})]),_vm._v(" "),_c('el-radio',{attrs:{"label":"single"}},[_vm._v("\n                  协议单独弹框展示"),_c('em',{staticClass:"el-icon-view icon-view1",on:{"click":function($event){$event.stopPropagation();_vm.licenceShowTypeSingle = true}}})])],1)],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.15 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"用户须确认协议"}},[_c('el-checkbox',{attrs:{"disabled":true},model:{value:(_vm.params.must_confirm_licence.user_licence),callback:function ($$v) {_vm.$set(_vm.params.must_confirm_licence, "user_licence", $$v)},expression:"params.must_confirm_licence.user_licence"}},[_vm._v("用户协议")]),_vm._v(" "),_c('el-checkbox',{attrs:{"disabled":true},model:{value:(_vm.params.must_confirm_licence.secure_licence),callback:function ($$v) {_vm.$set(_vm.params.must_confirm_licence, "secure_licence", $$v)},expression:"params.must_confirm_licence.secure_licence"}},[_vm._v("隐私政策")]),_vm._v(" "),(_vm.params.licence_show_type == 'single')?_c('el-checkbox',{on:{"change":_vm.checkYearsOld},model:{value:(_vm.params.must_confirm_licence.years_old),callback:function ($$v) {_vm.$set(_vm.params.must_confirm_licence, "years_old", $$v)},expression:"params.must_confirm_licence.years_old"}},[_vm._v("\n                确认已满"),_c('el-input-number',{staticClass:"w45 hidden",attrs:{"size":"mini","max":100,"step":1,"precision":"0","min":0,"controls":false,"disabled":!_vm.params.must_confirm_licence.years_old},model:{value:(_vm.params.confirm_licence_years_old),callback:function ($$v) {_vm.$set(_vm.params, "confirm_licence_years_old", $$v)},expression:"params.confirm_licence_years_old"}}),_vm._v("岁\n              ")],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.version >= 7.07 && _vm.platform!=='H5' && _vm.platform !='WINDOWS')?_c('el-form-item',{attrs:{"label":"主推登录方式："}},[_c('el-radio-group',{on:{"change":_vm.handleFeaturedLogins},model:{value:(_vm.params.recommend_login_mode),callback:function ($$v) {_vm.$set(_vm.params, "recommend_login_mode", $$v)},expression:"params.recommend_login_mode"}},[_c('el-radio',{attrs:{"label":"mobile_and_email","disabled":_vm.params.logins.indexOf('mobile_allowed') === -1}},[_vm._v("邮箱和手机")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"email"}},[_vm._v("邮箱")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"mobile","disabled":_vm.params.logins.indexOf('mobile_allowed') === -1}},[_vm._v("手机号")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.params.recommend_login_mode),expression:"params.recommend_login_mode"},{name:"loading",rawName:"v-loading",value:(_vm.urlLoding),expression:"urlLoding"}],staticClass:"img-border"},[_c('h3',[_vm._v(" 效果预览")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.activeUrl,"alt":""}})])],1):_vm._e(),_vm._v(" "),((_vm.version >= 7.08) || _vm.platform==='H5' || _vm.platform==='WINDOWS' )?_c('el-form-item',{attrs:{"label":"登录页面logo："}},[_c('div',{staticClass:"dialog-upload-btn-box"},[_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[(_vm.platform!=='WINDOWS')?_c('div',[_vm._v("尺寸要求： 高144px，宽480-880px "),_c('font',{attrs:{"color":"red"}},[_vm._v("(请上传png格式)")])],1):_vm._e(),_vm._v(" "),(_vm.platform==='WINDOWS')?_c('div',[_vm._v("尺寸要求： 高56px，宽56-366px "),_c('font',{attrs:{"color":"red"}},[_vm._v("(请上传png格式)")])],1):_vm._e(),_vm._v(" "),_c('upload',{attrs:{"size":_vm.platform==='WINDOWS'? '366*56px': '880*144px',"formatlimit":"png"},model:{value:(_vm.params.login_page_logo),callback:function ($$v) {_vm.$set(_vm.params, "login_page_logo", $$v)},expression:"params.login_page_logo"}})],1)],1)])]):_vm._e(),_vm._v(" "),_c('el-form-item',[(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"el-dialog__body_self",attrs:{"title":"","visible":_vm.licenceShowTypeMerge,"width":"1220px"},on:{"update:visible":function($event){_vm.licenceShowTypeMerge=$event}}},[_c('div',{staticClass:"flex dialog-img-box"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("pHxA"),"width":"1180","alt":""}})])])]),_vm._v(" "),_c('el-dialog',{staticClass:"el-dialog__body_self",attrs:{"title":"","visible":_vm.licenceShowTypeSingle,"width":"1220px"},on:{"update:visible":function($event){_vm.licenceShowTypeSingle=$event}}},[_c('div',{staticClass:"flex dialog-img-box"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__("+dzg"),"width":"1180","alt":""}})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fb+S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/android-portrait1.14f9a66.png";

/***/ }),

/***/ "fdrO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "g6N2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "ServerQuery",
    data: function data() {
        return {
            params: {
                begin: "",
                end: "",
                name: "",
                status: "",
                type: ""
            }
        };
    },

    props: {
        servers: {
            type: Array,
            required: true
        },
        srcServers: {
            type: Array,
            required: true
        }
    },
    computed: {
        id2childrenIds: function id2childrenIds() {
            var tmp = {},
                setVal = function setVal() {
                var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                data.forEach(function (item) {
                    tmp[item.server_info.server_auto_id] = item.children_auto_ids || [];
                    if (item.children && item.children.length) {
                        setVal(item.children);
                    }
                });
            };
            setVal(this.servers);
            return tmp;
        },
        serverIds: function serverIds() {
            return this.srcServers.map(function (v) {
                return v.server_auto_id;
            });
        },
        beginServers: function beginServers() {
            if (this.params.end) {
                var idx = this.serverIds.indexOf(this.params.end);
                return this.srcServers.slice(0, idx + 1);
            }
            return this.srcServers;
        },
        endServers: function endServers() {
            if (this.params.begin) {
                var idx = this.serverIds.indexOf(this.params.begin);
                return this.srcServers.slice(idx);
            }
            return this.srcServers;
        }
    },
    watch: {
        srcServers: function srcServers() {
            this.change();
        }
    },
    methods: {
        reset: function reset() {
            this.params = {
                begin: "",
                end: "",
                name: "",
                status: "",
                type: ""
            };
        },
        getSelectedIds: function getSelectedIds() {
            var _this = this;

            var begin = this.params.begin ? this.serverIds.indexOf(this.params.begin) : 0,
                end = this.params.end ? this.serverIds.indexOf(this.params.end) + 1 : this.serverIds.length,
                ids = this.serverIds.slice(begin, end),
                tmp = [];
            ids.forEach(function (id) {
                tmp.push(id, _this.id2childrenIds[id]);
            });
            return tmp.flat();
        },
        change: function change() {
            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ selectedIds: this.getSelectedIds() }, this.params);
            this.$emit("change", params);
        }
    }
});

/***/ }),

/***/ "gGMy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("6BbG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf6fa5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("hm+e");
function injectStyle (ssrContext) {
  __webpack_require__("+HI+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cf6fa5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf6fa5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gJHW":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./website/subComponents/autoload": "GK8i"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gJHW";

/***/ }),

/***/ "gNKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frame_vue__ = __webpack_require__("QRQv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bfafce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_frame_vue__ = __webpack_require__("6m1I");
function injectStyle (ssrContext) {
  __webpack_require__("o8to")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42bfafce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42bfafce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_frame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h1Z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "hm+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-header-box"},[_c('div',{staticClass:"sub-header-left"},[_c('div',{staticClass:"sub-header-select-box"},[(!_vm.$selectDisabledStatus)?_c('el-select',{staticClass:"sub-header-select",attrs:{"filterable":"","disabled":_vm.$selectDisabledStatus,"placeholder":_vm.$selectPlaceholder,"size":"small","filter-method":_vm.filterGameList},on:{"change":_vm.selectFn,"visible-change":_vm.visibleChange},model:{value:(_vm.gameCode),callback:function ($$v) {_vm.gameCode=$$v},expression:"gameCode"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item['game_id'],attrs:{"label":item.name,"value":item.game_code}})}),1):_vm._e()],1),_vm._v(" "),(_vm.$isaccess)?_c('div',{staticClass:"sub-header-project-type"},[_c('a',{class:_vm.activeProjectType === 1 ? 'active' : '',attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.projectTypeFn(_vm.$config.projectTypeRoute1, 1)}}},[_vm._v("发行配置")]),_vm._v(" "),_c('a',{class:_vm.activeProjectType === 2 ? 'active' : '',attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.projectTypeFn(_vm.$config.projectTypeRoute2, 2)}}},[_vm._v("业务管理")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sub-header-right"},[(_vm.$isaccess && _vm.$routerMaps['system'])?_c('div',{staticClass:"sub-header-setting"},[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"},on:{"select":_vm.subMenuSelected}},[_c('el-submenu',{attrs:{"index":"system","popper-class":"sub-header-setting-pop"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-setting"})]),_vm._v(" "),_vm._l((_vm.$routerMaps['system']['children']),function(item){return [_c('el-menu-item',{key:item.active,attrs:{"index":("system/" + (item.active))},domProps:{"innerHTML":_vm._s(item.title)}})]})],2)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sub-header-username"},[_vm._v("\n            "+_vm._s(_vm.$userInfo.name ? _vm.$userInfo.name : "游客")+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"sub-header-logout",on:{"click":function($event){return _vm.$helper.helper.logout()}}},[_c('i',{staticClass:"el-icon-switch-button"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hr8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("O1ev");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_154a4430_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("Tgt7");
function injectStyle (ssrContext) {
  __webpack_require__("7XdD")
  __webpack_require__("asZg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_154a4430_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hsci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('em',{staticClass:"el-icon-arrow-left",style:({color: _vm.titleColor})}),_vm._v(" "),_c('h3',[_c('span',{style:({color: _vm.titleColor})},[_vm._v("个人中心")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hv0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "basisConfig",
    props: {
        params: {
            type: Object,
            default: function _default() {}
        },
        is_configured: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),

/***/ "iUc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "noIdentified",
    props: {
        params: {
            type: Object,
            default: function _default() {}
        },
        is_configured: {
            type: Boolean,
            default: false
        }
    }
});

/***/ }),

/***/ "icwK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdk-dimension-container"},[_c('div',{staticClass:"flex"},[_c('el-form',{ref:"form",staticStyle:{"width":"600px"},attrs:{"model":_vm.params.style,"label-width":_vm.labelWidth}},[_c('el-form-item',{attrs:{"label":"页面风格："}},[_c('el-radio-group',{on:{"change":_vm.handleCustomStyleAllowed},model:{value:(_vm.params.style.custom_personal_center_style_allowed),callback:function ($$v) {_vm.$set(_vm.params.style, "custom_personal_center_style_allowed", $$v)},expression:"params.style.custom_personal_center_style_allowed"}},[_c('el-radio',{attrs:{"label":false}},[_vm._v("默认系统风格 ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":true}},[_vm._v("游戏风格")])],1),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view left-120",on:{"click":function($event){$event.stopPropagation();_vm.personalCenterDefaultDialogVisible = true}}})],1),_vm._v(" "),(_vm.params.style.custom_personal_center_style_allowed)?_c('el-form-item',{attrs:{"rules":[{ required: _vm.params.style.custom_personal_center_style_allowed, message: '请上传背景图', trigger: 'blur' }],"label":"背景图：","prop":"personal_center_background"}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"upload-box"},[_c('div',{staticClass:"personal-center-font-style"},[_vm._v("尺寸要求：")]),_vm._v(" "),_c('div',{staticClass:"personal-center-font-style"},[_vm._v("横版高度固定1440px，宽度等比缩放，建议宽度大于2560px")]),_vm._v(" "),_c('div',{staticClass:"personal-center-font-style"},[_vm._v("竖版宽度固定1440px，高度等比缩放，建议高度大于600px")]),_vm._v(" "),_c('div',{staticClass:"personal-center-font-style"},[_vm._v("个人中心的横竖版设置与游戏的横竖版设置一致")]),_vm._v(" "),_c('upload',{staticClass:"page-style-upload",attrs:{"formatlimit":"all"},model:{value:(_vm.params.style.personal_center_background),callback:function ($$v) {_vm.$set(_vm.params.style, "personal_center_background", $$v)},expression:"params.style.personal_center_background"}})],1)])]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"页面样式："}},[_c('el-radio-group',{on:{"change":_vm.handlerDefaultStyle},model:{value:(_vm.params.style.appearance),callback:function ($$v) {_vm.$set(_vm.params.style, "appearance", $$v)},expression:"params.style.appearance"}},[_c('el-radio',{attrs:{"label":"light"}},[_vm._v("浅色系 ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"dark"}},[_vm._v("深色系")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"页面样式："}},[_c('el-radio-group',{on:{"change":_vm.handlerDefaultStyle},model:{value:(_vm.params.style.custom_page_style_allowed),callback:function ($$v) {_vm.$set(_vm.params.style, "custom_page_style_allowed", $$v)},expression:"params.style.custom_page_style_allowed"}},[_c('el-radio',{attrs:{"label":false}},[_vm._v("默认样式")]),_vm._v(" "),_c('el-radio',{attrs:{"label":true}},[_vm._v("自定义样式")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"标题1："}},[_c('div',{staticClass:"style-diy-color"},[_c('div',{staticClass:"background-color"},[_c('div',{style:({background: _vm.params.diy_colors.title_1})},[_vm._v(_vm._s(_vm.params.diy_colors.title_1))])]),_vm._v(" "),_c('el-color-picker',{attrs:{"disabled":!_vm.params.style.custom_page_style_allowed},model:{value:(_vm.params.diy_colors.title_1),callback:function ($$v) {_vm.$set(_vm.params.diy_colors, "title_1", $$v)},expression:"params.diy_colors.title_1"}}),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('title_1')}}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容底框背景色："}},[_c('div',{staticClass:"style-diy-color"},[_c('div',{staticClass:"background-color"},[_c('div',{style:({background: _vm.params.diy_colors.background_color})},[_vm._v(_vm._s(_vm.params.diy_colors.background_color))])]),_vm._v(" "),_c('el-color-picker',{attrs:{"disabled":!_vm.params.style.custom_page_style_allowed},model:{value:(_vm.params.diy_colors.background_color),callback:function ($$v) {_vm.$set(_vm.params.diy_colors, "background_color", $$v)},expression:"params.diy_colors.background_color"}}),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('background_color')}}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容区域背景色："}},[_c('div',{staticClass:"style-diy-color"},[_c('div',{staticClass:"background-color"},[_c('div',{style:({background: _vm.params.diy_colors.background_color_of_content})},[_vm._v(_vm._s(_vm.params.diy_colors.background_color_of_content))])]),_vm._v(" "),_c('el-color-picker',{attrs:{"disabled":!_vm.params.style.custom_page_style_allowed},model:{value:(_vm.params.diy_colors.background_color_of_content),callback:function ($$v) {_vm.$set(_vm.params.diy_colors, "background_color_of_content", $$v)},expression:"params.diy_colors.background_color_of_content"}}),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('background_color_of_content')}}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"按钮颜色："}},[_c('div',{staticClass:"style-diy-color"},[_c('div',{staticClass:"background-color"},[_c('div',{style:({background: _vm.params.diy_colors.color_of_button})},[_vm._v(_vm._s(_vm.params.diy_colors.color_of_button))])]),_vm._v(" "),_c('el-color-picker',{attrs:{"disabled":!_vm.params.style.custom_page_style_allowed},model:{value:(_vm.params.diy_colors.color_of_button),callback:function ($$v) {_vm.$set(_vm.params.diy_colors, "color_of_button", $$v)},expression:"params.diy_colors.color_of_button"}}),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('color_of_button')}}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"内容选中高亮背景色："}},[_c('div',{staticClass:"style-diy-color"},[_c('div',{staticClass:"background-color"},[_c('div',{style:({background: _vm.params.diy_colors.highlight_background_color})},[_vm._v(_vm._s(_vm.params.diy_colors.highlight_background_color))])]),_vm._v(" "),_c('el-color-picker',{attrs:{"disabled":!_vm.params.style.custom_page_style_allowed},model:{value:(_vm.params.diy_colors.highlight_background_color),callback:function ($$v) {_vm.$set(_vm.params.diy_colors, "highlight_background_color", $$v)},expression:"params.diy_colors.highlight_background_color"}}),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('highlight_background_color')}}})],1)]),_vm._v(" "),_c('el-form-item',[(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v(_vm._s(_vm.isIOS ? '下一步' : '完成'))]):_vm._e()],1)],1),_vm._v(" "),_c('span',{staticClass:"line"}),_vm._v(" "),_c('el-tabs',{staticClass:"upload-box tabs",model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"横版","name":"landscape"}},[_c('div',{staticClass:"upload-view-landscape"},[_c('div',{staticClass:"contents"},[(!_vm.params.style.custom_personal_center_style_allowed)?_c('img',{attrs:{"src":_vm.defaultLandscapeUrl,"height":"294","width":"530","alt":"","srcset":""}}):[_c('img',{staticClass:"zindex-0",attrs:{"src":_vm.params.style.personal_center_background,"height":"294","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"zindex-1 right-conetnt"},[_c('diy-title',{attrs:{"titleColor":_vm.params.diy_colors.title_1}}),_vm._v(" "),_c('div',{staticClass:"right-content-bom",style:({backgroundColor: _vm.params.diy_colors.background_color})},[_c('div',{staticClass:"user-center",style:(_vm.backgroundContentColor)},[_c('img',{attrs:{"src":__webpack_require__("TdxR"),"height":"50","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-name"},[_vm._v("rolename")]),_vm._v(" "),_c('div',{staticClass:"user-server-name"},[_vm._v("userservername")]),_vm._v(" "),_c('div',{staticClass:"user-id"},[_vm._v("300000010451646")])])]),_vm._v(" "),_c('ul',{staticClass:"taps"},_vm._l((_vm.randerTaps().tap1),function(item,i){return _c('li',{key:'tap1'+ i,style:(_vm.backgroundContentColor),on:{"mouseenter":_vm.handlerOverCurrentBackground,"mouseleave":_vm.handlerOutCurrentBackground}},[_c('div',[_c('img',{attrs:{"src":item.url,"height":"28","alt":"","srcset":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.text))])]),_vm._v(" "),_c('em',{staticClass:"el-icon-arrow-right"})])}),0),_vm._v(" "),_c('ul',{staticClass:"taps"},_vm._l((_vm.randerTaps().tap2),function(item,i){return _c('li',{key:'tap1'+ i,style:(_vm.backgroundContentColor),on:{"mouseenter":_vm.handlerOverCurrentBackground,"mouseleave":_vm.handlerOutCurrentBackground}},[_c('div',[_c('img',{attrs:{"src":item.url,"height":"28","alt":"","srcset":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.text))])]),_vm._v(" "),_c('em',{staticClass:"el-icon-arrow-right"})])}),0)])],1)]],2)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"竖版","name":"portrait"}},[_c('div',{staticClass:"upload-view-portrait"},[_c('div',{staticClass:"contents"},[(!_vm.params.style.custom_personal_center_style_allowed)?_c('img',{staticClass:"portrait-img",attrs:{"src":_vm.defaultPortraitUrl,"height":"526","width":"290","alt":"","srcset":""}}):_c('div',{staticClass:"zindex-1 right-conetnt"},[_c('img',{staticClass:"zindex-0",attrs:{"src":_vm.params.style.personal_center_background,"width":"290","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"right-content-bom background-color",style:({backgroundColor: _vm.params.diy_colors.background_color})},[_c('diy-title',{attrs:{"titleColor":_vm.params.diy_colors.title_1}}),_vm._v(" "),_c('div',{staticClass:"user-center",style:(_vm.backgroundContentColor)},[_c('img',{attrs:{"src":__webpack_require__("TdxR"),"height":"50","alt":"","srcset":""}}),_vm._v(" "),_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-name"},[_vm._v("rolename")]),_vm._v(" "),_c('div',{staticClass:"user-server-name"},[_vm._v("userservername")]),_vm._v(" "),_c('div',{staticClass:"user-id"},[_vm._v("300000010451646")])])]),_vm._v(" "),_c('ul',{staticClass:"taps"},_vm._l((_vm.randerTaps().tap1),function(item,i){return _c('li',{key:'tap1'+ i,style:(_vm.backgroundContentColor),on:{"mouseenter":_vm.handlerOverCurrentBackground,"mouseleave":_vm.handlerOutCurrentBackground}},[_c('div',[_c('img',{attrs:{"src":item.url,"height":"20","alt":"","srcset":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.text))])]),_vm._v(" "),_c('em',{staticClass:"el-icon-arrow-right"})])}),0),_vm._v(" "),_c('ul',{staticClass:"taps"},_vm._l((_vm.randerTaps().tap2),function(item,i){return _c('li',{key:'tap2'+ i,style:(_vm.backgroundContentColor),on:{"mouseenter":_vm.handlerOverCurrentBackground,"mouseleave":_vm.handlerOutCurrentBackground}},[_c('div',{on:{"mouseenter":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":item.url,"height":"20","alt":"","srcset":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.text))])]),_vm._v(" "),_c('em',{staticClass:"el-icon-arrow-right"})])}),0),_vm._v(" "),_c('ul',{staticClass:"taps"},_vm._l((_vm.randerTaps().tap3),function(item,i){return _c('li',{key:'tap1'+ i,style:(_vm.backgroundContentColor),on:{"mouseenter":_vm.handlerOverCurrentBackground,"mouseleave":_vm.handlerOutCurrentBackground}},[_c('div',[_c('img',{attrs:{"src":item.url,"height":"20","alt":"","srcset":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.text))])]),_vm._v(" "),_c('em',{staticClass:"el-icon-arrow-right"})])}),0)],1)])])])])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"el-dialog__body_self",attrs:{"title":"默认效果预览","visible":_vm.personalCenterDefaultDialogVisible,"width":"720px"},on:{"update:visible":function($event){_vm.personalCenterDefaultDialogVisible=$event}}},[_c('div',{staticClass:"flex dialog-img-box"},[_c('div',[_c('div',[_vm._v("iOS横版")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("CNxV"),"width":"320","alt":""}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Android横版")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Fedn"),"width":"320","alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"flex dialog-img-box"},[_c('div',[_c('div',[_vm._v("iOS竖版")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Jp+H"),"height":"568","alt":""}})]),_vm._v(" "),_c('div',[_c('div',[_vm._v("Android竖版")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("v6+Z"),"height":"568","alt":""}})])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"预览","visible":_vm.styleDialogVisible,"width":"1200px"},on:{"update:visible":function($event){_vm.styleDialogVisible=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("颜色位置预览 "),_c('span',{staticStyle:{"color":"#F56C6C"}},[_vm._v("（该图片仅用来示意颜色在界面中的显示位置，不代表真实效果。）")])])]),_vm._v(" "),_c('img',{attrs:{"src":_vm.activeUrl,"alt":"","width":"1160"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j9ck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    baseInfo: {},
    apiConfig: {},
    testRet: {}
};
var handler = {
    _getUrl: function _getUrl(rootState) {
        var url = rootState.$config.api.app.baseinfo;
        return _.replace(url, '{game_code}', rootState.$helper.helper.getGameCode().game_code);
    }
};
/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    SET_API_CONFIG: function SET_API_CONFIG(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        commit('_setApiConfig', args);
    },
    UPDATE_API_CONFIG: function UPDATE_API_CONFIG(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var url = handler._getUrl(rootState);
        commit('PRIVATE_LOADING', true, { root: true });
        rootState.$helper.request.put(url, args).then(function (data) {
            dispatch('GET_ACTIVE_GAME_INFO', null, { root: true });
            commit('PRIVATE_LOADING', false, { root: true });
            dispatch('ALERT_HANDLE', { message: '提交成功！', reload: true }, { root: true });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
            commit('PRIVATE_LOADING', false, { root: true });
        });
    },
    REMOVE_API_CONFIG: function REMOVE_API_CONFIG(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        commit('_removeApiConfig', args);
    },
    CURL_TEST_URL: function CURL_TEST_URL(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var appUrl = rootState.$config.api.app;
        var url = appUrl['test_' + args.type];
        args.game_code = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get(url, args).then(function (data) {
            commit('PRIVATE_LOADING', false, { root: true });
            commit('_curlTestUrl', eval('(' + data.data.response + ')'));
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
            commit('PRIVATE_LOADING', false, { root: true });
        });
    },
    RESET_TEST_RET: function RESET_TEST_RET(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        commit('_resetTestRet', '');
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _setApiConfig: function _setApiConfig(state, args) {
        var isExist = false;
        _.forEach(state.apiConfig, function (item, ind) {
            if (args.key === item.key) {
                isExist = true;
                state.apiConfig[ind] = args;
            }
        });
        if (!isExist) {
            state.apiConfig[args.key] = args;
        }
    },


    /****
     * @param state
     * @param args
     * @private
     */
    _removeApiConfig: function _removeApiConfig(state, args) {
        var temp = [];
        for (var key in state.apiConfig) {
            temp.push(state.apiConfig[key]);
        }
        temp = temp.filter(function (tab) {
            return tab.key !== args;
        });
        var res = {};
        var len = temp.length;
        for (var i = 0; i < len; i++) {
            res[temp[i]['key']] = temp[i];
        }
        state.apiConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res);
    },
    _curlTestUrl: function _curlTestUrl(state, args) {
        state.testRet = args;
    },
    _resetTestRet: function _resetTestRet(state, args) {
        state.testRet = '';
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "jLM+":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./website/store/app": "60zE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jLM+";

/***/ }),

/***/ "jYsH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jb01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetIdfaAllowed_vue__ = __webpack_require__("OXH7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f9bf74b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetIdfaAllowed_vue__ = __webpack_require__("YVX7");
function injectStyle (ssrContext) {
  __webpack_require__("xIyZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetIdfaAllowed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f9bf74b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetIdfaAllowed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jfVJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jqB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "jr9Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sdkUpload",
    props: {
        value: {
            type: String,
            default: ''
        },
        size: '',
        formatlimit: ''
    },
    data: function data() {
        return {
            imgUrl: ''
        };
    },

    watch: {
        value: {
            handler: function handler(val) {
                this.imgUrl = val;
            },

            immediate: true
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$config'])),
    methods: {
        handleSuccess: function handleSuccess(file) {
            this.$emit('input', file.fileurl || '');
        },
        beforeUpload: function beforeUpload(file) {

            if (this.$props.formatlimit === 'png') {
                var fileSuffix = ['image/png'].includes(file.type);
                if (!fileSuffix) {
                    this.$message({
                        message: '上传格式错误，只支持png格式！',
                        type: 'error',
                        showClose: true
                    });
                    return false;
                }
            } else if (this.$props.formatlimit === 'jpg') {
                var _fileSuffix = ['image/jpeg'].includes(file.type);
                if (!_fileSuffix) {
                    this.$message({
                        message: '上传格式错误，只支持jpg格式！',
                        type: 'error',
                        showClose: true
                    });
                    return false;
                }
            } else {
                var _fileSuffix2 = ['image/jpeg', 'image/png'].includes(file.type);
                if (!_fileSuffix2) {
                    this.$message({
                        message: '上传格式错误，只支持png/jpg格式！',
                        type: 'error',
                        showClose: true
                    });
                    return false;
                }
            }
        },
        errorUpload: function errorUpload() {
            this.$alert('上传失败！', '提示');
        }
    }
});

/***/ }),

/***/ "kdcc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sub-system-list',
    props: ['datalist'],
    data: function data() {
        return {
            dialogVisible: false,
            form: {
                version: '',
                detail: ''
            },
            itemData: {}
        };
    },

    components: {},
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment', '$route'])),

    created: function created() {},


    watch: {
        datalist: function datalist(val) {
            console.log(val);
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['ALERT_HANDLE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('systemSdkVersion', ['REMOVE_BASE_VERSION', 'EDIT_BASE_VERSION']), {
        edit: function edit(item) {
            this.form.version = item.version;
            this.form.detail = item.detail;
            this.itemData = item;
            this.dialogVisible = !this.dialogVisible;
        },
        onSubmit: function onSubmit() {
            var reg = /^[0-9\.]{2,}$/;

            if (!this.$helper.helper.tirm(this.form.version)) {
                this.ALERT_HANDLE({ message: '版本号不能为空！例如: 5.2.0' });
                return false;
            }

            if (!this.$helper.helper.tirm(this.form.detail)) {
                this.ALERT_HANDLE({ message: '版本描述不能为空！' });
                return false;
            }

            if (!reg.test(this.form.version)) {
                this.ALERT_HANDLE({ message: '版本号只能包含数字和点，例如: 5.2.0' });
                return false;
            }

            /**
             * 编辑版本号
             */
            this.EDIT_BASE_VERSION({ data: this.form, item: this.itemData, callback: function callback() {
                    this.dialogVisible = !this.dialogVisible;
                    this.form.version = '';
                    this.form.detail = '';
                    this.from.sdk_version_id = '';
                    this.from.platform = '';
                }
            });
        },
        remove: function remove(item) {
            var _this = this;

            this.$confirm('确认删除当前版本号吗？', '提示').then(function () {
                _this.REMOVE_BASE_VERSION(item);
            }).catch(function (res) {
                console.log(res);
            });
        }
    })
});

/***/ }),

/***/ "l29D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"times-container"},[_c('span',{staticClass:"title-description"},[_vm._v("可设置多个推送时间，系统将按照推送时间定时推送")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.pushTimesForm,"inline":"","rules":_vm.formRule}},[_c('el-form-item',{attrs:{"prop":"time"}},[_c('el-date-picker',{attrs:{"size":"small","type":"datetime","disabled":_vm.isDetail,"format":"yyyy-MM-dd HH:mm","value-format":"yyyy-MM-dd HH:mm","picker-options":_vm.pickerOptions,"placeholder":"选择日期时间"},model:{value:(_vm.pushTimesForm.time),callback:function ($$v) {_vm.$set(_vm.pushTimesForm, "time", $$v)},expression:"pushTimesForm.time"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"next-button",attrs:{"disabled":_vm.isDetail,"type":"success","size":"small","icon":"el-icon-plus"},on:{"click":_vm.handleCreateTime}},[_vm._v("添加")])],1)],1),_vm._v(" "),_c('el-alert',{attrs:{"title":'已添加推送时间（共'+_vm.tableData.length+'次）',"closable":false,"type":"success"}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"prop":"send_time","label":"推送时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"week_day","label":"周信息"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"send_status","label":"推送状态"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"send_number","label":"推送人数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isDetail && scope.row.send_status !== '已推送')?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.handleDelete(scope.$index)}}},[_vm._v("删除")]):_vm._e()]}}])})],1),_vm._v(" "),(!_vm.isDetail)?_c('el-button',{staticClass:"next-button margin-top-18",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("下一步")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l6JS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




/**
 * Created by shiyonggao on 2019/12/13.
 */

var sessionStorage = function () {
    function sessionStorage() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, sessionStorage);

        this.regKey = /^[a-zA-Z_]{1,}$/;
        this.store = window.sessionStorage ? window.sessionStorage : null;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(sessionStorage, [{
        key: "check",
        value: function check(key) {
            if (!this.store) {
                throw "Browser don't support localStorage";
            }

            if (!this.regKey.test(key)) {
                throw "Key the rules is error";
            }
        }

        /***
         * 设置值
         * @param key [a-zA-Z_]
         * @param value
         * @param expire 小时单位 type='number'
         */

    }, {
        key: "set",
        value: function set(key, value, expire) {
            this.check(key);
            this.store.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
        }

        /**
         * 获取值
         * @param key
         * @returns {string|null}
         */

    }, {
        key: "get",
        value: function get(key) {
            this.check(key);
            return this.store.getItem(key);
        }

        /**
         * 删除值
         * @param key
         */

    }, {
        key: "remove",
        value: function remove(key) {
            this.check(key);
            this.store.removeItem(key);
        }
    }]);

    return sessionStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (new sessionStorage());

/***/ }),

/***/ "lDZI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "lJ6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    platformPackageList: '',
    iosTotalCount: '',
    androidTotalCount: '',
    h5TotalCount: '',
    windowsTotalCount: '',
    gameRegionList: [], // 地区
    gamePackageList: [], // 包名
    gameStoreList: [], // 发行渠道
    authServerList: '',
    testServerList: ''

};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_GAME_REGION_LIST: function GET_GAME_REGION_LIST(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;


        var package_ajax_game_region_list_url = rootState.$config.api.package_ajax_game_region_list_url;
        rootState.$helper.request.get(package_ajax_game_region_list_url, args).then(function (res) {
            commit('_getGameRegionList', res.data.result);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_GAME_PACKAGE_LIST: function GET_GAME_PACKAGE_LIST(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;


        var package_ajax_game_package_list_url = rootState.$config.api.package_ajax_game_package_list_url;
        rootState.$helper.request.get(package_ajax_game_package_list_url, args).then(function (res) {
            commit('_getGamePackageList', res.data.result);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_GAME_STORE_LIST: function GET_GAME_STORE_LIST(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;


        var package_ajax_game_store_list_url = rootState.$config.api.package_ajax_game_store_list_url;
        rootState.$helper.request.get(package_ajax_game_store_list_url, args).then(function (res) {
            commit('_getGameStoreList', res.data.result);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PLATFORM_PACKAGE_ALL_LIST: function GET_PLATFORM_PACKAGE_ALL_LIST(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;


        console.log('GET_PLATFORM_PACKAGE_ALL_LIST', args);
        var package_games_list_url = rootState.$config.api.package_games_list_url;
        package_games_list_url = package_games_list_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.get(package_games_list_url, args).then(function (res) {
            commit('_setPlatformPackageList', res.data);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    ADD_PACKAGE: function ADD_PACKAGE(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;


        var package_add_package_url = rootState.$config.api.package_add_package_url;
        package_add_package_url = package_add_package_url.replace('{game_code}', args.game_code);

        rootState.$helper.request.put(package_add_package_url, args).then(function (res) {
            dispatch('GET_PLATFORM_PACKAGE_ALL_LIST', {
                game_code: args.game_code,
                platform: args.platform,
                package_name: args.select_package_value,
                region_code: args.select_country_value
            });
            dispatch('GET_GAME_PACKAGE_LIST', {
                game_code: args.game_code,
                platform: args.platform
            });

            if (typeof args.callback === 'function') {
                args.callback();
            }
        }).catch(function (res) {
            args.errCallback();
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    EDIT_PACKAGE: function EDIT_PACKAGE(_ref6, args) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;


        var package_edit_del_package_url = rootState.$config.api.package_edit_del_package_url;
        package_edit_del_package_url = package_edit_del_package_url.replace('{game_code}', args.game_code);
        package_edit_del_package_url = package_edit_del_package_url.replace('{package_id}', args.package_region_id);

        rootState.$helper.request.put(package_edit_del_package_url, args).then(function (res) {
            dispatch('GET_PLATFORM_PACKAGE_ALL_LIST', {
                game_code: args.game_code,
                platform: args.platform,
                package_name: args.select_package_value,
                region_code: args.select_country_value
            });
            dispatch('GET_GAME_PACKAGE_LIST', {
                game_code: args.game_code,
                platform: args.platform
            });

            if (typeof args.callback === 'function') {
                args.callback();
            }
        }).catch(function (res) {
            args.errCallback();
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    DELETE_PACKAGE_BY_ID: function DELETE_PACKAGE_BY_ID(_ref7, args) {
        var state = _ref7.state,
            commit = _ref7.commit,
            dispatch = _ref7.dispatch,
            rootState = _ref7.rootState;


        var package_edit_del_package_url = rootState.$config.api.package_edit_del_package_url;
        package_edit_del_package_url = package_edit_del_package_url.replace('{game_code}', args.game_code);
        package_edit_del_package_url = package_edit_del_package_url.replace('{package_id}', args.package_id);

        rootState.$helper.request.delete(package_edit_del_package_url).then(function (res) {
            dispatch('GET_PLATFORM_PACKAGE_ALL_LIST', { game_code: args.game_code, platform: args.platform });
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_SERVER_LIST_BY_REGION: function GET_SERVER_LIST_BY_REGION(_ref8, args) {
        var state = _ref8.state,
            commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            rootState = _ref8.rootState;


        var package_server_list_region_url = rootState.$config.api.package_server_list_region_url;

        rootState.$helper.request.get(package_server_list_region_url, args).then(function (res) {
            commit('_getServerList', res.data.result);
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 *
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _getGameRegionList: function _getGameRegionList(state, args) {
        state.gameRegionList = args;
    },
    _getGamePackageList: function _getGamePackageList(state, args) {
        state.gamePackageList = args;
    },
    _getGameStoreList: function _getGameStoreList(state, args) {
        state.gameStoreList = args;
    },
    _addPackageList: function _addPackageList(state, args) {
        state.packageList.push(args);
    },
    _setPlatformPackageList: function _setPlatformPackageList(state, args) {
        state.platformPackageList = args.packages;
        state.iosTotalCount = args.ios_count;
        state.androidTotalCount = args.android_count;
        state.h5TotalCount = args.h5_count;
        state.windowsTotalCount = args.windows_count;
    },
    _getServerList: function _getServerList(state, args) {

        state.authServerList = args.auth_serverlist;
        state.testServerList = args.test_serverlist;
    },

    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "lVf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YYYY_MM_DD", function() { return YYYY_MM_DD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YYYY_MM_DD_HH_MM", function() { return YYYY_MM_DD_HH_MM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YYYY_MM_DD_HH_MM_SS", function() { return YYYY_MM_DD_HH_MM_SS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var YYYY_MM_DD = function YYYY_MM_DD(val) {
    return val ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(val, 'X').format('YYYY-MM-DD') : '--';
};

var YYYY_MM_DD_HH_MM = function YYYY_MM_DD_HH_MM(val) {
    return val ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(val, 'X').format('YYYY-MM-DD HH:mm') : '--';
};

var YYYY_MM_DD_HH_MM_SS = function YYYY_MM_DD_HH_MM_SS(val) {
    return val ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(val, 'X').format('YYYY-MM-DD HH:mm:ss') : '--';
};


/***/ }),

/***/ "mdp2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'users',
    data: function data() {
        return {
            model: '',
            userOptions: []
        };
    },

    props: {
        value: {
            type: Array,
            default: []
        },
        disabled: {
            type: [Number, Boolean],
            default: false
        }
    },
    watch: {
        value: function value(val) {
            this.model = val;
        },

        model: {
            handler: function handler(val) {
                this.$emit("input", val);
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('pushPushPlanOperate', ['users'])),
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('pushPushPlanOperate', ['getAllUsers']), {
        filterData: function filterData(kwd) {
            if (typeof kwd === 'string' && kwd) {
                this.userOptions = this.users.filter(function (item) {
                    var names = [item.fullname, item.firstnamePinYin, item.fullnameFirstLetter, item.username].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            } else {
                this.userOptions = _.cloneDeep(this.users);
            }
        }
    }),
    created: function created() {
        var _this = this;

        this.getAllUsers().then(function (_) {
            _this.filterData();
        });
    }
});

/***/ }),

/***/ "mne3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
  getAutoBanSettingData: function getAutoBanSettingData(_ref, params) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    var gameCode = rootState.$helper.helper.getGameCode().game_code;
    return rootState.$helper.request.get("/games/" + gameCode + "/auto-ban-setting", params, function (res) {
      return true;
    });
  },
  editAutoBanSetting: function editAutoBanSetting(_ref2, params) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    var gameCode = rootState.$helper.helper.getGameCode().game_code;
    return rootState.$helper.request.post("/games/" + gameCode + "/auto-ban-setting/edit", params).then();
  }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "nYFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "nYdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "ServerDialog",
    data: function data() {
        return {
            selfVisible: false,
            formVisible: false,
            params: {
                type: "single",
                begin: "",
                end: "",
                range: [],
                ids: [],
                time: "",
                data_source: "",
                server_type: ""
            }
        };
    },

    props: {
        // maintain open config
        type: {
            type: String,
            default: "maintain"
        },
        servers: {
            type: Array,
            required: true
        },
        srcServers: {
            type: Array,
            required: true
        },
        selectedIds: {
            type: Array
        },
        title: String,
        visible: {
            type: Boolean
        }
    },
    watch: {
        visible: {
            handler: function handler(val) {
                this.selfVisible = val;
            },

            immediate: true
        },
        selfVisible: function selfVisible(val) {
            var _this = this;

            if (!val) {
                this.$emit("update:visible", false);
                setTimeout(function () {
                    _this.formVisible = false;
                }, 300);
            } else {
                this.formVisible = true;
            }
        },
        formVisible: function formVisible(val) {
            // reset params after dialog opened
            if (val) {
                this.params = {
                    type: "single",
                    begin: "",
                    end: "",
                    range: [],
                    ids: this.selectedIds,
                    time: this.type === "maintain" ? [__WEBPACK_IMPORTED_MODULE_0_moment___default()().utcOffset(8).toDate(), __WEBPACK_IMPORTED_MODULE_0_moment___default()().utcOffset(8).add(1, "M").toDate()] : __WEBPACK_IMPORTED_MODULE_0_moment___default()().utcOffset(8).toDate(),
                    data_source: "",
                    server_type: ""
                };
            }
        },

        selectedIds: {
            handler: function handler(val) {
                this.params.ids = val;
            },

            immediate: true
        },
        "params.type": function paramsType(val) {
            if (val === "all") {
                this.params.ids = [];
            }
        },
        "params.begin": function paramsBegin() {
            this.setParamsRange();
        },
        "params.end": function paramsEnd() {
            this.setParamsRange();
        }
    },
    computed: {
        timeLabelText: function timeLabelText() {
            return this.type === "open" ? "开服时间" : this.type === "maintain" ? "维护时间" : "";
        },
        rules: function rules() {
            return {
                type: [{ required: true, message: "" }],
                time: [{ required: true, message: "请选择" + this.timeLabelText }],
                range: [{
                    required: this.params.type === "range",
                    message: "请选择服务器"
                }],
                ids: [{
                    required: this.params.type === "single",
                    message: "请选择服务器"
                }],
                data_source: [{
                    required: this.type === "config",
                    message: "请选择数据来源"
                }],
                server_type: [{
                    required: this.type === "config" && this.params.data_source === 1,
                    message: "请选择区服类型"
                }]
            };
        },
        filterServers: function filterServers() {
            if (this.type === "config") {
                return this.srcServers;
            }
            return this.servers;
        },
        serverIds: function serverIds() {
            return this.filterServers.map(function (v) {
                return v.server_auto_id;
            });
        },
        beginServers: function beginServers() {
            if (this.params.end) {
                var idx = this.serverIds.indexOf(this.params.end);
                return this.filterServers.slice(0, idx + 1);
            }
            return this.filterServers;
        },
        endServers: function endServers() {
            if (this.params.begin) {
                var idx = this.serverIds.indexOf(this.params.begin);
                return this.filterServers.slice(idx);
            }
            return this.filterServers;
        },
        rangeIds: function rangeIds() {
            if (!this.params.range.length) {
                return [];
            }
            var begin = this.serverIds.indexOf(this.params.begin),
                end = this.serverIds.indexOf(this.params.end);
            return this.serverIds.slice(begin, end + 1);
        },
        finalIds: function finalIds() {
            var tmp = void 0;
            switch (this.params.type) {
                case "single":
                    tmp = this.params.ids;
                    break;
                case "range":
                    tmp = this.rangeIds;
                    break;
                case "all":
                    tmp = this.serverIds;
                    break;
            }
            return tmp;
        }
    },
    methods: {
        typeChange: function typeChange() {
            this.$refs.form.clearValidate(["ids", "range", "server_type", "data_source"]);
        },
        dsChange: function dsChange() {
            if (this.params.data_source === 0) {
                this.params.server_type = "";
            }
            this.$refs.form.clearValidate(["ids", "range", "server_type"]);
        },
        setParamsRange: function setParamsRange() {
            var _this2 = this;

            if (!this.params.begin || !this.params.end) {
                this.params.range = [];
            } else {
                this.params.range = [this.params.begin, this.params.end];
            }
            setTimeout(function () {
                _this2.$refs.form.clearValidate(["range"]);
            });
        },
        getSubmitParams: function getSubmitParams() {
            var tmp = {};
            tmp.server_auto_id_list = this.finalIds.join(",");

            var time = Array.isArray(this.params.time) ? this.params.time : [this.params.time];
            tmp.time = time.map(function (v) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(v).utcOffset(8).format("X");
            });

            if (this.type === "config") {
                tmp.data_source = this.params.data_source;
                tmp.server_type = this.params.server_type;
                tmp.server_type = tmp.data_source === 0 ? 3 : tmp.server_type;
                delete tmp.time;
            }
            return tmp;
        },
        submit: function submit() {
            var _this3 = this;

            this.$refs.form.validate(function (valid) {
                if (valid) {
                    var params = _this3.getSubmitParams();
                    _this3.$emit("submit", params);
                }
            });
        }
    }
});

/***/ }),

/***/ "o8to":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ozhi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticStyle:{"width":"400px"},attrs:{"disabled":_vm.disableds,"filterable":"","clearable":"","multiple":_vm.multiple,"placeholder":"请选择","size":"small"},on:{"change":_vm.change},model:{value:(_vm.serverIds),callback:function ($$v) {_vm.serverIds=$$v},expression:"serverIds"}},_vm._l((_vm.servers),function(item){return _c('el-option',{key:item.server_auto_id,attrs:{"label":item.display_server_name + '（' + item.server_id + '）',"value":item.server_auto_id,"disabled":item.disabled}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p0NN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/11/06.
 */

var router = {
    /** 系统配置**/
    system: {
        title: "系统配置",
        role: "ROLE_APP_ODP5_CUSTOM_SYSTEM",
        children: {
            sdkVersion: {
                title: "SDK版本管理",
                url: "sdkversion.html",
                active: "sdkVersion",
                role: "ROLE_APP_ODP5_CUSTOM_SYSTEM_SDK"
                // 'userSetting': {
                //     title: '用户管理',
                //     url: 'usersetting.html',
                //     active: 'userSetting',
                //     role: 'ROLE_APP_ODP5_CUSTOM_SYSTEM_USER_SETTING'
                // },
            } }
    },

    index: {
        title: "首页",
        url: "index.html",
        active: "index",
        icon: "el-icon-video-camera",
        role: ""
    },

    demo: {
        title: "公共功能展示",
        url: "demo.html",
        active: "demo",
        icon: "el-icon-video-camera",
        role: ""
    },

    /** 无权限访问页面**/
    noAccess: {
        title: "权限提示",
        url: "noaccess.html",
        active: "noAccess",
        role: "",
        icon: ""
    },
    /** 404访问页面**/
    notfind: {
        title: "404",
        url: "notfind.html",
        active: "notfind",
        icon: "",
        role: ""
    },
    /** 游戏信息配置**/
    gameConfig: {
        title: "游戏信息配置",
        icon: "icon-youxi1",
        role: "ROLE_APP_ODP5_CUSTOM_GAMEDEPLOY",
        projectType: 1,
        children: {
            baseInfo: {
                title: "基础信息配置",
                url: "baseinfo.html",
                active: "baseInfo",
                role: "ROLE_APP_ODP5_CUSTOM_GAMEDEPLOY_BASIC"
            },
            commonInfo: {
                title: "游戏参数配置",
                url: "commoninfo.html",
                active: "commonInfo",
                role: "ROLE_APP_ODP5_CUSTOM_GAMEDEPLOY_UNIVERSAL"
            },
            PackagePlanManager: {
                title: "包名计划管理",
                url: "packageplanmanager.html",
                active: "PackagePlanManager",
                role: "ROLE_APP_ODP5_CUSTOM_GAMEDEPLOY_PACKAGE"
            },
            server: {
                title: "服列表管理",
                url: "server.html",
                active: "server",
                role: "ROLE_APP_ODP5_CUSTOM_GAMEDEPLOY_SERVICE"
            },
            activityPageManager: {
                title: "活动页面管理",
                url: "activityPageManager.html",
                active: "activityPageManager",
                role: "ROLE_APP_ODP5_CUSTOM_GAMEDEPLOY_SERVICE"
            }
        }
    },

    /** SDK配置发行**/
    sdk: {
        title: "SDK配置发行",
        icon: "icon-SDKxiazai",
        projectType: 1,
        role: "ROLE_APP_ODP5_CUSTOM_SDK",
        children: {
            configList: {
                title: "SDK配置文件",
                url: "configlist.html",
                active: "configList",
                role: "ROLE_APP_ODP5_CUSTOM_SDK_BASIC"
            },
            configEdit: {
                title: "详情",
                url: "configedit.html",
                active: "configList",
                role: "ROLE_APP_ODP5_CUSTOM_SDK_BASIC"
            },
            releasesList: {
                title: "SDK版本发行",
                url: "releaseslist.html",
                active: "releasesList",
                role: "ROLE_APP_ODP5_CUSTOM_SDK_ISSUE"
            },
            releasesEdit: {
                title: "详情",
                url: "releasesedit.html",
                active: "releasesList",
                role: "ROLE_APP_ODP5_CUSTOM_SDK_ISSUE"
            },
            adjustToken: {
                title: "参数映射表",
                url: "adjusttoken.html",
                active: "adjustToken",
                role: "ROLE_APP_ODP5_CUSTOM_SDK_MAP"
            }
        }
    },

    /** CP参数导出**/
    cpArgExport: {
        title: "CP参数导出",
        url: "cpargexport.html",
        active: "cpArgExport",
        icon: "el-icon-s-operation",
        projectType: 1,
        role: "ROLE_APP_ODP5_CUSTOM_CPMAP"
    },

    /** 支付**/
    payPackageSetting: {
        title: "支付套餐配置",
        url: "paypackagesetting.html",
        active: "payPackageSetting",
        icon: "icon-pay1",
        projectType: 1,
        role: "ROLE_APP_ODP5_CUSTOM_PAY3"
    },

    /** 登陆风控管理**/
    riskManagement: {
        title: "登录风控管理",
        projectType: 1,
        role: "ROLE_APP_ODP5_CUSTOM_WINDCONTROL",
        icon: "el-icon-umbrella",
        children: {
            ipBlockView: {
                title: "IP风控管理",
                url: "ipblockview.html",
                active: "ipBlockView",
                role: "ROLE_APP_ODP5_CUSTOM_IPBLOCK"
            },
            ipBlock: {
                title: "IP风控管理",
                url: "ipblock.html",
                active: "ipBlockView",
                role: "ROLE_APP_ODP5_CUSTOM_IPBLOCK"
            },
            loginBan: {
                title: "登录封禁",
                url: "loginBan.html",
                active: "loginBan",
                role: "ROLE_APP_ODP5_CUSTOM_LOGINBAN"
            },
            autoBanSetting: {
                title: "自动封禁配置",
                url: "autoBanSetting.html",
                active: "autoBanSetting",
                role: "ROLE_APP_ODP5_CUSTOM_AUTOBANNEDSETTING"
            }
        }
    },

    /** 防沉迷管理**/
    antiAddiction: {
        title: "防沉迷管理",
        projectType: 1,
        role: "ROLE_APP_ODP5_CUSTOM_ANTIADDICTION",
        icon: "el-icon-time",
        children: {
            configuration: {
                title: "防沉迷规则配置",
                url: "configuration.html",
                active: "configuration",
                role: "ROLE_APP_ODP5_CUSTOM_ANTIADDICTION_CONFIGURATION"
            }
        }
    },

    /** 用户查询**/
    query: {
        title: "数据查询",
        icon: "icon-shujuchaxun",
        role: "ROLE_APP_ODP5_CUSTOM_VIEW",
        projectType: 2,
        children: {
            user: {
                title: "用户查询",
                url: "user.html",
                active: "user",
                role: "ROLE_APP_ODP5_CUSTOM_VIEW_USER"
            },
            /* 'reg': {
                title: '注册查询',
                url: 'reg.html',
                active: 'reg',
                role: 'ROLE_APP_ODP5_CUSTOM_VIEW_LOGIN',
            }, */
            loginList: {
                title: "登录查询",
                url: "loginList.html",
                active: "loginList",
                role: "ROLE_APP_ODP5_CUSTOM_VIEW_LOGINLIST"
            },
            terminal: {
                title: "设备查询",
                url: "terminal.html",
                active: "terminal",
                role: "ROLE_APP_ODP5_CUSTOM_VIEW_DEVICE"
            },
            pay: {
                title: "充值日志",
                url: "pay.html",
                active: "pay",
                role: "ROLE_APP_ODP5_CUSTOM_VIEW_PAY"
            },
            activityOrderList: {
                title: "活动订单查询",
                url: "activityOrderList.html",
                active: "activityOrderList",
                role: "ROLE_APP_ODP5_CUSTOM_VIEW_ACTIVEORDER"
            },
            activityOrderDetail: {
                title: "活动订单详情",
                url: "activityOrderDetail.html",
                active: "activityOrderList"
            },
            activityOrderResend: {
                title: "活动订单补发",
                url: "activityOrderResend.html",
                active: "activityOrderResend",
                role: "ROLE_APP_ODP5_CUSTOM_VIEW_REISSUEORDER"
            },
            sdkReleaseRecord: {
                title: "SDK发行统计",
                url: "sdkReleaseRecord.html",
                active: "sdkReleaseRecord",
                role: "ROLE_APP_ODP5_CUSTOM_SDK_VERSIONS_ANALYSIS"
            }
        }
    },

    /** 用户查询**/
    watch: {
        title: "数据监控",
        icon: "icon-jiankong",
        projectType: 2,
        role: "ROLE_APP_ODP5_CUSTOM_MONITOR",
        children: {
            attendence: {
                title: "打卡记录",
                url: "attendence.html",
                active: "attendence",
                role: "ROLE_APP_ODP5_CUSTOM_MONITOR_CHECKIN"
            },
            line: {
                title: "报警曲线",
                url: "line.html",
                active: "line",
                role: "ROLE_APP_ODP5_CUSTOM_MONITOR_ALARM"
            },
            alarmPolicy: {
                title: "报警策略配置",
                url: "alarmpolicy.html",
                active: "alarmPolicy",
                role: "ROLE_APP_ODP5_CUSTOM_MONITOR_RULE"
            },
            alarmGroup: {
                title: "报警群组配置",
                url: "alarmgroup.html",
                active: "alarmGroup",
                role: "ROLE_APP_ODP5_CUSTOM_MONITOR_GROUP"
            }
        }
    },

    /** 游戏运营**/
    push: {
        title: "游戏运营",
        icon: "icon-yunying",
        projectType: 2,
        role: "ROLE_APP_ODP5_CUSTOM_OPERATION",
        children: {
            PushPlanManager: {
                title: "推送方案管理",
                url: "pushplanmanager.html",
                active: "PushPlanManager",
                role: "ROLE_APP_ODP5_CUSTOM_OPERATION_PUSH"
            },
            PushPlanDetail: {
                title: "推送方案详情",
                url: "pushplandetail.html",
                active: "PushPlanManager",
                role: "ROLE_APP_ODP5_CUSTOM_OPERATION_PUSH"
            },
            PushPlan: {
                title: "消息推送管理",
                url: "pushplan.html",
                active: "PushPlan",
                role: "ROLE_APP_ODP5_CUSTOM_IN_APP_MESSAGE_MANAGEMENT"
            },
            PushPlanOperate: {
                title: "应用消息推送",
                url: "pushplanoperate.html",
                active: "PushPlan",
                role: "ROLE_APP_ODP5_CUSTOM_IN_APP_MESSAGE_MANAGEMENT"
            },
            ces: {
                title: "内容配置管理",
                url: "ces.html",
                active: "ces",
                role: "ROLE_APP_ODP5_CUSTOM_OPERATION_CONCENT"
            },
            serverListManager: {
                title: "服列表管理",
                url: "serverlistmanager.html",
                active: "serverListManager",
                jumpToRoute: "gameConfig/server",
                role: "ROLE_APP_ODP5_CUSTOM_OPERATION_CONCENT"
            }
        }
    },
    /** 充值码管理**/
    recharge: {
        title: "充值码管理",
        icon: "icon-pay",
        projectType: 2,
        role: "ROLE_APP_ODP5_CUSTOM_RECHARGECODE",
        children: {
            rechargeCodeList: {
                title: "自生成充值码",
                url: "rechargecodelist.html",
                active: "rechargeCodeList"
            },
            pushRechargeCodeList: {
                title: "CP充值码导入",
                url: "pushrechargecodelist.html",
                active: "pushRechargeCodeList"
            },
            createRechargeCode: {
                title: "新增",
                url: "createrechargecode.html",
                active: "rechargeCodeList"
            },
            pushRechargeCode: {
                title: "新增",
                url: "pushrechargecode.html",
                active: "pushRechargeCodeList"
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "pDqk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/background_color.aee35da.jpeg";

/***/ }),

/***/ "pHxA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/licence_show_type_merge.d50eac1.png";

/***/ }),

/***/ "pS/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subComponents_sdkUpload__ = __webpack_require__("uhd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_DiyTitle_vue__ = __webpack_require__("9yFh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'set-login-allowed',
    components: {
        upload: __WEBPACK_IMPORTED_MODULE_3__subComponents_sdkUpload__["a" /* default */],
        DiyTitle: __WEBPACK_IMPORTED_MODULE_4__style_DiyTitle_vue__["a" /* default */]
    },
    data: function data() {
        return {
            activeName: 'landscape',
            platform: '',
            activeUrl: '',
            params: {
                style: {
                    personal_center_background: '',
                    custom_personal_center_style_allowed: true,
                    appearance: '',
                    default_colors: this.initStyleColors(),
                    diy_colors: {},
                    custom_page_style_allowed: false
                },
                diy_colors: {
                    title_1: '',
                    background_color: '',
                    background_color_of_content: '',
                    color_of_button: '',
                    highlight_background_color: ''
                },
                step: 'style'
            },
            personalCenterDefaultDialogVisible: false,
            styleDialogVisible: false
        };
    },

    props: ['isDetail', 'isCopy', 'labelWidth'],
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['$helper', '$lodash']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])("sdkReleasesEdit", ["gameVersion", "packageList", "packageStoreList", "sdkVersion", "data"]), {
        isIOS: function isIOS() {
            return this.platform === 'IOS';
        },
        backgroundContentColor: function backgroundContentColor() {
            return {
                backgroundColor: this.params.diy_colors.background_color_of_content
            };
        },
        defaultLandscapeUrl: function defaultLandscapeUrl() {
            var Urls = {
                dark: {
                    iosUrl: __webpack_require__("CQ4N"),
                    androidUrl: __webpack_require__("u+YQ")
                },
                light: {
                    iosUrl: __webpack_require__("CNxV"),
                    androidUrl: __webpack_require__("Fedn")
                }
            };
            return this.isIOS ? Urls[this.params.style.appearance].iosUrl : Urls[this.params.style.appearance].androidUrl;
        },
        defaultPortraitUrl: function defaultPortraitUrl() {
            var Urls = {
                dark: {
                    iosUrl: __webpack_require__("Yaey"),
                    androidUrl: __webpack_require__("fb+S")
                },
                light: {
                    iosUrl: __webpack_require__("Jp+H"),
                    androidUrl: __webpack_require__("v6+Z")
                }
            };
            return this.isIOS ? Urls[this.params.style.appearance].iosUrl : Urls[this.params.style.appearance].androidUrl;
        }
    }),
    watch: {
        'data.style': function dataStyle() {
            this.params.style = this.$lodash.cloneDeep(this.data.style);
            this.params.step = 'style';
            this.handlerDefaultStyle();
        },
        "params.style.personal_center_background": function paramsStylePersonal_center_background(val) {
            if (val) {
                this.$refs['form'].clearValidate('personal_center_background');
            }
        }
    },
    methods: {
        handlerOverCurrentBackground: function handlerOverCurrentBackground(e) {
            e.target.style.backgroundColor = this.params.diy_colors.highlight_background_color;
        },
        handlerOutCurrentBackground: function handlerOutCurrentBackground(e) {
            e.target.style.backgroundColor = this.params.diy_colors.background_color_of_content;
        },
        randerTaps: function randerTaps() {
            return {
                tap1: [{
                    text: '账号绑定',
                    url: __webpack_require__("5u7H")
                }, {
                    text: '切换账号',
                    url: __webpack_require__("8Tb4")
                }, {
                    text: '修改密码',
                    url: __webpack_require__("edJP")
                }],
                tap2: [{
                    text: '充值记录',
                    url: __webpack_require__("WNVH")
                }, {
                    text: '礼包兑换',
                    url: __webpack_require__("B1dP")
                }],
                tap3: [{
                    text: '客服中心',
                    url: __webpack_require__("wlhV")
                }, {
                    text: '论坛',
                    url: __webpack_require__("IIXg")
                }]
            };
        },
        initStyleColors: function initStyleColors() {
            return {
                dark: {
                    title_1: '#FFFFFF',
                    background_color: '#111111',
                    background_color_of_content: '#202020',
                    color_of_button: '#1765AD',
                    highlight_background_color: '#303030'
                },
                light: {
                    title_1: '#111111',
                    background_color: '#F6F6F6',
                    background_color_of_content: '#FEFEFE',
                    color_of_button: '#177DDC',
                    highlight_background_color: '#E9E9E9'
                }
            };
        },
        currentUrl: function currentUrl(key) {
            var urls = {
                title_1: __webpack_require__("s5Kw"),
                background_color: __webpack_require__("pDqk"),
                background_color_of_content: __webpack_require__("zfo0"),
                color_of_button: __webpack_require__("Tg3l"),
                highlight_background_color: __webpack_require__("MTjC")
            };
            return urls[key];
        },
        handlerDefaultStyle: function handlerDefaultStyle() {
            if (this.params.style.custom_page_style_allowed && typeof this.params.style.diy_colors[this.params.style.appearance] !== 'undefined') {
                this.params.diy_colors = this.$lodash.cloneDeep(this.params.style.diy_colors[this.params.style.appearance]);
            } else {
                this.params.diy_colors = this.$lodash.cloneDeep(this.params.style.default_colors[this.params.style.appearance]);
            }
        },
        handlerPreview: function handlerPreview(key) {
            this.activeUrl = this.currentUrl(key);
            this.styleDialogVisible = true;
        },
        handleTemplateReview: function handleTemplateReview() {
            this.uploadViewDialogVisible = true;
        },
        handleCustomStyleAllowed: function handleCustomStyleAllowed(checked) {
            if (!checked) {
                this.params.style.personal_center_background = '';
            }
        },
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    if (_this.params.style.custom_page_style_allowed) {
                        _this.params.style.diy_colors = _this.$lodash.cloneDeep(_this.initStyleColors());
                        _this.params.style.diy_colors[_this.params.style.appearance] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.params.diy_colors);
                    } else {
                        _this.params.style.diy_colors = {};
                    }
                    _this.$emit('submit', _this.params, _this.isIOS ? 5 : 'save');
                }
            });
        }
    },
    created: function created() {
        this.platform = this.$helper.helper.getParamers("platform");
    }
});

/***/ }),

/***/ "qkxf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qzhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    data: {},
    users: [],
    detailData: {}
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    create: function create(_ref, args) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var URL = rootState.$config.api.push_plans_news;
        URL = URL.replace('{game_code}', rootState.$activeGameCode);
        return rootState.$helper.request.put(URL, args).then(function (res) {
            commit('updateData', res.data.created);
            return res.data;
        });
    },
    getPlansTimeList: function getPlansTimeList(_ref2, args) {
        var dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var URL = rootState.$config.api.push_get_plans_times;
        return rootState.$helper.request.get(URL, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, args)).then(function (res) {
            return res.data;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    getPlatformConfig: function getPlatformConfig(_ref3, platForm) {
        var dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var URL = rootState.$config.api.push_get_os_platform_config;
        return rootState.$helper.request.get(URL, { platform: platForm }).then(function (res) {
            return res.data;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    getAllUsers: function getAllUsers(_ref4, args) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var URL = rootState.$config.api.push_get_all_users;
        return rootState.$helper.request.get(URL, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, args)).then(function (res) {
            commit('updateUsers', res.data.list);
            return true;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    getDetail: function getDetail(_ref5, args) {
        var commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        var URL = rootState.$config.api.push_get_plans_detail;
        commit("PRIVATE_LOADING", true, { root: true });
        return rootState.$helper.request.get(URL, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, args)).then(function (res) {
            commit('updateData', res.data.list[0]);
            commit('updateDetailData', res.data.list[0]);
            commit("PRIVATE_LOADING", false, { root: true });
            return true;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
            commit("PRIVATE_LOADING", false, { root: true });
        });
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    updateData: function updateData(state, data) {
        state.data = data;
    },
    updateDetailData: function updateDetailData(state, data) {
        state.detailData = data;
    },
    updateUsers: function updateUsers(state, data) {
        state.users = data;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "rMe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdk-dimension-container"},[_c('el-form',{ref:"form",attrs:{"model":_vm.params.payment,"label-width":_vm.labelWidth}},[(!_vm.isSdkVersion5_6)?[_c('el-form-item',{attrs:{"label":"游戏内充值："}},[_c('el-radio-group',{on:{"change":_vm.changeChargeButtonAllowed},model:{value:(_vm.params.payment.charge_button_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "charge_button_allowed", $$v)},expression:"params.payment.charge_button_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"隐藏所有三方渠道："}},[_c('el-radio-group',{model:{value:(_vm.params.payment.apf_safe_mode),callback:function ($$v) {_vm.$set(_vm.params.payment, "apf_safe_mode", $$v)},expression:"params.payment.apf_safe_mode"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1),_vm._v(" "),(_vm.params.payment.charge_button_allowed)?_c('el-form-item',{attrs:{"label":"游戏内充值渠道："}},[_c('el-checkbox',{model:{value:(_vm.params.payment.quick_charge_google_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "quick_charge_google_allowed", $$v)},expression:"params.payment.quick_charge_google_allowed"}},[_vm._v("官方渠道")]),_vm._v(" "),(_vm.platform !== 'H5')?_c('el-checkbox',{on:{"change":_vm.changeThirdpartyAllowed},model:{value:(_vm.params.payment.quick_charge_thirdparty_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "quick_charge_thirdparty_allowed", $$v)},expression:"params.payment.quick_charge_thirdparty_allowed"}},[_vm._v("第三方渠道\n                ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"渠道按国家过滤："}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"[开启] 选项含义: 如果有当前国家渠道，则只展示当前国家渠道，若没有则展示美国渠道","placement":"top-start"}},[_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"-17px"}})]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.params.payment.filter_channel_with_geo_country),callback:function ($$v) {_vm.$set(_vm.params.payment, "filter_channel_with_geo_country", $$v)},expression:"params.payment.filter_channel_with_geo_country"}},[_c('el-radio',{attrs:{"label":"no"}},[_vm._v("关闭")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"yes"}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"yes-with-us"}},[_vm._v("开启&一定含美国(US)")])],1)],1),_vm._v(" "),(_vm.platform !== 'H5')?_c('el-form-item',{attrs:{"label":"提审充值："}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"用于提审阶段的充值功能，开启该功能，提审人员使用测试渠道下单，无需走支付流程即可支付成功。","placement":"top-start"}},[_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"-17px"}})]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.params.payment.submit_recharge_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "submit_recharge_allowed", $$v)},expression:"params.payment.submit_recharge_allowed"}},[_c('el-radio',{attrs:{"label":true,"disabled":_vm.submitRechargeAllowedDisabled}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false,"disabled":_vm.submitRechargeAllowedDisabled}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.params.payment.quick_charge_thirdparty_allowed && 0)?_c('el-form-item',{attrs:{"label":"第三方支付页面风格："}},[_c('el-radio-group',{on:{"change":_vm.changeChargeThirdpartyPageStyle},model:{value:(_vm.params.payment.charge_thirdparty_page_style),callback:function ($$v) {_vm.$set(_vm.params.payment, "charge_thirdparty_page_style", $$v)},expression:"params.payment.charge_thirdparty_page_style"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v("默认模版")]),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('third_pay_page_default_style')}}}),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v("Google指定模版")]),_vm._v(" "),_c('em',{staticClass:"el-icon-view icon-view",staticStyle:{"left":"390px"},on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview('third_pay_page_google_style')}}})],1)],1):_vm._e(),_vm._v(" "),(
                    _vm.params.payment.quick_charge_thirdparty_allowed &&
                        _vm.params.payment.charge_thirdparty_page_style
                )?_c('el-form-item',{attrs:{"label":"游戏支付方式图片："}},[_c('div',{staticClass:"dialog-upload-btn-box"},[_c('div',{staticClass:"upload-imgs"},[_c('el-form-item',{attrs:{"label-width":"0"}},[_c('upload',{attrs:{"formatlimit":"png"},model:{value:(
                                    _vm.params.payment.game_payment_method_image
                                ),callback:function ($$v) {_vm.$set(_vm.params.payment, "game_payment_method_image", $$v)},expression:"\n                                    params.payment.game_payment_method_image\n                                "}}),_vm._v(" "),_c('div',[_c('span',{staticClass:"href-rela",on:{"click":function($event){$event.stopPropagation();return _vm.handlerPreview(
                                            'pay_page_sample_and_size'
                                        )}}},[_vm._v("示例及尺寸要求")])])],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.params.payment.charge_button_allowed)?_c('el-form-item',{attrs:{"label":"游戏是否开启APF:"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"如果开启了APF，即使'第三方渠道'处于关闭状态，也可以返回所有代金券套餐","placement":"top-start"}},[_c('i',{staticClass:"el-icon-question",staticStyle:{"margin-left":"-17px"}})]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.params.payment.apf_enabled),callback:function ($$v) {_vm.$set(_vm.params.payment, "apf_enabled", $$v)},expression:"params.payment.apf_enabled"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1):_vm._e(),_vm._v(" "),(_vm.params.payment.apf_enabled)?_c('el-form-item',{attrs:{"label":"APF 打开风格:"}},[_c('el-radio-group',{model:{value:(_vm.params.payment.apf_ux_style),callback:function ($$v) {_vm.$set(_vm.params.payment, "apf_ux_style", $$v)},expression:"params.payment.apf_ux_style"}},[_c('el-radio',{attrs:{"label":"bottom-drawer"}},[_vm._v("游戏内底部抽屉")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"in-app-webview"}},[_vm._v("游戏内全屏")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"external-webview"}},[_vm._v("跳出的全屏弹窗")])],1)],1):_vm._e(),_vm._v(" "),(_vm.params.payment.apf_enabled)?_c('el-form-item',{attrs:{"label":"外跳支付页面地址："}},[_c('el-input',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"normal"},model:{value:(_vm.params.payment.apf_external_webview_url),callback:function ($$v) {_vm.$set(_vm.params.payment, "apf_external_webview_url", $$v)},expression:"params.payment.apf_external_webview_url"}})],1):_vm._e(),_vm._v(" "),(_vm.params.payment.apf_enabled)?_c('el-form-item',{attrs:{"label":"历史总充值达："}},[_c('el-input-number',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","min":0,"precision":0,"controls":false},model:{value:(_vm.params.payment.apf_min_history_topup),callback:function ($$v) {_vm.$set(_vm.params.payment, "apf_min_history_topup", $$v)},expression:"params.payment.apf_min_history_topup"}}),_vm._v("\n                (美分)才能开启APF\n            ")],1):_vm._e(),_vm._v(" "),(_vm.params.payment.apf_enabled)?_c('el-form-item',{attrs:{"label":"历史总充值达："}},[_c('el-input-number',{staticClass:"sdkconfigedit-formitem-width",attrs:{"size":"small","min":0,"precision":0,"controls":false},model:{value:(_vm.params.payment.apf_min_topup_times),callback:function ($$v) {_vm.$set(_vm.params.payment, "apf_min_topup_times", $$v)},expression:"params.payment.apf_min_topup_times"}}),_vm._v("\n                (笔)订单才能开启APF\n            ")],1):_vm._e()]:[_c('el-form-item',{attrs:{"label":"OG充值："}},[_c('el-radio-group',{model:{value:(_vm.params.payment.charge_button_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "charge_button_allowed", $$v)},expression:"params.payment.charge_button_allowed"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("开启")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("关闭")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"游戏内充值渠道："}},[_c('el-checkbox',{model:{value:(_vm.params.payment.quick_charge_google_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "quick_charge_google_allowed", $$v)},expression:"params.payment.quick_charge_google_allowed"}},[_vm._v("官方渠道")]),_vm._v(" "),_c('el-checkbox',{model:{value:(_vm.params.payment.quick_charge_thirdparty_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "quick_charge_thirdparty_allowed", $$v)},expression:"params.payment.quick_charge_thirdparty_allowed"}},[_vm._v("第三方渠道")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"SDK充值："}},[_c('el-checkbox',{model:{value:(_vm.params.payment.manual_charge_google_allowed),callback:function ($$v) {_vm.$set(_vm.params.payment, "manual_charge_google_allowed", $$v)},expression:"params.payment.manual_charge_google_allowed"}},[_vm._v("谷歌渠道展示")]),_vm._v(" "),_c('el-checkbox',{model:{value:(
                        _vm.params.payment.manual_charge_thirdparty_allowed
                    ),callback:function ($$v) {_vm.$set(_vm.params.payment, "manual_charge_thirdparty_allowed", $$v)},expression:"\n                        params.payment.manual_charge_thirdparty_allowed\n                    "}},[_vm._v("第三方渠道展示")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"页面设置："}},[_c('el-radio-group',{model:{value:(_vm.params.payment.charge_display_type),callback:function ($$v) {_vm.$set(_vm.params.payment, "charge_display_type", $$v)},expression:"params.payment.charge_display_type"}},[_c('el-radio',{attrs:{"label":true}},[_vm._v("套餐>渠道")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v("渠道>套餐")])],1)],1)],_vm._v(" "),_c('el-form-item',[(!_vm.isDetail)?_c('el-button',{staticClass:"next-button",attrs:{"type":"primary","size":"small"},on:{"click":_vm.handlerNext}},[_vm._v("\n                "+_vm._s(_vm.isSave)+"\n            ")]):_vm._e()],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"预览","visible":_vm.styleDialogVisible,"width":"1200px"},on:{"update:visible":function($event){_vm.styleDialogVisible=$event}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("\n                预览\n                "),_c('span',{staticStyle:{"color":"#F56C6C"}},[_vm._v("（该图片仅用来示意在界面中的显示位置，不代表真实效果。）")])])]),_vm._v(" "),_c('img',{attrs:{"src":_vm.activeUrl,"alt":"","width":"1160"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rpMM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    demoList: [],
    demoStatus: false
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    DEMO_ACTIONS: function DEMO_ACTIONS(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        console.log('DEMO_ACTIONS=>', args, rootState);
        var data = [{ id: 1, data: 'aata1' }, { id: 2, data: 'aata2' }, { id: 3, data: 'aata3' }];
        commit('_updateDemoList', data);
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {
    GET_DEMO_GETTER: function GET_DEMO_GETTER(state, getters) {
        var data = getters.getDemoGetterOthr;
        state.demoList = state.demoList.concat(data);
        return state.demoList;
    },
    getDemoGetterOthr: function getDemoGetterOthr(state, getters) {
        return [{ id: 4, data: 'aata4' }];
    }
};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _updateDemoList: function _updateDemoList(state, args) {
        state.demoList = args;
        console.log(state.demoList);
    },


    /**
     * 对外的方法
     * @param state
     * @param args
     * @constructor
     */
    DEMO_MUTATIONS: function DEMO_MUTATIONS(state, args) {
        state.demoStatus = args;
        console.log(state.demoStatus);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "rvp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    packageUrl: ''
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_PACKAGE_TOKEN: function GET_PACKAGE_TOKEN(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var pay_package_token = rootState.$helper.cookie.get('pay_package_token_' + gameCode);
        if (_.isEmpty(pay_package_token)) {
            var url = rootState.$config.api.plugin.package_token;

            url = _.replace(url, '{game_code}', gameCode);
            rootState.$helper.request.get(url, '').then(function (data) {
                commit('PRIVATE_LOADING', false, { root: true });
                pay_package_token = data.data.access_token;
                if (typeof pay_package_token === 'undefined') {
                    pay_package_token = '';
                }
                rootState.$helper.cookie.set('pay_package_token_' + gameCode, pay_package_token, { 'expires': 5 });
                var finalUrl = rootState.$config.pay_package_url + "?token=" + pay_package_token;
                commit('_setPackageToken', finalUrl);
            }).catch(function (res) {
                dispatch('ERROR_HANDLE', res, { root: true });
                commit('PRIVATE_LOADING', false, { root: true });
            });
        } else {
            var finalUrl = rootState.$config.pay_package_url + "?token=" + pay_package_token;
            commit('_setPackageToken', finalUrl);
        }
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _setPackageToken: function _setPackageToken(state, args) {
        state.packageUrl = args;
        console.log(state.packageUrl);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "s2HP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var groupsButtonText = ['OS', '包名', 'SDK版本', '语言', '国家', '游戏版本', '注册时间（天）', '最后登录时间（天）'];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'devive-filter',
    data: function data() {
        return {
            activeName: 'user',
            pushDeviceFilterForm: {
                os: ''
            },
            groupOptions: this.initGroupOptions(),
            platformConfig: {},
            marks: {
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%'
            },
            userPositionFormItems: [{
                label: 'OS',
                key: 'os',
                options: [{
                    label: 'Android',
                    value: 'android'
                }, {
                    label: 'IOS',
                    value: 'ios'
                }],
                checked: false
            }, {
                label: '包名',
                key: 'package_id',
                options: [],
                checked: false
            }, {
                label: 'SDK版本',
                key: 'sdk_version_id',
                options: [],
                checked: false
            }, {
                label: '语言',
                key: 'lang',
                options: [],
                checked: false
            }, {
                label: '国家',
                key: 'country',
                options: [],
                checked: false
            }, {
                label: '游戏版本',
                key: 'game_version_id',
                options: [],
                checked: false
            }, {
                label: '注册时间（天）',
                key: 'reg_date',
                options: [{
                    label: 'com1',
                    value: 'com1'
                }, {
                    label: 'com77',
                    value: 'com77'
                }],
                checked: false
            }, {
                label: '最后登录时间（天）',
                key: 'last_login_date',
                options: [{
                    label: 'com88',
                    value: 'com88'
                }, {
                    label: 'com99',
                    value: 'com99'
                }],
                checked: false
            }]
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('pushPushPlanOperate', ['data', 'detailData']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['$activeGameInfo', '$lodash'])),
    props: ['isDetail', 'isCopy'],
    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('pushPushPlanOperate', ['getPlatformConfig', 'getCountry']), {
        initGroupOptions: function initGroupOptions() {
            var options = [];
            groupsButtonText.forEach(function (name) {
                options.push({
                    checked: false,
                    label: name
                });
            });
            return options;
        },
        handlerNext: function handlerNext() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    for (var key in _this.pushDeviceFilterForm) {
                        if (key !== 'os') {
                            console.log(_this.pushDeviceFilterForm);
                            if (['reg_date', 'last_login_date'].includes(key) && typeof _this.pushDeviceFilterForm[key][1] === 'number') {
                                if (typeof _this.pushDeviceFilterForm[key][0] === 'number' && _this.pushDeviceFilterForm[key][1] < _this.pushDeviceFilterForm[key][0]) {
                                    _this.$alert('保存失败，时间维度最大值必须大于最小值！');
                                    return;
                                }
                            }
                        }
                    }
                    _this.$emit('submit', _this.pushDeviceFilterForm, 1);
                }
            });
        },
        handlerDimension: function handlerDimension(row, index) {
            var _this2 = this;

            if (this.isDetail || row.label === 'OS') return;
            if (typeof index === 'number') {
                this.groupOptions[index].checked = !row.checked;
            }
            row.checked = !row.checked;
            this.userPositionFormItems.forEach(function (item) {
                if (item.label === row.label) {
                    item.checked = row.checked;
                    if (row.checked) {
                        var initVal = ['future_7days_lose', 'future_7days_pay'].includes(item.key) ? [75, 100] : [];
                        _this2.$set(_this2.pushDeviceFilterForm, item.key, initVal);
                    } else {
                        delete _this2.pushDeviceFilterForm[item.key];
                    }
                    setTimeout(function () {
                        _this2.$refs['form'].clearValidate(item.key);
                    }, 0);
                }
            });
        },
        filterCountry: function filterCountry(kwd, row) {
            var options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.country_list.filter(function (item) {
                    var names = [item.code2, item.code3, item.continent, item.name, item.name_cn].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            } else {
                options = _.cloneDeep(this.platformConfig.country_list);
            }
            row.options = options.map(function (list) {
                return {
                    label: list.name_cn,
                    value: list.name
                };
            });
        },
        filterPackage: function filterPackage(kwd, row) {
            var options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.package_list.filter(function (item) {
                    var names = [item.package_name, item.package_id].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            } else {
                options = _.cloneDeep(this.platformConfig.package_list);
            }
            row.options = options.map(function (list) {
                return {
                    label: list.package_name,
                    value: list.package_id
                };
            });
        },
        filterSDKVersion: function filterSDKVersion(kwd, row) {
            var options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.sdkversion_list.filter(function (item) {
                    var names = [item.sdk_version, item.sdk_version_id].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            } else {
                options = _.cloneDeep(this.platformConfig.sdkversion_list);
            }
            row.options = options.map(function (list) {
                return {
                    label: list.sdk_version,
                    value: list.sdk_version_id
                };
            });
        },
        filterGameVersion: function filterGameVersion(kwd, row) {
            var options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.platformConfig.gameversion_list.filter(function (item) {
                    var names = [item.game_version_id, item.game_version].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            } else {
                options = _.cloneDeep(this.platformConfig.gameversion_list);
            }
            row.options = options.map(function (list) {
                return {
                    label: list.game_version,
                    value: list.game_version_id
                };
            });
        },
        filterLang: function filterLang(kwd, row) {
            var options = [];
            if (typeof kwd === 'string' && kwd) {
                options = this.$activeGameInfo.lang.filter(function (item) {
                    var names = [item.local_name, item.full_code, item.name, item.full_code.toUpperCase()].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                });
            } else {
                options = _.cloneDeep(this.$activeGameInfo.lang);
            }
            row.options = options.map(function (list) {
                return {
                    label: list.name,
                    value: list.full_code
                };
            });
        },
        filterData: function filterData(kwd, row) {
            switch (row.key) {
                case 'country':
                    this.filterCountry(kwd, row);
                    break;
                case 'package_id':
                    this.filterPackage(kwd, row);
                    break;
                case 'game_version_id':
                    this.filterGameVersion(kwd, row);
                    break;
                case 'sdk_version_id':
                    this.filterSDKVersion(kwd, row);
                    break;
                case 'lang':
                    this.filterLang(kwd, row);
                    break;
            }
        }
    }),
    watch: {
        'pushDeviceFilterForm.os': function pushDeviceFilterFormOs(event) {
            var _this3 = this;

            if (event) {
                this.getPlatformConfig(event).then(function (res) {
                    _this3.platformConfig = res.result;
                });
            }
        },

        data: {
            handler: function handler() {
                var _this4 = this;

                this.pushDeviceFilterForm = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.data.conditions).length ? this.$lodash.cloneDeep(this.data.conditions) : this.pushDeviceFilterForm;
                var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.pushDeviceFilterForm);
                for (var key in this.pushDeviceFilterForm) {
                    if (typeof this.pushDeviceFilterForm[key] === 'string' && key !== 'os') {
                        this.pushDeviceFilterForm[key] = this.pushDeviceFilterForm[key].split(',');
                        if (['reg_date', 'last_login_date'].includes(key)) {
                            this.pushDeviceFilterForm[key] = this.pushDeviceFilterForm[key].map(function (item) {
                                return item || undefined;
                            });
                        }
                    }
                }
                this.userPositionFormItems.forEach(function (item) {
                    if (keys.indexOf(item.key) > -1) {
                        item.checked = true;
                        _this4.groupOptions.forEach(function (keys) {
                            if (keys.label === item.label) {
                                keys.checked = true;
                            }
                        });
                    }
                });
            },

            deep: true
        },
        platformConfig: {
            handler: function handler(val) {
                var _this5 = this;

                this.userPositionFormItems.forEach(function (item) {
                    if (item.key === 'package_id') {
                        item.options = val.package_list.map(function (list) {
                            return {
                                label: list.package_name,
                                value: list.package_id
                            };
                        });
                    }
                    if (item.key === 'game_version_id') {
                        item.options = val.gameversion_list.map(function (list) {
                            return {
                                label: list.game_version,
                                value: list.game_version_id
                            };
                        });
                    }
                    if (item.key === 'sdk_version_id') {
                        item.options = val.sdkversion_list.map(function (list) {
                            return {
                                label: list.sdk_version,
                                value: list.sdk_version_id
                            };
                        });
                    }
                    if (item.key === 'country') {
                        item.options = val.country_list.map(function (list) {
                            return {
                                label: list.name_cn,
                                value: list.name
                            };
                        });
                    }
                    if (item.key === 'lang') {
                        item.options = _this5.$activeGameInfo.lang.map(function (list) {
                            return {
                                label: list.name,
                                value: list.full_code
                            };
                        });
                    }
                });
            },

            deep: true
        }
    }
});

/***/ }),

/***/ "s5Kw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/title1.dc7ff2d.jpeg";

/***/ }),

/***/ "t0sm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "tCok":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tymY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"placeholder":_vm.placeholder,"type":_vm.type,"rows":_vm.rows,"size":_vm.size,"disabled":_vm.disabled},on:{"blur":_vm.trimValue},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.keyUpEnter($event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._t("default",null,{"slot":"append"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tz4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "u+YQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/android-landscape1.a760bdc.png";

/***/ }),

/***/ "uEHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleSearchData_vue__ = __webpack_require__("dpKb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a3bd3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleSearchData_vue__ = __webpack_require__("SiJ5");
function injectStyle (ssrContext) {
  __webpack_require__("R19o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00a3bd3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleSearchData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a3bd3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleSearchData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uK2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushTimes_vue__ = __webpack_require__("LBD4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e38440d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushTimes_vue__ = __webpack_require__("l29D");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PushTimes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e38440d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PushTimes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uOBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subComponents_sdkUpload__ = __webpack_require__("uhd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__antiAddiction_configuration__ = __webpack_require__("wlS+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var urlKeys = {
    fb_share_button_allowed: 'facebook_sharing_url',
    vk_share_button_allowed: 'vk_sharing_url',
    twitter_share_button_allowed: 'twitter_sharing_url'
};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'set-content-allowed',
    components: {
        configuration: __WEBPACK_IMPORTED_MODULE_4__antiAddiction_configuration__["a" /* default */],
        upload: __WEBPACK_IMPORTED_MODULE_3__subComponents_sdkUpload__["a" /* default */]
    },
    data: function data() {
        var checkUrl = function checkUrl(rule, value, callback) {
            console.log("checkurl.............", value, typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value));
            if (typeof value !== "undefined") {
                if (/^https:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/.test(value) === false) {
                    console.log("请输入正确的Url");
                    callback(new Error('请输入正确的Url'));
                } else {
                    callback();
                }
            } else {
                callback(new Error('请输入正确的Url'));
            }
        };
        return {
            login_buttons_check_all: '',
            antiAddictionVisible: false,
            isIndeterminate: false,
            operate_type: '',
            isShowQuestionnaireUrl: false,
            isShowImageUploadAllowed: true,
            isShowLoginHistoryAllowed: true,
            isVersion5x: false,
            version: '',
            udp_domain: '',
            networkName: '',
            tracerouteHint: '',
            platform: '',
            params: {
                user_center_alloweds: [],
                admob_allowed: '',
                forum_allowed: [],
                is_anti_addiction_turn_on: false,
                eu_consent_allowed: true,
                dynamic_terms: '',
                image_upload_allowed: false,
                appsflyer_allowed: true,
                appsflyer_wait_for_idfa_time: '',
                country_age_constrains_config: '',
                play_game_service_achievements_allowed: false,
                game_center_achievements_allowed: false,
                share: [],
                share_url: {},
                facebook_sharing_url: '',
                vk_sharing_url: '',
                twitter_sharing_url: '',
                ping_stats_collection_allowed: false,
                ping_count: '',
                ping_frequency: '',
                trace_route_frequency: undefined,
                trace_route_domain_list: '',
                ping_domain_list: '',
                questionnaire_url: '',
                page_icon: "",
                page_right_background_image: "",
                page_left_background_image: "",
                step: 'feature',
                screenshot_share_allowed: false
            },
            urlLoding: false,
            rules: {
                facebook_sharing_url: [{
                    required: true, validator: checkUrl
                }],
                vk_sharing_url: [{
                    required: true, validator: checkUrl
                }],
                twitter_sharing_url: [{
                    required: true, validator: checkUrl
                }],
                appsflyer_wait_for_idfa_time: [{
                    required: true, message: ' '
                }],
                ping_count: [{
                    required: true, message: ' '
                }],
                ping_domain_list: [{
                    required: true, message: ' '
                }],
                ping_frequency: [{
                    required: true, message: ' '
                }],
                trace_route_domain_list: [{
                    required: true, message: ' '
                }],
                trace_route_frequency: [{
                    required: true, message: ' '
                }]
                // questionnaire_url: [{
                //     required: true, message: ' '
                // }],
            },
            userCenterMethods: [{
                label: 'OG按钮',
                key: 'og_button_allowed',
                content: 'OG图标的显示隐藏按钮'
            }, {
                label: '账号切换',
                key: 'account_switching_allowed',
                content: '玩家切换历史的登录账号',
                platform: "H5"
            }, {
                label: '历史账号',
                key: 'login_history_allowed',
                content: '在同一设备下登录过的账号列表',
                disabled: false,
                platform: "H5"
            }, {
                label: '账号安全',
                key: 'security_center_allowed',
                content: '用于密码找回，设置安全问题的功能'
            }, {
                label: '问卷',
                key: 'questionnaire',
                content: '开启调查问卷功能'
            }, {
                label: '客服',
                key: 'support_allowed',
                content: '客服答疑开关',
                platform: "H5"
            }, {
                label: 'epin兑换',
                key: 'charge_epin_allowed',
                content: '支付平台的渠道，类似于点卡，目前无使用',
                marginLeft: true
            }, {
                label: 'PC扫码登录',
                key: 'qr_code_allowed',
                content: 'SDK扫码登录，同步登录PC端登录'
            }]
        };
    },

    props: ['isDetail', 'isCopy', 'labelWidth'],
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['$config', '$helper', '$lodash']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])("sdkReleasesEdit", ["gameVersion", "packageList", "packageStoreList", "sdkVersion", "termsList", "data"]), {
        userCenterOptions: function userCenterOptions() {
            var _this = this;

            return this.userCenterMethods.filter(function (item, i) {
                if (_this.platform === "H5") {
                    return item.platform && item.platform === "H5";
                } else {
                    return true;
                }
            });
        }
    }),
    watch: {
        'data.feature': function dataFeature() {
            var _this2 = this;

            this.params = this.$lodash.cloneDeep(this.data.feature);
            this.params.step = 'feature';
            this.handleCheckedCitiesChange(this.params.user_center_alloweds);
            this.params.ping_domain_list = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.params.ping_domain_list) === 'object' ? this.params.ping_domain_list.join("\n") : this.params.ping_domain_list;
            this.params.trace_route_domain_list = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.params.trace_route_domain_list) === 'object' ? this.params.trace_route_domain_list.join("\n") : this.params.trace_route_domain_list;
            /* if(!this.params.ping_domain_list) {
                this.params.ping_domain_list = this.udp_domain + "\nhttps://www.facebook.com/\nhttps://www.google.com/";
            }
            if (!this.params.trace_route_domain_list) {
                this.params.trace_route_domain_list = this.udp_domain;
            } */
            if (this.params.ping_frequency) {
                this.params.ping_frequency = parseInt(this.params.ping_frequency / 60);
            }
            if (this.params.trace_route_frequency) {
                this.params.trace_route_frequency = parseInt(this.params.trace_route_frequency / 60);
            } else {
                this.params.trace_route_frequency = undefined;
            }
            console.log("feature。");
            console.log(this.params);
            setTimeout(function () {
                _this2.params.share.forEach(function (item) {
                    _this2.$set(_this2.params, [urlKeys[item]], _this2.params.share_url[urlKeys[item]]);
                });
            }, 300);
            this.params.forum_allowed = this.data.feature.forum_allowed.length > 1 ? [] : this.params.forum_allowed;
        },
        'data.query': function dataQuery(value) {
            var _this3 = this;

            var version = "";

            this.sdkVersion.forEach(function (item) {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            });
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
            console.log(this.version);
            this.networkName = this.showNetworkName();

            var versionStr = version.substr(0, 2);
            if (['6.', '5.'].includes(versionStr)) {
                this.isShowQuestionnaireUrl = true;
            }
            if (['7.', '8.'].includes(versionStr)) {
                this.isShowImageUploadAllowed = false;
                this.isShowLoginHistoryAllowed = false;
            }
            if (['5.'].includes(versionStr)) {
                this.isVersion5x = true;
            }
            this.userCenterOptions.forEach(function (item, i) {
                if (_this3.isShowQuestionnaireUrl && item.label === '问卷') {
                    _this3.userCenterOptions.splice(i, 1);
                }
                if (item.label === '历史账号' && !_this3.isShowLoginHistoryAllowed) {
                    _this3.userCenterOptions[i]['disabled'] = true;
                    if (_this3.params.user_center_alloweds.indexOf('login_history_allowed') === -1) _this3.params.user_center_alloweds.push('login_history_allowed');
                }
            });
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])("sdkReleasesEdit", ["GET_TERMS_LIST"]), {
        compareVersion: function compareVersion(versionA, versionB) {
            if (versionA && versionB) {
                return versionA >= versionB;
            } else {
                return true;
            }
        },
        showNetworkName: function showNetworkName() {
            return this.version >= 7.10 ? '网络监测:' : '网络PING检测:';
        },
        showTwitterShare: function showTwitterShare() {
            return this.version >= 7.12 || this.isVersion5x;
        },
        justifyVersion: function justifyVersion(version) {
            var versionarr = version.split(".");
            var version_convert = '';
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            } else {
                version_convert = version;
            }
            return version_convert;
        },
        handleForumAllowed: function handleForumAllowed(keys) {
            console.log(keys);
        },
        handleCheckAllChange: function handleCheckAllChange(isChecked) {
            this.params.user_center_alloweds = isChecked ? this.userCenterOptions.map(function (item) {
                return item.key;
            }) : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange: function handleCheckedCitiesChange(checkeds) {
            var checkedCount = checkeds.length;
            this.login_buttons_check_all = checkedCount === this.userCenterOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.userCenterOptions.length;
        },
        justifyUrl: function justifyUrl(type, onedomain) {
            var portReg = '';
            if (type == "traceroute") {
                portReg = "(:[0-9]{1,4})?";
            }
            var sRegexHead = "^((https|http|ftp|rtsp|mms)?:?/?/)";
            var sRegex = "(^([0-9]{1,3}\.){3}[0-9]{1,3}" + // IP形式的URL- 199.194.52.184
            "|" + // 允许IP和DOMAIN（域名）
            "([0-9a-z_!~*'()-]+\.)*" + // 域名- www.
            "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." + // 二级域名
            "[a-z]{2,6})" + // first level domain- .com or .museum
            portReg + "$"; // 端口- :80
            console.log(sRegex);

            var matchUrlHead = new RegExp(sRegexHead);
            var matchUrl = new RegExp(sRegex, 'i');

            if (type == "ping") {
                if (onedomain && (!matchUrl.test(onedomain) || matchUrlHead.test(onedomain))) {
                    return false;
                }
            } else if (type == "traceroute") {
                if (onedomain && (!matchUrl.test(onedomain) || matchUrlHead.test(onedomain))) {
                    return false;
                }
            }
            return true;
        },
        handlerNext: function handlerNext() {
            var _this4 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    var params = _this4.$lodash.cloneDeep(_this4.params);
                    if (_this4.version >= 7.10 && _this4.params.ping_stats_collection_allowed) {
                        if (!_this4.params.ping_frequency) {
                            _this4.$message.error("请填写ping频率！");
                            _this4.$refs['ping_frequency'].focus();
                            return false;
                        }
                        if (!_this4.params.ping_count) {
                            _this4.$message.error("请填写ping次数！");
                            _this4.$refs['ping_count'].focus();
                            return false;
                        }
                        if (!_this4.params.ping_domain_list) {
                            _this4.$message.error("请填写ping地址！");
                            _this4.$refs['ping_domain_list'].focus();
                            return false;
                        }
                        if (!_this4.params.trace_route_frequency && _this4.params.trace_route_domain_list) {
                            _this4.$message.error("请填写traceroute频率！");
                            _this4.$refs['trace_route_frequency'].focus();
                            return false;
                        }
                        if (_this4.params.trace_route_frequency && !_this4.params.trace_route_domain_list) {
                            _this4.$message.error("请填写traceroute地址！");
                            _this4.$refs['trace_route_domain_list'].focus();
                            return false;
                        }
                        // ping地址 正则验证
                        if (_this4.params.ping_domain_list) {
                            var ping_domain_array = _this4.params.ping_domain_list.split("\n");
                            console.log(ping_domain_array);
                            for (var i = 0; i < ping_domain_array.length; i++) {
                                var one_item = ping_domain_array[i];
                                var ret = _this4.justifyUrl("ping", one_item);
                                console.log(one_item, ret);
                                if (!ret) {
                                    _this4.$message({
                                        message: '请输入有效的ping地址！',
                                        type: 'error'
                                    });
                                    _this4.$refs['ping_domain_list'].focus();
                                    return false;
                                }
                            }
                        }
                        // traceroute 正则验证
                        if (_this4.params.trace_route_domain_list) {
                            var traceroute_domain_array = _this4.params.trace_route_domain_list.split("\n");
                            console.log(traceroute_domain_array);
                            for (var _i = 0; _i < traceroute_domain_array.length; _i++) {
                                var _one_item = traceroute_domain_array[_i];
                                var _ret = _this4.justifyUrl("traceroute", _one_item);
                                console.log(_one_item, _ret);
                                if (!_ret) {
                                    _this4.$message({
                                        message: '请输入有效的traceroute地址！',
                                        type: 'error'
                                    });
                                    _this4.$refs['trace_route_domain_list'].focus();
                                    return false;
                                }
                            }
                        }
                    } else if (_this4.version < 7.10 && _this4.params.ping_stats_collection_allowed) {
                        if (!_this4.params.ping_count) {
                            _this4.$message.error("请填写ping次数！");
                            _this4.$refs['ping_count'].focus();
                            return false;
                        }
                        if (!_this4.params.ping_domain_list) {
                            _this4.$message.error("请填写ping地址！");
                            _this4.$refs['ping_domain_list'].focus();
                            return false;
                        }
                    }
                    params.ping_domain_list = _this4.params.ping_domain_list.split("\n");
                    params.trace_route_domain_list = _this4.params.trace_route_domain_list ? _this4.params.trace_route_domain_list.split("\n") : [];
                    params.share_url = {};
                    params.share.forEach(function (item) {
                        params.share_url[urlKeys[item]] = params[urlKeys[item]];
                    });
                    params.questionnaire_url = _this4.isShowQuestionnaireUrl ? params.questionnaire_url.replace(/\s*/g, '') : '';
                    if (_this4.isShowQuestionnaireUrl && params.questionnaire_url === '' && params.user_center_alloweds.indexOf('questionnaire') > -1) {
                        params.user_center_alloweds.splice(params.user_center_alloweds.indexOf('questionnaire'), 1);
                    }
                    _this4.$emit('submit', params);
                }
            });
        },
        handleAntiAddictionViewConfig: function handleAntiAddictionViewConfig() {
            this.antiAddictionVisible = true;
        }
    }),
    created: function created() {
        var baseurl = this.$config.apiBaseUrl.split("/");
        this.udp_domain = baseurl[2];
        this.tracerouteHint = "例:\n" + this.udp_domain + "\n" + this.udp_domain + ":443\n119.75.217.109";
        this.operate_type = this.$helper.helper.getParamers("operate_type");
        this.GET_TERMS_LIST();
        this.platform = this.$helper.helper.getParamers("platform");
    }
});

/***/ }),

/***/ "uhd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sdkUpload_vue__ = __webpack_require__("jr9Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b019074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sdkUpload_vue__ = __webpack_require__("SSdj");
function injectStyle (ssrContext) {
  __webpack_require__("3DF/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sdkUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b019074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sdkUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v55N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v6+Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/android-portrait.c11bdbf.png";

/***/ }),

/***/ "vfTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "vhh8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vtgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "wFsZ":
/***/ (function(module, exports) {

/**
 * Created by shiyonggao on 2019/1/22.
 */

/**
 * 项目配置文件
 */

var config = {
    /**用户登陆token**/
    userLoginAccessTokenKey: 'odp5-access-token',
    udcAccessTokenKey: 'oasis-udc-token',
    passportAccessTokenKey: 'oasis-passport-token',
    isDebug: false,

    /**core配置 此三项删除**/
    coreAppId: 255,
    coreUrl: 'https://core.mars-era.cn',
    coreOauthUrl: 'https://oauth-abroad.mars-era.cn',

    /**dev server port**/
    port: 8090,

    /**dev server index page**/
    index: 'index',
    projectTypeRoute1: 'gameConfig/baseInfo',
    projectTypeRoute2: 'watch/line',

    /**dev server auto open browser**/
    autoOpenBrowser: true,

    /**host udc 祁涛提供**/
    baseUrl: 'https://odp.mars.games/',
    apiBaseUrl: 'https://udp6.mars.games/v6',
    udcApiBaseUrl: 'https://udc.mars.games/api/',
    userLogin: 'https://udp6.mars.games/sdk-auth/login',
    userLogoutApi: 'https://udp6.mars.games/sdk-auth/logout',
    userLogout: 'static/logout.html',

    /**pugin**/
    pay_package_url: 'https://package.pay.mars.games/index.html', //支付套餐
    attendenceUrl: 'https://watch.mars.games/plugin/game-clock/mylog', //我的打卡肌瘤
    lineUrl: 'https://watch.mars.games/plugin/three-compared-charts/', //监控曲线图
    alarmPolicyUrl: 'https://watch.mars.games/plugin/game-plans/list', //报警策略配置
    alarmGroupUrl: 'https://watch.mars.games/plugin/notif-groups/list', //报警群组配置


    /**api**/
    api: {
        /**Package管理**/
        package_ajax_game_region_list_url: '/ajaxrela/getgameregionlist',
        package_ajax_game_package_list_url: '/ajaxrela/getpackagenamelist',
        package_ajax_game_store_list_url: '/ajaxrela/getstore',
        package_games_list_url: '/games/{game_code}/packages',
        package_add_package_url: '/games/{game_code}/packages/new',
        package_edit_del_package_url: '/games/{game_code}/packages/{package_id}',
        package_server_list_region_url: '/ajaxrela/getserverlist',

        /**游戏运营**/
        push_ajax_rela_get_game_code_lang_url: '/ajaxrela/getgamecodelang',
        push_games_code_push_topic_group_url: '/games/{game_code}/push-topic-groups',
        push_push_topics_url: '/push-topics',
        push_add_games_code_push_topic_group_url: '/games/{game_code}/push-topic-groups/new',
        push_edit_games_code_push_topic_group_id_url: '/games/{game_code}/push-topic-groups/{topic_group_id}',
        push_add_schedules_url: '/games/{game_code}/push-schedules/new',
        push_schedules_list_url: '/games/{game_code}/push-schedules',
        push_delete_edit_schedules_by_id_url: '/games/{game_code}/push-schedules/{schedule_id}',
        push_plans_news: '/games/{game_code}/pushplans/new',
        push_get_plans_times: 'games/{game_code}/pushplans/times',
        push_get_os_platform_config: '/ajaxrela/getplatformconfig',
        push_get_all_users: '/ajaxrela/getuserlist',
        push_get_plans_detail: '/games/{game_code}/pushplans',
        game_unbind_account: '/ajaxrela/unbind-account',

        /** Anti Addiction **/
        anti_addiction_create_config: '/games/{game_code}/anti_addiction/add',
        anti_addiction_edit_config: '/games/{game_code}/anti_addiction/edit',
        anti_addiction_get_config: '/games/{game_code}/anti_addiction',
        anti_addiction_get_user_info: '/games/{game_code}/anti_addiction_info',

        /***server*/
        serverlist: '/games/{game_code}/servers',
        editServer: '/games/{game_code}/servers/',
        region: '/ajaxrela/getregion',
        batchMerge: '/games/{game_code}/servers/merge',
        batchMaintain: '/games/{game_code}/servers/editmaintain',
        batchDelMaintain: '/games/{game_code}/servers/delmaintain',
        batchOpen: "/games/{game_code}/servers/batchsetopentime",
        batchConfig: "/games/{game_code}/servers/batchsetdatasource",

        system: {
            add_version: '/sdk/{platform}/versions/new',
            get_version_list: '/sdk/{platform}/versions',
            get_version_info: '/sdk/{platform}/versions/{sdk_version_id}',
            remove_version: '/sdk/{platform}/versions/{sdk_version_id}',
            edit_version: '/sdk/{platform}/versions/{sdk_version_id}'
        },
        app: {
            get_game_info: '/games',
            get_ces_token: 'https://udp6.mars.games/sdk-auth/get-ces-token',
            get_game_list: 'https://udp6.mars.games/sdk-auth/get',
            baseinfo: '/games/{game_code}',
            test_reg: '/ajaxrela/registernum',
            test_server: '/ajaxrela/serverlist',
            test_online: '/ajaxrela/onlinenum',
            test_role: '/ajaxrela/userrole',
            check_regionjustify: '/games/{game_code}/regionjustify'
        },

        /**cp参数导出**/
        cpargexport: {
            get: '/games/{game_code}',
            save: '/games/{game_code}',
            get_packages: '/ajaxrela/getpackagenamelist',
            get_store_by_package: '/ajaxrela/getpackagenamestorelist',
            get_sdk_version_by_package_and_channel: '/ajaxrela/getsdkversionbypackagestore',
            get_plan: '/games/{game_code}/plans',
            get_adjust_token: '/games/{game_code}/adjust-tokens'
        },
        /**数据查询**/
        query: {
            on_paid: '/games/{game_code}/order-logs/on-paid',
            on_game_notified: '/games/{game_code}/order-logs/on-game-notified',
            get_user_data: '/games/{game_code}/datasearchUser',
            get_user_relevant_data: '',
            device: '/games/{game_code}/datasearchDevice',
            get_connect: '/ajaxrela/getconnect',
            activity_order_resend_list: '/games/{game_code}/activity-order/list',
            activity_order_resend_one: '/games/{game_code}/activity-reissue',
            activity_order_resend_batch: '/games/{game_code}/activity-reissue/batch',
            activity_order: '/games/{game_code}/activity-order/list',
            sdk_release_record: '/publish-statistics/list',
            package_lists: '/publish-statistics/packages',
            sdk_version_lists: '/publish-statistics/sdk_versions'
        },
        /**活动页面管理**/
        activity_page: {
            list: '/game-act-pages/list',
            add: '/game-act-pages/add',
            edit: '/game-act-pages/edit/{id}'
        },
        plugin: {
            package_token: '/games/{game_code}/get-token/pay'
        }
    },

    /**默认语言**/
    locale: 'zh-CN',

    /**
     * 版本号
     */
    version: 'v2.0.0',
    /**
     * google Analytics measurement id
     */
    measurement_id: 'G-PTS0KRRE9W'
};
module.exports = config;

/***/ }),

/***/ "wUcL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wazR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wlS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_vue__ = __webpack_require__("Y0eg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4700c988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_vue__ = __webpack_require__("FNTj");
function injectStyle (ssrContext) {
  __webpack_require__("SIS3")
  __webpack_require__("J1Q6")
  __webpack_require__("HAIV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_configuration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4700c988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_configuration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wlhV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/customerservice.599080e.png";

/***/ }),

/***/ "wwIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__("wFsZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_config__);



/**
 * Created by shiyonggao on 2019/11/28.
 */



var Cookie = function () {
    function Cookie() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Cookie);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Cookie, [{
        key: "get",

        /**
         * 读取cookie值
         * @param key
         * @param options
         */
        value: function get(key, options) {
            options = options || {};
            var result = void 0,
                decode = options.raw ? function (s) {
                return s;
            } : decodeURIComponent;
            return (result = new RegExp("(?:^|; )" + encodeURIComponent(key) + "=([^;]*)").exec(document.cookie)) ? decode(result[1]) : null;
        }

        /**
         * 删除指定键值所对应的cookie值
         * @param key
         * @param options
         */

    }, {
        key: "remove",
        value: function remove(key, options) {
            this.set(key, null, options || {});
        }

        /**
         * 添加指定名称cookie值 , 过期时间小时制
         * @param key
         * @param value
         * @param options
         */

    }, {
        key: "set",
        value: function set(key, value, options) {
            var domain = __WEBPACK_IMPORTED_MODULE_3__config_config___default.a.baseUrl.replace(/\.*\/$/, "").split(".").slice(-2).join(".");
            console.log(domain);
            options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
                domain: "." + domain,
                path: "/"
            }, options);

            // 删除cookie操作处理
            if (value === null) {
                options.expires = -1;
            }

            // 设置过期时间 单位小时
            if (typeof options.expires === "number") {
                var seconds = options.expires,
                    t = options.expires = new Date();
                t.setTime(t.getTime() + seconds * 1000 * 60 * 60);
            }

            // 强制转换为字符串格式
            value = "" + value;

            // 设置cookie信息
            return document.cookie = [encodeURIComponent(key), "=", options.raw ? value : encodeURIComponent(value), options.expires ? "; expires=" + options.expires.toUTCString() : "", options.path ? "; path=" + options.path : "", options.domain ? "; domain=" + options.domain : "", options.secure ? "; secure" : ""].join("");
        }
    }]);

    return Cookie;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Cookie());

/***/ }),

/***/ "x/+b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIyZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xoEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
  getLoginHistoryList: function getLoginHistoryList(_ref, params) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    var gameCode = rootState.$helper.helper.getGameCode().game_code;
    return rootState.$helper.request.get("/games/" + gameCode + "/login-history-list", params, function (res) {
      return true;
    });
  }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "xoU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);



/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    updateAntiAddictionConfig: function updateAntiAddictionConfig(_ref, data) {
        var rootState = _ref.rootState;

        var URL = rootState.$config.api[data.is_edit ? 'anti_addiction_edit_config' : 'anti_addiction_create_config'];
        var params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["cloneDeep"])(data.params);
        console.log("result");
        console.log(data);
        console.log(params);

        params.identified_user_rules.forEach(function (item, i) {
            item.login_rule.holiday = {};
            item.login_rule.work_day_normal = {};
            item.login_rule.work_day_special = {};

            data.params.identified_user_rules[i].login_rule.holiday.rules.forEach(function (keys) {
                if (keys.date_type && keys.date_type === 1) {
                    item.login_rule.holiday.daily_max_game_minutes = keys.daily_max_game_time;
                } else if (keys.date_type && keys.date_type === 2) {
                    if (Array.isArray(item.login_rule.holiday.forbidden_game_minutes_periods)) {
                        item.login_rule.holiday.forbidden_game_minutes_periods.push([keys.start_time, keys.end_time]);
                    } else {
                        item.login_rule.holiday.forbidden_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                } else if (keys.date_type && keys.date_type === 3) {
                    if (Array.isArray(item.login_rule.holiday.allow_game_minutes_periods)) {
                        item.login_rule.holiday.allow_game_minutes_periods.push([keys.start_time, keys.end_time]);
                    } else {
                        item.login_rule.holiday.allow_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                }
            });
            delete item.login_rule.holiday.changeTimeOptions;
            delete item.login_rule.holiday.rules;

            data.params.identified_user_rules[i].login_rule.work_day_normal.rules.forEach(function (keys) {
                if (keys.date_type && keys.date_type === 1) {
                    item.login_rule.work_day_normal.daily_max_game_minutes = keys.daily_max_game_time;
                } else if (keys.date_type && keys.date_type === 2) {
                    if (Array.isArray(item.login_rule.work_day_normal.forbidden_game_minutes_periods)) {
                        item.login_rule.work_day_normal.forbidden_game_minutes_periods.push([keys.start_time, keys.end_time]);
                    } else {
                        item.login_rule.work_day_normal.forbidden_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                } else if (keys.date_type && keys.date_type === 3) {
                    if (Array.isArray(item.login_rule.work_day_normal.allow_game_minutes_periods)) {
                        item.login_rule.work_day_normal.allow_game_minutes_periods.push([keys.start_time, keys.end_time]);
                    } else {
                        item.login_rule.work_day_normal.allow_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                }
            });
            delete item.login_rule.work_day_normal.changeTimeOptions;
            delete item.login_rule.work_day_normal.rules;

            data.params.identified_user_rules[i].login_rule.work_day_special.rules.forEach(function (keys) {
                if (keys.date_type && keys.date_type === 1) {
                    item.login_rule.work_day_special.daily_max_game_minutes = keys.daily_max_game_time;
                } else if (keys.date_type && keys.date_type === 2) {
                    if (Array.isArray(item.login_rule.work_day_special.forbidden_game_minutes_periods)) {
                        item.login_rule.work_day_special.forbidden_game_minutes_periods.push([keys.start_time, keys.end_time]);
                    } else {
                        item.login_rule.work_day_special.forbidden_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                } else if (keys.date_type && keys.date_type === 3) {
                    if (Array.isArray(item.login_rule.work_day_special.allow_game_minutes_periods)) {
                        item.login_rule.work_day_special.allow_game_minutes_periods.push([keys.start_time, keys.end_time]);
                    } else {
                        item.login_rule.work_day_special.allow_game_minutes_periods = [[keys.start_time, keys.end_time]];
                    }
                }
            });
            delete item.login_rule.work_day_special.changeTimeOptions;
            delete item.login_rule.work_day_special.rules;
        });
        console.log(params);

        return rootState.$helper.request.post(URL, { fields: params }).then(function (res) {
            return res;
        });
    },
    getAntiAddictionConfig: function getAntiAddictionConfig(_ref2) {
        var rootState = _ref2.rootState;

        var URL = rootState.$config.api.anti_addiction_get_config;
        return rootState.$helper.request.get(URL).then(function (res) {
            return res.data;
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "xtGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "select-server",
    props: ["servers", "selected", "values", "multiple", "disable"],
    data: function data() {
        return {
            serverIds: [],
            disableds: false
        };
    },

    methods: {
        change: function change() {
            this.selected(this.serverIds);
        }
    },

    watch: {
        disable: function disable(val) {
            this.disableds = val;
        }
    },

    mounted: function mounted() {
        this.serverIds = this.values > 0 ? this.values : "";
        if (this.disable !== undefined) {
            this.disableds = this.disable;
        }
        if (this.serverIds.length > 0) this.selected(this.serverIds);
    }
});

/***/ }),

/***/ "y42g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aside_vue__ = __webpack_require__("VKDt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8e6ac92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aside_vue__ = __webpack_require__("Kapi");
function injectStyle (ssrContext) {
  __webpack_require__("/2eX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8e6ac92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y4Cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    iosConfigList: [],
    androidConfigList: [],
    h5ConfigList: [],
    windowsConfigList: [],
    iosPackageList: [],
    androidPackageList: [],
    h5PackageList: [],
    windowsPackageList: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_TOKEN_LIST: function GET_TOKEN_LIST(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/adjust-tokens', { platform: args.platform }).then(function (res) {
            data = res.data.tokens;
            for (var i in data) {
                if (data[i]['token_type'] === 0) {
                    data[i]['token_type_name'] = 'Adjust Token';
                } else if (data[i]['token_type'] === 1) {
                    data[i]['token_type_name'] = 'Admob Token';
                } else if (data[i]['token_type'] === 2) {
                    data[i]['token_type_name'] = 'Google Ads';
                } else if (data[i]['token_type'] === 3) {
                    data[i]['token_type_name'] = 'Applovin Token';
                }
            }
            if (args.platform === 'IOS') {
                commit('_iosConfigList', data);
            } else if (args.platform === 'H5') {
                commit('_h5ConfigList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsConfigList', data);
            } else {
                commit('_androidCongfigList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    PUT_TOKEN_EDIT: function PUT_TOKEN_EDIT(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        commit('PRIVATE_LOADING', true, { root: true });
        rootState.$helper.request.put('/games/' + gameCode + '/adjust-tokens/' + args.token_id, args).then(function (res) {
            data = res.data.edited;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '编辑成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/adjusttoken', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '编辑失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/adjusttoken');
                    }
                }, {
                    root: true
                });
            }
            commit('PRIVATE_LOADING', false, { root: true });
        }).catch(function (error) {
            commit('PRIVATE_LOADING', false, { root: true });
            var message = '操作失败！';
            if (error['response'] && error['response']['data'] && error['response']['data']['exception'] && error['response']['data']['exception']['message']) {
                message = error['response']['data']['exception']['message'];
            }
            dispatch('ALERT_HANDLE', { message: message, reload: true }, { root: true });
        });
    },
    PUT_TOKEN_NEW: function PUT_TOKEN_NEW(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        commit('PRIVATE_LOADING', true, { root: true });
        rootState.$helper.request.put('/games/' + gameCode + '/adjust-tokens/newbatch', { adjust_arg: args }).then(function (res) {
            data = res.data.batchadd[0]['created'];
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '添加成功!',
                    callback: function callback() {
                        /*
                        dispatch('GET_TOKEN_LIST', {
                            platform: data.platform
                        });
                        */
                        rootState.$helper.helper.route('sdk/adjusttoken', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '添加失败!',
                    callback: function callback() {
                        dispatch('GET_TOKEN_LIST', { platform: data.platform.toUpperCase() });
                    }
                }, { root: true });
            }
            commit('PRIVATE_LOADING', false, { root: true });
        }).catch(function (error) {
            commit('PRIVATE_LOADING', false, { root: true });
            var message = '操作失败！';
            if (error['response'] && error['response']['data'] && error['response']['data']['exception'] && error['response']['data']['exception']['message']) {
                message = error['response']['data']['exception']['message'];
            }
            dispatch('ALERT_HANDLE', { message: message, reload: true }, { root: true });
        });
    },
    GET_PACKAGE_LIST: function GET_PACKAGE_LIST(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenamelist', {
            game_code: gameCode,
            platform: args.platform
        }).then(function (res) {
            data = res.data.result;
            if (args.platform === 'IOS') {
                commit('_iosPackageList', data);
            } else if (args.platform === 'H5') {
                commit('_h5PackageList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsPackageList', data);
            } else {
                commit('_androidPackageList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    TOKEN_ENABLED: function TOKEN_ENABLED(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.put('/games/' + gameCode + '/adjust-tokens/' + args.token_id, {
            enabled: args.enabled
        }).then(function (res) {
            data = res.data.result;
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    DELETE_ROW: function DELETE_ROW(_ref6, args) {
        var state = _ref6.state,
            commit = _ref6.commit,
            dispatch = _ref6.dispatch,
            rootState = _ref6.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.delete('/games/' + gameCode + '/adjust-tokens/' + args.token_id, { platform: args.platform }).then(function (res) {
            data = res.data.deleted;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '删除成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/adjusttoken', { platform: args.platform });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '删除失败!',
                    callback: function callback() {
                        dispatch('GET_TOKEN_LIST', { platform: args.platform });
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _iosConfigList: function _iosConfigList(state, args) {
        state.iosConfigList = args;
        console.log('_iosConfigList=', state.iosConfigList);
    },
    _androidCongfigList: function _androidCongfigList(state, args) {
        state.androidConfigList = args;
        console.log('_androidCongfigList=', state.androidConfigList);
    },
    _h5ConfigList: function _h5ConfigList(state, args) {
        state.h5ConfigList = args;
        console.log('_h5CongfigList=', state.h5ConfigList);
    },
    _windowsConfigList: function _windowsConfigList(state, args) {
        state.windowsConfigList = args;
        console.log('_windowsCongfigList=', state.windowsConfigList);
    },
    _iosPackageList: function _iosPackageList(state, args) {
        state.iosPackageList = args;
        console.log('_iosPackageList=', state.iosPackageList);
    },
    _androidPackageList: function _androidPackageList(state, args) {
        state.androidPackageList = args;
        console.log('_androidPackageList=', state.androidPackageList);
    },
    _h5PackageList: function _h5PackageList(state, args) {
        state.h5PackageList = args;
        console.log('_h5PackageList=', state.h5PackageList);
    },
    _windowsPackageList: function _windowsPackageList(state, args) {
        state.windowsPackageList = args;
        console.log('_windowsPackageList=', state.windowsPackageList);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "y6Tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetLoginAllowed_vue__ = __webpack_require__("SLxa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_829f7df6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetLoginAllowed_vue__ = __webpack_require__("fEwg");
function injectStyle (ssrContext) {
  __webpack_require__("EYzl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-829f7df6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetLoginAllowed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_829f7df6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_my_custom_element_attribute_to_transform_to_require_another_attribute_to_transform_to_require_attribute_to_transform_to_require_another_attribute_to_transform_to_require_lego_lp_hnav_icon_background_image_rotating_button_background_image_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetLoginAllowed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yCC1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    data: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    getLoginBanData: function getLoginBanData(_ref, params) {
        var commit = _ref.commit,
            rootState = _ref.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get('/games/' + gameCode + '/login-blacklists', params, function (res) {
            return true;
        });
    },
    createdLoginBan: function createdLoginBan(_ref2, params) {
        var commit = _ref2.commit,
            rootState = _ref2.rootState;

        return rootState.$helper.request.post('/games/{game_code}/login-blacklist/new', params);
    },
    editLoginBan: function editLoginBan(_ref3, params) {
        var commit = _ref3.commit,
            rootState = _ref3.rootState;

        return rootState.$helper.request.put('/games/{game_code}/login-blacklist/edit', params, function (res) {
            return true;
        });
    },
    deleteLoginBan: function deleteLoginBan(_ref4, params) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        return rootState.$helper.request.delete('/games/{game_code}/login-blacklist/delete', params, function (res) {
            return true;
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    changeData: function changeData(state, data) {
        state.data = data;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "zH1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
var state = {
    iosConfigList: [],
    androidConfigList: [],
    h5ConfigList: [],
    windowsConfigList: [],
    sdkVersion: [],
    iosSdkVersion: [],
    androidSdkVersion: [],
    h5SdkVersion: [],
    windowsSdkVersion: [],
    iosPackageList: [],
    androidPackageList: [],
    h5PackageList: [],
    windowsPackageList: [],
    iosGameVersion: [],
    androidGameVersion: [],
    h5GameVersion: [],
    windowsGameVersion: []
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
var actions = {
    GET_SDK_VERSION: function GET_SDK_VERSION(_ref, args) {
        var state = _ref.state,
            commit = _ref.commit,
            dispatch = _ref.dispatch,
            rootState = _ref.rootState;

        var data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {}).then(function (res) {
            data = res.data.sdk_versions;
            if (args.platform === 'IOS') {
                commit('_iosSdkVersion', data);
            } else if (args.platform === 'H5') {
                commit('_h5SdkVersion', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsSdkVersion', data);
            } else {
                commit('_androidSdkVersion', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_GAME_VERSION: function GET_GAME_VERSION(_ref2, args) {
        var state = _ref2.state,
            commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootState = _ref2.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getgameversion', { game_code: gameCode }).then(function (res) {
            data = res.data.result;
            if (args.platform === 'IOS') {
                commit('_iosGameVersion', data);
            } else if (args.platform === 'H5') {
                commit('_h5GameVersion', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsGameVersion', data);
            } else {
                commit('_androidGameVersion', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_PACKAGE_LIST: function GET_PACKAGE_LIST(_ref3, args) {
        var state = _ref3.state,
            commit = _ref3.commit,
            dispatch = _ref3.dispatch,
            rootState = _ref3.rootState;

        var data = [];
        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenameregionlist', {
            game_code: gameCode,
            platform: args.platform
        }).then(function (res) {
            data = res.data.result;
            if (args.platform === 'IOS') {
                commit('_iosPackageList', data);
            } else if (args.platform === 'H5') {
                commit('_h5PackageList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsPackageList', data);
            } else {
                commit('_androidPackageList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    GET_CONFIG_LIST: function GET_CONFIG_LIST(_ref4, args) {
        var state = _ref4.state,
            commit = _ref4.commit,
            dispatch = _ref4.dispatch,
            rootState = _ref4.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/releases', {
            platform: args.platform,
            package_id: args.package_id,
            sdk_version: args.sdk_version,
            game_version: args.game_version
        }).then(function (res) {
            data = res.data.releases;
            if (args.platform === 'IOS') {
                commit('_iosConfigList', data);
            } else if (args.platform === 'H5') {
                commit('_h5ConfigList', data);
            } else if (args.platform === 'WINDOWS') {
                commit('_windowsConfigList', data);
            } else {
                commit('_androidCongfigList', data);
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    },
    DELETE_ROW: function DELETE_ROW(_ref5, args) {
        var state = _ref5.state,
            commit = _ref5.commit,
            dispatch = _ref5.dispatch,
            rootState = _ref5.rootState;

        var gameCode = rootState.$helper.helper.getGameCode().game_code;
        var data = [];
        rootState.$helper.request.delete('/games/' + gameCode + '/releases/' + args.release_id, { platform: args.platform }).then(function (res) {
            data = res.data.deleted;
            if (data) {
                dispatch('ALERT_HANDLE', {
                    message: '删除成功!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/releaseslist', { platform: args.platform });
                    }
                }, { root: true });
            } else {
                dispatch('ALERT_HANDLE', {
                    message: '删除失败!',
                    callback: function callback() {
                        rootState.$helper.helper.route('sdk/releaseslist');
                    }
                }, { root: true });
            }
        }).catch(function (res) {
            dispatch('ERROR_HANDLE', res, { root: true });
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
var getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
var mutations = {
    _iosConfigList: function _iosConfigList(state, args) {
        state.iosConfigList = args;
        console.log('_iosConfigList=', state.iosConfigList);
    },
    _androidCongfigList: function _androidCongfigList(state, args) {
        state.androidConfigList = args;
        console.log('_androidCongfigList=', state.androidConfigList);
    },
    _h5ConfigList: function _h5ConfigList(state, args) {
        state.h5ConfigList = args;
        console.log('_h5CongfigList=', state.h5ConfigList);
    },
    _windowsConfigList: function _windowsConfigList(state, args) {
        state.windowsConfigList = args;
        console.log('_windowsCongfigList=', state.windowsConfigList);
    },
    _iosSdkVersion: function _iosSdkVersion(state, args) {
        state.iosSdkVersion = args;
        console.log('_iosSdkVersion=', state.iosSdkVersion);
    },
    _androidSdkVersion: function _androidSdkVersion(state, args) {
        state.androidSdkVersion = args;
        console.log('_androidSdkVersion=', state.androidSdkVersion);
    },
    _h5SdkVersion: function _h5SdkVersion(state, args) {
        state.h5SdkVersion = args;
        console.log('_h5SdkVersion=', state.h5SdkVersion);
    },
    _windowsSdkVersion: function _windowsSdkVersion(state, args) {
        state.windowsSdkVersion = args;
        console.log('_windowsSdkVersion=', state.windowsSdkVersion);
    },
    _iosGameVersion: function _iosGameVersion(state, args) {
        state.iosGameVersion = args;
        console.log('_iosGameVersion=', state.iosGameVersion);
    },
    _androidGameVersion: function _androidGameVersion(state, args) {
        state.androidGameVersion = args;
        console.log('_androidGameVersion=', state.androidGameVersion);
    },
    _h5GameVersion: function _h5GameVersion(state, args) {
        state.h5GameVersion = args;
        console.log('_h5GameVersion=', state.h5GameVersion);
    },
    _windowsGameVersion: function _windowsGameVersion(state, args) {
        state.windowsGameVersion = args;
        console.log('_windowsGameVersion=', state.windowsGameVersion);
    },
    _iosPackageList: function _iosPackageList(state, args) {
        state.iosPackageList = args;
        console.log('_iosPackageList=', state.iosPackageList);
    },
    _androidPackageList: function _androidPackageList(state, args) {
        state.androidPackageList = args;
        console.log('_androidPackageList=', state.androidPackageList);
    },
    _h5PackageList: function _h5PackageList(state, args) {
        state.h5PackageList = args;
        console.log('_h5PackageList=', state.h5PackageList);
    },
    _windowsPackageList: function _windowsPackageList(state, args) {
        state.windowsPackageList = args;
        console.log('_windowsPackageList=', state.windowsPackageList);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ "zfo0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/background_color_of_content.d324312.jpeg";

/***/ })

});


// WEBPACK FOOTER //
// js/commons.c634421.js